module.exports = {
  //ACTUACIÓN "SUMARIO POR OFICIO"
 "oficio": {
  "preUbicacion": {
    "calle": "Avenida Siempreviva",
    "coordinates": {
      "lat": -31.542287711530214,
      "lng": -68.53799328752244
    },
    "departamento": {
      "id": "7164a28a-ce2d-11e4-a042-0090f58f4f32",
      "nombre": "9 DE JULIO"
    },
    "numero": "742"
  },
  "denuncia": [
    {
      "name": "InputNestor"
    }
  ],
  "denunciaText": "Relato de Prueba para V2",
  "causaNumero": "123456",
  "modusOperandi": {
    "TipomodusoperandiID": "417195bf-a3c5-11ec-816d-16c2a030bb97",
    "Nombre": "ARROJO PIEDRA"
  },
  "listaCaratulas": [
    {
      "TipocausacaratulaID": "2771bc5b-a3ca-11ec-816d-16c2a030bb97",
      "Nombre": "ABUSO DE ARMA",
      "TipoCaratula": "Causa Caratula"
    },
    {
      "TipocausacaratulaID": "2a5c76f3-a3ca-11ec-816d-16c2a030bb97",
      "Nombre": "ACT.PARA ESTABLECER PARADERO",
      "TipoCaratula": "Causa Caratula"
    },
    {
      "TipocausacaratulaID": "2b6ff555-a3ca-11ec-816d-16c2a030bb97",
      "Nombre": "ACT.POR FALLECIMIENTO",
      "TipoCaratula": "Causa Caratula"
    }
  ],
  "causaJuzgado": {
    "JuzgadoID": "3783ba3f-9d62-11ec-816d-16c2a030bb97",
    "Fechainivig": "2022-03-06 15:29:30",
    "Nombre": "3ER JUZGADO DE FALTAS"
  },
  "id": "76465033-c0c4-11f0-8e0d-0242ac140005",
  "deposition": "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  "formType": "oficio",
  "dependencia": "SUB COMISARIA  E3",
  "Sitio": {
    "TipoSitioID": "tipo-sitio-id-0001"
  },
  "effectsType": "empty",
  "PersonalInterviniente": [
    {
      "nombre": "Cosme Fulanito",
      "jerarquia": {
        "id": "4",
        "nombre": "Sargento"
      },
      "dependencia": "Ptp Policial Tamberias Calingasta"
    },
    {
      "nombre": "Max Power",
      "jerarquia": {
        "id": "1",
        "nombre": "Agente"
      },
      "dependencia": "Comisaria 16ta Calingasta"
    }
  ],
  "textEditsCounter": {
    "Preform": 0,
    "Contravener": 0,
    "instructionDecree": 0
  },
  "acusados": {
    "list": [
      {
        "arrId": "b0e013b9-1ffd-497a-a744-c4e35fa01601",
        "doc": {
          "instruccion": {
            "id": "sabe_leer_sabe_firmar",
            "nombre": "Sabe leer y sabe firmar"
          },
          "email": "helloworld@gmail.com",
          "nacionalidad": {
            "id": 1,
            "nombre": "ARGENTINA"
          },
          "tipoDocumento": {
            "id": "DNI",
            "nombre": "DNI"
          },
          "condicion": {
            "id": "Acusado",
            "nombre": "Acusado"
          },
          "arrId": "b0e013b9-1ffd-497a-a744-c4e35fa01601"
        },
        "identikit": [
          {
            "question": "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
            "questionNumber": 1,
            "answer": "Respuesta P.1: Vestía una bincha informal de color amarillo, una blusa mangas largas formal de color azul, "
          },
          {
            "question": "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
            "questionNumber": 2,
            "answer": "Respuesta P.2: Tenía cabello rapado ondulado de color castaño "
          },
          {
            "question": "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
            "questionNumber": 3,
            "answer": "Respuesta P.3: Una persona de sexo masculino de estatura baja,  delgado, estatura aproximada de 110 cm "
          }
        ],
        "identikitQuestion": 3,
        "type": "doc",
        "conocido": true,
        "hasIdentikit": true,
        "sipeSearch": false,
        "filiacionDesconocida": true
      },
      {
        "arrId": "c1ced7f2-edde-4dec-83c7-f97704a8772f",
        "doc": {
          "instruccion": {
            "id": "sabe_leer_sabe_firmar",
            "nombre": "Sabe leer y sabe firmar"
          },
          "email": "helloworld@gmail.com",
          "nacionalidad": {
            "id": 1,
            "nombre": "ARGENTINA"
          },
          "tipoDocumento": {
            "id": "DNI",
            "nombre": "DNI"
          }
        },
        "identikit": [
          {
            "answer": "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
            "question": "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
            "questionNumber": 1
          },
          {
            "answer": "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
            "question": "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
            "questionNumber": 2
          },
          {
            "answer": "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
            "question": "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
            "questionNumber": 3
          },
          {
            "answer": "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
            "question": "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
            "questionNumber": 4
          },
          {
            "answer": "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
            "question": "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
            "questionNumber": 5
          },
          {
            "answer": "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
            "question": "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
            "questionNumber": 6
          }
        ],
        "identikitQuestion": 1,
        "type": "empty",
        "conocido": true,
        "hasIdentikit": false,
        "emptyTitle": "Nuevo vinculado"
      }
    ]
  },
  "robados": {
    "list": [
      {
        "arrId": "7192952f-8a6b-4f89-a824-dc18b6713b43",
        "doc": {
          "tipoEfecto": {
            "id": "Recuperado",
            "nombre": "Recuperado"
          },
          "arrId": "7192952f-8a6b-4f89-a824-dc18b6713b43",
          "CategoriaID": "1",
          "SubcategoriaID": "2d532f6b-b685-11ec-8878-16c2a030bb97",
          "TipoID": "8fd03587-dfb4-11ed-9f23-0242ac120004",
          "MarcaID": "06344cd6-cc77-11ec-acbc-16c2a030bb97",
          "ModeloID": "150cbaa4-c24f-11ec-8878-16c2a030bb97",
          "Anio": "2023",
          "Chasis": "156",
          "NumeroMotor": "1589798",
          "Dominio": "asd123",
          "NumeroSerie": "2235",
          "Imei": "159489159",
          "Abonado": "365",
          "Color": "Gris"
        },
        "type": "doc",
        "conocido": true,
        "hasIdentikit": false
      },
      {
        "arrId": "6c445767-6a60-4617-900f-dd776bfb1fee",
        "doc": {
          "newFormatEffect": true,
          "tipoEfecto": {
            "id": "Secuestrado",
            "nombre": "Secuestrado"
          }
        },
        "type": "empty",
        "conocido": true,
        "hasIdentikit": false
      }
    ]
  },
  "denunciante": {
    "list": [
      {
        "arrId": "ba790af5-3a5f-41a1-9598-e06b9c0c5e84",
        "doc": {
          "personaJuridica": false,
          "condicion": {
            "id": "Damnificado",
            "nombre": "Damnificado"
          },
          "documento": "12345",
          "tipoDocumento": {
            "id": "DNI",
            "nombre": "DNI"
          },
          "sexo": {
            "id": "F",
            "nombre": "Femenino"
          },
          "exhibeDocumento": {
            "id": 1,
            "nombre": "Sí"
          },
          "instruccion": {
            "id": "sabe_leer_sabe_firmar",
            "nombre": "Sabe leer y sabe firmar"
          },
          "apellido": "MUZZUPAPPA",
          "nombre": "Pilar A",
          "nacionalidad": {
            "id": 1,
            "nombre": "ARGENTINA"
          },
          "fechaNacimiento": "07-02-1915",
          "edad": "12",
          "estadoCivil": {
            "id": "2",
            "nombre": "Casado/a"
          },
          "telefono": "333",
          "profesion": "123123123",
          "domicilio": "123123123",
          "domicilioSIPE": " ,  CP: - , , ",
          "email": "helloworld@gmail.com",
          "tieneSeguro": false,
          "tieneEstudios": {
            "id": 1,
            "nombre": "Sí"
          },
          "cuil": "123123123",
          "arrId": "ba790af5-3a5f-41a1-9598-e06b9c0c5e84"
        },
        "type": "doc",
        "ordenPublico": false,
        "emptyTitle": "Nuevo denunciante y/o damnificado/a",
        "cuil": "20-00001234-4",
        "sipeSearch": true
      },
      {
        "arrId": "58eea3c9-2772-43de-9892-feddf565156d",
        "doc": {
          "instruccion": {
            "id": "sabe_leer_sabe_firmar",
            "nombre": "Sabe leer y sabe firmar"
          },
          "email": "helloworld@gmail.com",
          "nacionalidad": {
            "id": 1,
            "nombre": "ARGENTINA"
          },
          "condicion": {
            "id": "Damnificado",
            "nombre": "Damnificado"
          },
          "tipoDocumento": {
            "id": "DNI",
            "nombre": "DNI"
          }
        },
        "type": "empty",
        "ordenPublico": false,
        "emptyTitle": "Nuevo Afectado"
      }
    ],
    "emptyDoc": {
      "instruccion": {
        "id": "sabe_leer_sabe_firmar",
        "nombre": "Sabe leer y sabe firmar"
      },
      "nacionalidad": {
        "id": 1,
        "nombre": "ARGENTINA"
      },
      "condicion": {
        "id": "Damnificado",
        "nombre": "Damnificado"
      },
      "tipoDocumento": {
        "id": "DNI",
        "nombre": "DNI"
      },
      "exhibeDocumento": {
        "id": 1,
        "nombre": "Sí"
      },
      "tieneEstudios": {
        "id": 1,
        "nombre": "Sí"
      }
    }
  },
  "afectacionPatrimonial": {
    "list": [
      {
        "arrId": "28e62944-31d2-498c-9de9-857d29449822",
        "doc": {
          "newFormatEffect": true
        },
        "type": "empty"
      }
    ]
  },
  "idDependencia": "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
  "idUser": "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
  "sumarioEstado": "En Curso",
  "detenidos": {
    "list": [
      {
        "arrId": "b66a12d0-2f9c-4e60-89f6-c727f5145521",
        "doc": {
          "instruccion": {
            "id": "sabe_leer_sabe_firmar",
            "nombre": "Sabe leer y sabe firmar"
          },
          "email": "helloworld@gmail.com",
          "nacionalidad": {
            "id": 1,
            "nombre": "ARGENTINA"
          },
          "tipoDocumento": {
            "id": "DNI",
            "nombre": "DNI"
          },
          "arrId": "b66a12d0-2f9c-4e60-89f6-c727f5145521",
          "condicion": {
            "id": "Acusado",
            "nombre": "Acusado"
          }
        },
        "identikit": [
          {
            "answer": "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
            "question": "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
            "questionNumber": 1
          },
          {
            "answer": "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
            "question": "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
            "questionNumber": 2
          },
          {
            "answer": "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
            "question": "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
            "questionNumber": 3
          },
          {
            "answer": "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
            "question": "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
            "questionNumber": 4
          },
          {
            "answer": "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
            "question": "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
            "questionNumber": 5
          },
          {
            "answer": "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
            "question": "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
            "questionNumber": 6
          }
        ],
        "identikitQuestion": 1,
        "type": "doc",
        "conocido": true,
        "hasIdentikit": false,
        "sipeSearch": false,
        "emptyTitle": "Nuevo contraventor/a",
        "filiacionDesconocida": true
      },
      {
        "arrId": "1e01be2b-7a3b-42d8-99eb-31694d78a1af",
        "doc": {
          "instruccion": {
            "id": "sabe_leer_sabe_firmar",
            "nombre": "Sabe leer y sabe firmar"
          },
          "email": "helloworld@hotmail.com",
          "nacionalidad": {
            "id": 1,
            "nombre": "ARGENTINA"
          },
          "tipoDocumento": {
            "id": "DNI",
            "nombre": "DNI"
          },
          "estadoCivil": {
            "id": "4",
            "nombre": "Divorciado/a"
          },
          "arrId": "1e01be2b-7a3b-42d8-99eb-31694d78a1af",
          "documento": "123456",
          "sexo": {
            "id": "F",
            "nombre": "Femenino"
          },
          "nombre": "Romina Sabrina",
          "apellido": "GAJERO",
          "fechaNacimiento": "00-00-0000",
          "domicilioSIPE": " ,  CP: - , , ",
          "apodo": "la ladronsuela",
          "telefono": "444",
          "condicion": {
            "id": "Detenido",
            "nombre": "Detenido"
          }
        },
        "identikit": [
          {
            "answer": "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
            "question": "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
            "questionNumber": 1
          },
          {
            "answer": "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
            "question": "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
            "questionNumber": 2
          },
          {
            "answer": "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
            "question": "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
            "questionNumber": 3
          },
          {
            "answer": "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
            "question": "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
            "questionNumber": 4
          },
          {
            "answer": "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
            "question": "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
            "questionNumber": 5
          },
          {
            "answer": "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
            "question": "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
            "questionNumber": 6
          }
        ],
        "identikitQuestion": 1,
        "type": "doc",
        "conocido": true,
        "hasIdentikit": false,
        "emptyTitle": "Nuevo contraventor/a",
        "sipeSearch": true
      },
      {
        "arrId": "773f0cb2-3b79-4063-99c7-efceb1a8ca8b",
        "doc": {
          "instruccion": {
            "id": "sabe_leer_sabe_firmar",
            "nombre": "Sabe leer y sabe firmar"
          },
          "email": "helloworld@gmail.com",
          "nacionalidad": {
            "id": 1,
            "nombre": "ARGENTINA"
          },
          "tipoDocumento": {
            "id": "DNI",
            "nombre": "DNI"
          }
        },
        "identikit": [
          {
            "answer": "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
            "question": "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
            "questionNumber": 1
          },
          {
            "answer": "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
            "question": "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
            "questionNumber": 2
          },
          {
            "answer": "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
            "question": "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
            "questionNumber": 3
          },
          {
            "answer": "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
            "question": "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
            "questionNumber": 4
          },
          {
            "answer": "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
            "question": "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
            "questionNumber": 5
          },
          {
            "answer": "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
            "question": "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
            "questionNumber": 6
          }
        ],
        "identikitQuestion": 1,
        "type": "empty",
        "conocido": true,
        "hasIdentikit": false,
        "emptyTitle": "Nuevo contraventor/a"
      }
    ]
  },
  "actaInicio": "--- En la provincia de San Juan, RAWSON,  local de SUB COMISARIA  E3a los 13 días del mes de Noviembre del año Dos Mil Veinticinco, siendo las 15:59 horasel Funcionario de Policía que suscribe, Jefe Titular de esta Dependencia, con intervención del Secretario de Actuaciones que Refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada, se hace presente Sargento Cosme Fulanito adscripto/s al numerario de Ptp Policial Tamberias Calingasta y Agente Max Power adscripto/s al numerario de Comisaria 16ta Calingasta, informando que Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.. undefined",
  "preMoment": {
    "date": new Date("2025-11-13T19:10:48.821Z"),
    "date2": new Date("2025-11-13T19:10:48.821Z")
  }
},

  //ACTUACIÓN "EXPEDIENTE CONTRAVENCIONAL POR OFICIO"
  "contravencional-oficio": {
    denunciantesBD: [],
    ubicacion: "",
    preUbicacion: {
      calle: "Avenida Siempreviva",
      numero: "742",
      coordinates: { lat: -31.542287711530214, lng: -68.53799328752244 },
    },
    moment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    preMoment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    estadoCivil: {},
    residencia: {},
    denuncia: [{ name: "InputNestor", value: "" }],
    fechaDenuncia: new Date(),
    fechaCertificadoDenuncia: null,
    denunciaText: "Relato de Prueba para V2",
    causaNumero: "123456",
    modusOperandi: null,
    causaCaratula: null,
    listaArticulos: [
      {
        ArticulosID: "0bfcf202-b5f7-11ec-8878-16c2a030bb97",
        Numeroarticulo: "108° Discriminación ",
        Codigo: "Ley N° 941-R",
      },
      {
        ArticulosID: "12110411-9d53-11ec-816d-16c2a030bb97",
        Numeroarticulo: "134º Estado de ebriedad",
        Codigo: "Ley Nº 941-R",
      },
      {
        ArticulosID: "0afc85b7-b60f-11ec-8878-16c2a030bb97",
        Numeroarticulo: "98° Inobservancia de disposiciones legales",
        Codigo: "LEY N°  941-R ",
      },
    ],
    causaJuzgado: {
      JuzgadoID: "184802fa-cc9a-11e4-8df1-0090f58f4f32",
      Fechainivig: "2021-12-23 00:00:00",
      Fechafinvig: null,
      Nombre: "4TO JUZGADO EN LO CORRECCIONAL",
      Telefono: null,
      Domicilio: null,
    },
    id: null,
    saveStatus: "new",
    timer: false,
    isSaving: false,
    type: null,
    deposition:
      "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FIN",
    formType: "contravencional-oficio",
    dependencia: "SUB COMISARIA  E3",
    PersonalInterviniente: [
      {
        nombre: "Cosme Fulanito",
        jerarquia: { id: "4", nombre: "Sargento" },
        dependencia: "Ptp Policial Tamberias Calingasta",
      },
      {
        nombre: "Max Power",
        jerarquia: { id: "1", nombre: "Agente" },
        dependencia: "Comisaria 16ta Calingasta",
      },
    ],
    textEditsCounter: { Preform: 0, Contravener: 0, Postform: "", LegalData: "" },
    textEstaticos: { Preform: "", Contravener: "", Postform: "", LegalData: "" },
    spinnerOrderTablePrintFrom: false,
    acusados: {
      list: [
        {
          arrId: "b66a12d0-2f9c-4e60-89f6-c727f5145521",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            arrId: "b66a12d0-2f9c-4e60-89f6-c727f5145521",
            condicion: { id: "Acusado", nombre: "Acusado" },
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          sipeSearch: false,
          emptyTitle: "Nuevo contraventor/a",
          filiacionDesconocida: true,
        },
        {
          arrId: "1e01be2b-7a3b-42d8-99eb-31694d78a1af",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "4", nombre: "Divorciado/a" },
            arrId: "1e01be2b-7a3b-42d8-99eb-31694d78a1af",
            documento: "123456",
            sexo: { id: "F", nombre: "Femenino" },
            nombre: "Romina Sabrina",
            apellido: "GAJERO",
            fechaNacimiento: "00-00-0000",
            domicilioSIPE: " ,  CP: - , , ",
            apodo: "la ladronsuela",
            telefono: "444",
            condicion: { id: "Detenido", nombre: "Detenido" },
            email: "helloworld@hotmail.com",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo contraventor/a",
          sipeSearch: true,
        },
        {
          arrId: "773f0cb2-3b79-4063-99c7-efceb1a8ca8b",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "empty",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo contraventor/a",
        },
      ],
    },
    robados: {
      list: [
        {
          arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
          doc: {
            tipoEfecto: { id: "Recuperado", nombre: "Recuperado" },
            arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
            CategoriaID: "1",
            SubcategoriaID: "2d532f6b-b685-11ec-8878-16c2a030bb97",
            TipoID: "8fd03587-dfb4-11ed-9f23-0242ac120004",
            MarcaID: "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            ModeloID: "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            Anio: "2023",
            Chasis: "156",
            NumeroMotor: "1589798",
            Dominio: "asd123",
            NumeroSerie: "2235",
            Imei: "159489159",
            Abonado: "365",
            Color: "Gris",
          },
          type: "doc",
          conocido: true,
          hasIdentikit: false,
        },
        {
          arrId: "6c445767-6a60-4617-900f-dd776bfb1fee",
          doc: { newFormatEffect: true, tipoEfecto: { id: "Secuestrado", nombre: "Secuestrado" } },
          type: "empty",
          conocido: true,
          hasIdentikit: false,
        },
      ],
    },
    denunciante: {
      list: [
        {
          arrId: "ec449bc2-60a8-4d60-bea0-780a0300effa",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Denunciante y Damnificado", nombre: "Denunciante y Damnificado" },
            email: "dolor_sit_amet@hotmail.com",
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "3", nombre: "Separado/a" },
            arrId: "ec449bc2-60a8-4d60-bea0-780a0300effa",
            documento: "1234",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Marcelo",
            apellido: "UAMPA",
            fechaNacimiento: "12-06-1985",
            domicilioSIPE: " ,  CP: - , , ",
            telefono: "333",
          },
          type: "doc",
          sipeSearch: true,
          emptyTitle: "Nuevo denunciante y/o damnificado/a",
        },
        {
          arrId: "ba790af5-3a5f-41a1-9598-e06b9c0c5e84",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            arrId: "ba790af5-3a5f-41a1-9598-e06b9c0c5e84",
            documento: "12345",
            sexo: { id: "F", nombre: "Femenino" },
            nombre: "Pilar A",
            apellido: "MUZZUPAPPA",
            fechaNacimiento: "07-02-1915",
            domicilioSIPE: " ,  CP: - , , ",
            telefono: "333",
          },
          type: "doc",
          ordenPublico: false,
          emptyTitle: "Nuevo denunciante y/o damnificado/a",
          cuil: "20-00001234-4",
          sipeSearch: true,
        },
        {
          arrId: "3928615d-6055-46ec-abd9-1134cb5b4360",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            arrId: "3928615d-6055-46ec-abd9-1134cb5b4360",
          },
          type: "doc",
          ordenPublico: true,
          emptyTitle: "Nuevo denunciante y/o damnificado/a",
        },
        {
          arrId: "58eea3c9-2772-43de-9892-feddf565156d",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nuevo denunciante y/o damnificado/a",
        },
      ],
      emptyDoc: {
        instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
        email: "helloworld@gmail.com",
        nacionalidad: { id: 1, nombre: "ARGENTINA" },
        condicion: { id: "Damnificado", nombre: "Damnificado" },
        tipoDocumento: { id: "DNI", nombre: "DNI" },
      },
    },
    Sitio: { TipoSitioID: "tipo-sitio-id-0001" },
    denunciante: {
      list: [
        {
          arrId: "DenunciantePorDefectoParaContravencional",
          doc: {
            instruccion: {},
            nacionalidad: {},
            documento: "",
            apellido: "",
            nombre: "",
            sexo: {},
            arrId: "DenunciantePorDefectoParaContravencional",
          },
          type: "doc",
          ordenPublico: true,
        },
        {
          arrId: "ec449bc2-60a8-4d60-bea0-780a0300effa",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Denunciante y Damnificado", nombre: "Denunciante y Damnificado" },
            email: "dolor_sit_amet@hotmail.com",
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "3", nombre: "Separado/a" },
            arrId: "ec449bc2-60a8-4d60-bea0-780a0300effa",
            documento: "1234",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Marcelo",
            apellido: "UAMPA",
            fechaNacimiento: "12-06-1985",
            domicilioSIPE: " ,  CP: - , , ",
            telefono: "333",
          },
          type: "doc",
          sipeSearch: true,
          emptyTitle: "Nuevo denunciante y/o damnificado/a",
        },
        {
          arrId: "ba790af5-3a5f-41a1-9598-e06b9c0c5e84",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            arrId: "ba790af5-3a5f-41a1-9598-e06b9c0c5e84",
            documento: "12345",
            sexo: { id: "F", nombre: "Femenino" },
            nombre: "Pilar A",
            apellido: "MUZZUPAPPA",
            fechaNacimiento: "07-02-1915",
            domicilioSIPE: " ,  CP: - , , ",
            telefono: "333",
          },
          type: "doc",
          ordenPublico: false,
          emptyTitle: "Nuevo denunciante y/o damnificado/a",
          sipeSearch: true,
        },
        {
          arrId: "3928615d-6055-46ec-abd9-1134cb5b4360",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nuevo denunciante y/o damnificado/a",
        },
      ],
      emptyDoc: {
        instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
        email: "helloworld@gmail.com",
        nacionalidad: { id: 1, nombre: "ARGENTINA" },
        condicion: { id: "Damnificado", nombre: "Damnificado" },
        tipoDocumento: { id: "DNI", nombre: "DNI" },
      },
    },
    diligencia: [],
    idDependencia: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    idUser: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
    DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    secretarioOriginal: "Test, User",
    secretarioActual: "Test, User",
    ActuacionUsuarioDependencia: [
      {
        Fechadesde: "2022-06-27 16:08:25",
        Fechahasta: null,
        ActuacionUsuarioDependenciaID: "852c25bf-f64c-11ec-bb82-0eb8b69eb347",
        ActuacionID: "841964a2-f64c-11ec-bb82-0eb8b69eb347",
        UsuarioID: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
        DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
        Numeroextracto: null,
        Email: "cangaleonardo@gmail.com",
        Imagen: null,
        NombreUsuario: "UserTesterE3",
        Numeroarma: null,
        Numerocredencial: null,
        Numeropadron: null,
        Ultimaactividad: null,
        PersonaFisicaID: "f0c88931-9ee3-11ec-816d-16c2a030bb97",
        TipoUsuarioID: "UserTester",
        Fechainivig: "2022-03-08 13:31:16",
        FechaEliminacion: null,
        WhoDeleteUser: null,
        Apellido: "Test",
        Celular: null,
        Cuil: "11111",
        Dni: "1111111",
        Fechadefuncion: null,
        Lugardenacimiento: null,
        Nacionalidad: null,
        Nombre: "User",
        Sexo: null,
        Telefono: null,
        TipodocumentoID: "123",
        EstadoCivil: null,
        FechaDeNacimiento: null,
        Instruccion: null,
        Profesion: null,
        DomicilioSipe: null,
        PersonaJuridica: null,
        Cuit: null,
        Denominacion: null,
        DomicilioJuridico: null,
        Rubro: null,
        TelefonoJuridico: null,
        Apodo: null,
      },
    ],
    actuacionUsuarioDependenciaID: "852c25bf-f64c-11ec-bb82-0eb8b69eb347",
    dependenciaPolicial: "SUB COMISARIA  E3",
    dependenciaDepartamento: "RAWSON",
    dependenciaDomicilio: "20 de Junio y Mistral (Fte. Plaza)",
    dependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    denunciaID: "81ea9ba6-f64c-11ec-bb82-0eb8b69eb347",
    tiposumarioID: "Expediente·Contravencional·por·oficio",
    sumarioEstado: "En Curso",
    sumarioEstadoID: "84a2e47c-f64c-11ec-bb82-0eb8b69eb347",
  },

  //ACTUACIÓN "EXPEDIENTE CONTRAVENCIONAL POR DENUNCIA"
  "contravencional-denuncia": {
    denunciantesBD: [],
    ubicacion: {},
    preUbicacion: {
      calle: "Avenida Siempreviva",
      numero: "742",
      coordinates: { lat: -31.542287711530214, lng: -68.53799328752244 },
    },
    moment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    preMoment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    estadoCivil: {},
    residencia: {},
    denuncia: [{ name: "InputNestor", value: "" }],
    fechaDenuncia: new Date(),
    fechaCertificadoDenuncia: null,
    denunciaText: "",
    causaNumero: "123456",
    modusOperandi: null,
    causaCaratula: null,
    listaArticulos: [
      {
        ArticulosID: "12110411-9d53-11ec-816d-16c2a030bb97",
        Numeroarticulo: "134º Estado de ebriedad",
        Codigo: "Ley Nº 941-R",
      },
      {
        ArticulosID: "26ef62c9-8f2f-11ec-816d-16c2a030bb97",
        Numeroarticulo: "157º Operaciones de cambio",
        Codigo: "Ley Nº 941-R",
      },
      {
        ArticulosID: "b40a5e0b-843a-11ec-816d-16c2a030bb97",
        Numeroarticulo: "137º Abuso de sustancias estupefacientes ",
        Codigo: "LEY Nº 941-R",
      },
    ],
    causaJuzgado: {
      JuzgadoID: "4e2500da-b6fa-11ec-8878-16c2a030bb97",
      Fechainivig: "2022-04-08 05:11:11",
      Fechafinvig: null,
      Nombre: "PRIMER JUZGADO PENAL DE NIÑEZ Y ADOLESCENCIA",
      Telefono: null,
      Domicilio: null,
    },
    ActuacionUfi: null,
    prosecutor: null,
    assistant: null,
    id: null,
    saveStatus: "new",
    timer: false,
    isSaving: false,
    type: null,
    deposition:
      "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FIN",
    formType: "contravencional-denuncia",
    dependencia: "",
    PersonalInterviniente: [],
    textEditsCounter: {
      Preform: 0,
      Contravener: 0,
      Postform: 0,
      LegalData: 0,
      instructionDecree: 0,
    },
    textEstaticos: {
      Preform: "",
      Contravener: "",
      Postform: "",
      LegalData: "",
      instructionDecree: "",
    },
    spinnerOrderTablePrintFrom: false,
    acusados: {
      list: [
        {
          arrId: "b66a12d0-2f9c-4e60-89f6-c727f5145521",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            arrId: "b66a12d0-2f9c-4e60-89f6-c727f5145521",
            condicion: { id: "Acusado", nombre: "Acusado" },
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          sipeSearch: false,
          emptyTitle: "Nuevo contraventor/a",
          filiacionDesconocida: true,
        },
        {
          arrId: "1e01be2b-7a3b-42d8-99eb-31694d78a1af",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "4", nombre: "Divorciado/a" },
            arrId: "1e01be2b-7a3b-42d8-99eb-31694d78a1af",
            documento: "123456",
            sexo: { id: "F", nombre: "Femenino" },
            nombre: "Romina Sabrina",
            apellido: "GAJERO",
            fechaNacimiento: "00-00-0000",
            domicilioSIPE: " ,  CP: - , , ",
            apodo: "la ladronsuela",
            telefono: "444",
            condicion: { id: "Detenido", nombre: "Detenido" },
            email: "helloworld@hotmail.com",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo contraventor/a",
          sipeSearch: true,
        },
        {
          arrId: "773f0cb2-3b79-4063-99c7-efceb1a8ca8b",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "empty",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo contraventor/a",
        },
      ],
    },
    robados: {
      list: [
        {
          arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
          doc: {
            tipoEfecto: { id: "Recuperado", nombre: "Recuperado" },
            arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
            CategoriaID: "1",
            SubcategoriaID: "2d532f6b-b685-11ec-8878-16c2a030bb97",
            TipoID: "8fd03587-dfb4-11ed-9f23-0242ac120004",
            MarcaID: "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            ModeloID: "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            Anio: "2023",
            Chasis: "156",
            NumeroMotor: "1589798",
            Dominio: "asd123",
            NumeroSerie: "2235",
            Imei: "159489159",
            Abonado: "365",
            Color: "Gris",
          },
          type: "doc",
          conocido: true,
          hasIdentikit: false,
        },
        {
          arrId: "6c445767-6a60-4617-900f-dd776bfb1fee",
          doc: { newFormatEffect: true, tipoEfecto: { id: "Secuestrado", nombre: "Secuestrado" } },
          type: "empty",
          conocido: true,
          hasIdentikit: false,
        },
      ],
    },
    Sitio: { TipoSitioID: "tipo-sitio-id-0001" },
    denunciante: {
      list: [
        {
          arrId: "20e7c1cd-4fff-42ef-a3a6-40102bb5109c",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Denunciante y Damnificado", nombre: "Denunciante y Damnificado" },
            email: "dolor_sit_amet@hotmail.com",
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "3", nombre: "Separado/a" },
            arrId: "20e7c1cd-4fff-42ef-a3a6-40102bb5109c",
            documento: "1234",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Marcelo",
            apellido: "UAMPA",
            fechaNacimiento: "12-06-1985",
            domicilioSIPE: " ,  CP: - , , ",
            telefono: "33333",
          },
          type: "doc",
          sipeSearch: true,
          emptyTitle: "Nuevo denunciante y/o damnificado/a",
        },
        {
          arrId: "c815f3c6-835e-440c-9f31-0896387b81da",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "4", nombre: "Divorciado/a" },
            arrId: "c815f3c6-835e-440c-9f31-0896387b81da",
            documento: "12345",
            sexo: { id: "F", nombre: "Femenino" },
            telefono: "44444",
            nombre: "Pilar A",
            apellido: "MUZZUPAPPA",
            fechaNacimiento: "07-02-1915",
            domicilioSIPE: " ,  CP: - , , ",
          },
          type: "doc",
          ordenPublico: false,
          emptyTitle: "Nuevo denunciante y/o damnificado/a",
          sipeSearch: true,
        },
        {
          arrId: "a7655b65-20d7-4e0f-a432-c134de673015",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nuevo denunciante y/o damnificado/a",
        },
      ],
      emptyDoc: {
        instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
        email: "helloworld@gmail.com",
        nacionalidad: { id: 1, nombre: "ARGENTINA" },
        condicion: { id: "Damnificado", nombre: "Damnificado" },
        tipoDocumento: { id: "DNI", nombre: "DNI" },
      },
    },
    diligencia: {},
  },

  //ACTUACIÓN "SUMARIO POR DENUNCIA"
  "denuncia": {
    "preUbicacion": {
      "calle": "P. Sherman, calle Wallaby, 42, Sydney",
      "coordinates": {
        "lat": -31.541588216116875,
        "lng": -68.53766083717348
      },
      "departamento": {
        "id": "7164a28a-ce2d-11e4-a042-0090f58f4f32",
        "nombre": "9 DE JULIO"
      },
      "numero": "8989"
    },
    "denuncia": [
      {
        "name": "InputNestor"
      }
    ],
    "denunciaText": "Relato de Prueba para V2",
    "causaNumero": "123456",
    "modusOperandi": {
      "TipomodusoperandiID": "496cf61d-a3c5-11ec-816d-16c2a030bb97",
      "Nombre": "CUATREROS"
    },
    "listaCaratulas": [
      {
        "TipocausacaratulaID": "2771bc5b-a3ca-11ec-816d-16c2a030bb97",
        "Nombre": "ABUSO DE ARMA",
        "TipoCaratula": "Causa Caratula"
      },
      {
        "TipocausacaratulaID": "2a5c76f3-a3ca-11ec-816d-16c2a030bb97",
        "Nombre": "ACT.PARA ESTABLECER PARADERO",
        "TipoCaratula": "Causa Caratula"
      },
      {
        "TipocausacaratulaID": "2b6ff555-a3ca-11ec-816d-16c2a030bb97",
        "Nombre": "ACT.POR FALLECIMIENTO",
        "TipoCaratula": "Causa Caratula"
      }
    ],
    "causaJuzgado": {
      "JuzgadoID": "3db1cda6-cca0-11e4-8df1-0090f58f4f32",
      "Fechainivig": "2021-12-23 00:00:00",
      "Nombre": "JUZGADO DE PAZ ZONDA"
    },
    "id": "a211866d-ade1-11f0-8d09-0242ac140004",
    "deposition": "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    "formType": "denuncia",
    "Sitio": {
      "TipoSitioID": "tipo-sitio-id-0001"
    },
    "effectsType": "empty",
    "textEditsCounter": {
      "Preform": 0,
      "Contravener": 0,
      "instructionDecree": 0
    },
    "acusados": {
      "list": [
        {
          "arrId": "94cea709-7ef5-4829-8a1b-40d877a3416b",
          "doc": {
            "instruccion": {
              "id": "sabe_leer_sabe_firmar",
              "nombre": "Sabe leer y sabe firmar"
            },
            "email": "helloworld@hotmail.com",
            "nacionalidad": {
              "id": 1,
              "nombre": "ARGENTINA"
            },
            "tipoDocumento": {
              "id": "DNI",
              "nombre": "DNI"
            },
            "estadoCivil": {
              "id": "3",
              "nombre": "Separado/a"
            },
            "arrId": "94cea709-7ef5-4829-8a1b-40d877a3416b",
            "documento": "123456",
            "sexo": {
              "id": "F",
              "nombre": "Femenino"
            },
            "nombre": "Romina Sabrina",
            "apellido": "GAJERO",
            "fechaNacimiento": "22/11/1300",
            "domicilioSIPE": " ,  CP: - , , ",
            "apodo": "La malota",
            "condicion": {
              "id": "Detenido",
              "nombre": "Detenido"
            },
            "personaJuridica": false,
            "exhibeDocumento": {
              "id": 1,
              "nombre": "Sí"
            },
            "edad": "55",
            "domicilio": " ,  CP: - , , ",
            "tieneSeguro": false,
            "tieneEstudios": {
              "nombre": "No"
            },
            "cuil": "454643453"
          },
          "identikit": [
            {
              "answer": "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              "question": "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              "questionNumber": 1
            },
            {
              "answer": "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              "question": "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              "questionNumber": 2
            },
            {
              "answer": "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              "question": "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              "questionNumber": 3
            },
            {
              "answer": "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              "question": "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              "questionNumber": 4
            },
            {
              "answer": "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              "question": "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              "questionNumber": 5
            },
            {
              "answer": "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              "question": "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              "questionNumber": 6
            }
          ],
          "type": "doc",
          "conocido": true,
          "hasIdentikit": false,
          "sipeSearch": true,
          "emptyTitle": "Nuevo acusado",
          "filiacionDesconocida": false
        },
        {
          "arrId": "ab19774c-424e-4b2f-92f9-ab36f0a18e8b",
          "doc": {
            "instruccion": {
              "id": "sabe_leer_sabe_firmar",
              "nombre": "Sabe leer y sabe firmar"
            },
            "email": "helloworld@gmail.com",
            "nacionalidad": {
              "id": 1,
              "nombre": "ARGENTINA"
            },
            "tipoDocumento": {
              "id": "DNI",
              "nombre": "DNI"
            },
            "arrId": "ab19774c-424e-4b2f-92f9-ab36f0a18e8b",
            "condicion": {
              "id": "Acusado",
              "nombre": "Acusado"
            }
          },
          "identikit": [
            {
              "answer": "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              "question": "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              "questionNumber": 1
            },
            {
              "answer": "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              "question": "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              "questionNumber": 2
            },
            {
              "answer": "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              "question": "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              "questionNumber": 3
            },
            {
              "answer": "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              "question": "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              "questionNumber": 4
            },
            {
              "answer": "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              "question": "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              "questionNumber": 5
            },
            {
              "answer": "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              "question": "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              "questionNumber": 6
            }
          ],
          "identikitQuestion": 1,
          "type": "doc",
          "conocido": true,
          "hasIdentikit": false,
          "emptyTitle": "Nuevo acusado",
          "filiacionDesconocida": true
        },
        {
          "arrId": "9639eb59-f69a-4aca-998a-ad081cbbcbac",
          "doc": {
            "instruccion": {
              "id": "sabe_leer_sabe_firmar",
              "nombre": "Sabe leer y sabe firmar"
            },
            "email": "helloworld@gmail.com",
            "nacionalidad": {
              "id": 1,
              "nombre": "ARGENTINA"
            },
            "tipoDocumento": {
              "id": "DNI",
              "nombre": "DNI"
            }
          },
          "identikit": [
            {
              "answer": "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              "question": "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              "questionNumber": 1
            },
            {
              "answer": "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              "question": "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              "questionNumber": 2
            },
            {
              "answer": "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              "question": "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              "questionNumber": 3
            },
            {
              "answer": "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              "question": "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              "questionNumber": 4
            },
            {
              "answer": "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              "question": "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              "questionNumber": 5
            },
            {
              "answer": "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              "question": "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              "questionNumber": 6
            }
          ],
          "identikitQuestion": 1,
          "type": "empty",
          "conocido": true,
          "hasIdentikit": false,
          "emptyTitle": "Nuevo vinculado"
        }
      ]
    },
    "robados": {
      "list": [
        {
          "arrId": "7192952f-8a6b-4f89-a824-dc18b6713b43",
          "doc": {
            "tipoEfecto": {
              "id": "Recuperado",
              "nombre": "Recuperado"
            },
            "arrId": "7192952f-8a6b-4f89-a824-dc18b6713b43",
            "CategoriaID": "1",
            "SubcategoriaID": "2d532f6b-b685-11ec-8878-16c2a030bb97",
            "TipoID": "8fd03587-dfb4-11ed-9f23-0242ac120004",
            "MarcaID": "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            "ModeloID": "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            "Anio": "2023",
            "Chasis": "156",
            "NumeroMotor": "1589798",
            "Dominio": "asd123",
            "NumeroSerie": "2235",
            "Imei": "159489159",
            "Abonado": "365",
            "Color": "Gris"
          },
          "type": "doc",
          "conocido": true,
          "hasIdentikit": false
        },
        {
          "arrId": "6c445767-6a60-4617-900f-dd776bfb1fee",
          "doc": {
            "newFormatEffect": true,
            "tipoEfecto": {
              "id": "Secuestrado",
              "nombre": "Secuestrado"
            }
          },
          "type": "empty",
          "conocido": true,
          "hasIdentikit": false
        }
      ]
    },
    "denunciante": {
      "list": [
        {
          "arrId": "48498b85-a4ce-4f9e-9ecb-becb28a97f19",
          "doc": {
            "personaJuridica": false,
            "condicion": {
              "id": "Denunciante",
              "nombre": "Denunciante"
            },
            "documento": "1234",
            "tipoDocumento": {
              "id": "DNI",
              "nombre": "DNI"
            },
            "sexo": {
              "id": "F",
              "nombre": "Femenino"
            },
            "exhibeDocumento": {
              "id": 1,
              "nombre": "Sí"
            },
            "instruccion": {
              "id": "sabe_leer_sabe_firmar",
              "nombre": "Sabe leer y sabe firmar"
            },
            "apellido": "SALVA",
            "nombre": "Gladys Yenina",
            "nacionalidad": {
              "id": 1,
              "nombre": "ARGENTINA"
            },
            "fechaNacimiento": "12/12/1800",
            "edad": "12",
            "estadoCivil": {
              "id": "4",
              "nombre": "Divorciado/a"
            },
            "telefono": "333",
            "profesion": "psicologo",
            "domicilio": " ,  CP: - , , ",
            "domicilioSIPE": " ,  CP: - , , ",
            "email": "holamundo@gmail.com",
            "tieneSeguro": false,
            "tieneEstudios": {
              "id": 1,
              "nombre": "Sí"
            },
            "cuil": "20-00001234-4",
            "arrId": "48498b85-a4ce-4f9e-9ecb-becb28a97f19"
          },
          "type": "doc",
          "sipeSearch": true,
          "emptyTitle": "Nuevo denunciante y/o damnificado/a"
        },
        {
          "arrId": "25eafee0-cdbb-4687-848a-1e86bc5f86e2",
          "doc": {
            "personaJuridica": false,
            "condicion": {
              "id": "Denunciante y Damnificado",
              "nombre": "Denunciante y Damnificado"
            },
            "documento": "12346",
            "tipoDocumento": {
              "id": "DNI",
              "nombre": "DNI"
            },
            "sexo": {
              "id": "M",
              "nombre": "Masculino"
            },
            "exhibeDocumento": {
              "id": 1,
              "nombre": "Sí"
            },
            "instruccion": {
              "id": "sabe_leer_sabe_firmar",
              "nombre": "Sabe leer y sabe firmar"
            },
            "apellido": "Arantes do Nascimento",
            "nombre": "Edson",
            "nacionalidad": {
              "id": 1,
              "nombre": "BRASIL"
            },
            "fechaNacimiento": "23/10/1940",
            "edad": "21",
            "estadoCivil": {
              "id": "2",
              "nombre": "Casado/a"
            },
            "telefono": "11111",
            "profesion": "futbolista",
            "domicilio": "calle falsa 123",
            "email": "dolor_sit_amet@hotmail.com",
            "tieneSeguro": false,
            "tieneEstudios": {
              "id": 0,
              "nombre": "No"
            },
            "cuil": "121231231",
            "arrId": "25eafee0-cdbb-4687-848a-1e86bc5f86e2"
          },
          "type": "doc",
          "ordenPublico": false,
          "emptyTitle": "Nuevo denunciante y/o damnificado/a",
          "sipeSearch": false
        }
      ],
      "emptyDoc": {
        "instruccion": {
          "id": "sabe_leer_sabe_firmar",
          "nombre": "Sabe leer y sabe firmar"
        },
        "nacionalidad": {
          "id": 1,
          "nombre": "ARGENTINA"
        },
        "condicion": {
          "id": "Denunciante y Damnificado",
          "nombre": "Denunciante y Damnificado"
        },
        "tipoDocumento": {
          "id": "DNI",
          "nombre": "DNI"
        },
        "exhibeDocumento": {
          "id": 1,
          "nombre": "Sí"
        },
        "tieneEstudios": {
          "id": 1,
          "nombre": "Sí"
        }
      }
    },
    "afectacionPatrimonial": {
      "list": [
        {
          "arrId": "ca5a1a13-ba93-4fb4-bde6-5f3458201f2a",
          "doc": {
            "newFormatEffect": true
          },
          "type": "empty"
        }
      ]
    },
    "sumarioEstado": "En Curso",
    "actaInicio": "--- En la provincia de San Juan, SUB COMISARIA  E3, RAWSONa los 20 días del mes de Octubre del año Dos Mil Veinticinco, siendo las 15:07 horasel Funcionario de Policía que suscribe, Jefe de esta sede legal y Secretario de Actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora precitada, comparece ante esta Instrucción la persona mencionada precedentemente a fin de poner en conocimiento la supuesta Comisión de un hecho de carácter delictivo, que da lugar a la intervención de esta Autoridad Policial, acto seguido y luego de ser impuesto del contenido del Art. 245° del Código Penal (falsa denuncia), a continuación, se le pregunta por sus nombres apellidos y demás circunstancias personales  manifestó llamarse:  SALVA, Gladys Yenina, DNI N° 1234, de nacionalidad ARGENTINA, estado civil Divorciado/a, de 224 años de edad, Sabe leer y sabe firmar, de profesion psicologo, con domicilio en  ,  CP: - , ,  \n  Arantes do Nascimento, Edson, DNI N° 12346, de nacionalidad BRASIL, estado civil Casado/a, de 84 años de edad, Sabe leer y sabe firmar, de profesion futbolista, con domicilio en calle falsa 123 \n . Con relación al hecho que viene a denunciar DECLARO: Que se presenta ante esta autoridad policial a fin de manifestar que Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.. ",
    "preMoment": {
      "date": new Date("2025-10-20T18:21:45.571Z"),
      "date2": new Date("2025-10-20T18:21:45.571Z")
    }
  },

  //ACTUACIÓN "UFI FLAGRANCIA"
"ufi-flagrancia": {
  "preUbicacion": {
    "calle": "olegario Andrade ",
    "coordinates": {
      "lat": -31.541940250411464,
      "lng": -68.53583693504335
    },
    "departamento": {
      "id": "71c04abf-ce2d-11e4-a042-0090f58f4f32",
      "nombre": "25 DE MAYO"
    },
    "numero": "123123123"
  },
  "denuncia": [
    {
      "name": "InputNestor"
    }
  ],
  "causaNumero": "123123123",
  "modusOperandi": {
    "TipomodusoperandiID": "36844f89-a3c5-11ec-816d-16c2a030bb97",
    "Nombre": "ABORTO"
  },
  "causaCaratula": {
    "TipocausacaratulaID": "fc2db6c2-85f7-11ed-8410-0242ac120003",
    "Nombre": "nuevo delito",
    "TipoCaratula": "Delito"
  },
  "ActuacionUfi": {
    "TipoufiID": "ufi44fb5-c013-11ec-8878-16c2a030bb97",
    "Fechainivig": "2022-07-06 13:22:00",
    "Numero": "4"
  },
  "prosecutor": {
    "PersonalfiscalID": "159d607f-ff05-11ec-bb82-0eb8b69eb347",
    "Denominacion": "Dr. Adrian Riveros",
    "Jerarquia": "Fiscal"
  },
  "assistant": {
    "PersonalfiscalID": "b38de3d0-ff06-11ec-bb82-0eb8b69eb347",
    "Denominacion": "Dr. Carlos Cáceres",
    "Jerarquia": "Ayudante"
  },
  "id": "6dd71e32-fd32-11f0-b73b-0242ac140003",
  "deposition": "--- En la provincia de San Juan, sede de , a los 29 días del mes de Enero del año Dos Mil Veintiseis, siendo las 13:44 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del Sargento Primero jefeGorgori adscripto/s al numerario de Ptp Policial Tamberias Calingasta--- En la provincia de San Juan, sede de , a los 29 días del mes de Enero del año Dos Mil Veintiseis, siendo las 13:44 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del Sargento Primero jefeGorgori adscripto/s al numerario de Ptp Policial Tamberias Calingasta--- En la provincia de San Juan, sede de , a los 29 días del mes de Enero del año Dos Mil Veintiseis, siendo las 13:44 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del Sargento Primero jefeGorgori adscripto/s al numerario de Ptp Policial Tamberias Calingasta--- En la provincia de San Juan, sede de , a los 29 días del mes de Enero del año Dos Mil Veintiseis, siendo las 13:44 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del Sargento Primero jefeGorgori adscripto/s al numerario de Ptp Policial Tamberias Calingasta",
  "formType": "ufi-flagrancia",
  "Sitio": {
    "TipoSitioID": "tipo-sitio-id-0001"
  },
  "effectsType": "empty",
  "PersonalInterviniente": [
    {
      "nombre": "jefeGorgori",
      "jerarquia": {
        "id": "5",
        "nombre": "Sargento Primero"
      },
      "dependencia": "Ptp Policial Tamberias Calingasta"
    }
  ],
  "diligencia": [
    {
      "ActuacionID": "12f6af01-fd32-11f0-b73b-0242ac140003",
      "Modificada": "false",
      "TamanoSangria": 0,
      "TipodiligenciaID": "ufiF5fe4-7957-11ec-816d-16c2a030bb97",
      "UsuarioID": "37ce39fe-f85c-11f0-a2f2-0242ac140004",
      "Fechainivig": "Hace un Minuto",
      "Contenido": "&lt;p style=&quot;line-height: 1.4em; color: black; text-indent: 0em; text-align: center&quot; class=&quot;&quot; id=&quot;&quot;&gt;&lt;strong&gt;&lt;u&gt;ACTA DE INICIO&lt;/u&gt;&lt;/strong&gt;&lt;/p&gt;&lt;p style=&quot;line-height: 1.4em; color: black; text-indent: 0em; text-align: justify&quot; class=&quot;&quot; id=&quot;&quot;&gt;--- En la provincia de San Juan, sede de , a los 29 días del mes de Enero del año Dos Mil Veintiseis, siendo las 13:44 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del Sargento Primero 123123123 adscripto/s al numerario de Ptp Policial Tamberias Calingasta --- En la provincia de San Juan, sede de , a los 29 días del mes de Enero del año Dos Mil Veintiseis, siendo las 13:44 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del--- En la provincia de San Juan, sede de , a los 29 días del mes de Enero del año Dos Mil Veintiseis, siendo las 13:44 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del--- En la provincia de San Juan, sede de , a los 29 días del mes de Enero del año Dos Mil Veintiseis, siendo las 13:44 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del--- En la provincia de San Juan, sede de , a los 29 días del mes de Enero del año Dos Mil Veintiseis, siendo las 13:44 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del--- En la provincia de San Juan, sede de , a los 29 días del mes de Enero del año Dos Mil Veintiseis, siendo las 13:44 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del--- En la provincia de San Juan, sede de , a los 29 días del mes de Enero del año Dos Mil Veintiseis, siendo las 13:44 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del--- En la provincia de San Juan, sede de , a los 29 días del mes de Enero del año Dos Mil Veintiseis, siendo las 13:44 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del--- En la provincia de San Juan, sede de , a los 29 días del mes de Enero del año Dos Mil Veintiseis, siendo las 13:44 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del--- En la provincia de San Juan, sede de , a los 29 días del mes de Enero del año Dos Mil Veintiseis, siendo las 13:44 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del--- En la provincia de San Juan, sede de , a los 29 días del mes de Enero del año Dos Mil Veintiseis, siendo las 13:44 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del--- En la provincia de San Juan, sede de , a los 29 días del mes de Enero del año Dos Mil Veintiseis, siendo las 13:44 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del--- En la provincia de San Juan, sede de , a los 29 días del mes de Enero del año Dos Mil Veintiseis, siendo las 13:44 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del--- En la provincia de San Juan, sede de , a los 29 días del mes de Enero del año Dos Mil Veintiseis, siendo las 13:44 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del. ; en virtud de ello la instrucción DISPONE Iniciar el Legajo de investigación que corresponda. Designar como secretario de las mismas al funcionario de Policía al pie firmante. Dar inmediata intervención a la U.F.I. N° 4 mediante la remisión del Parte Preventivo. Recibir a , de nacionalidad ARGENTINA, Sabe leer y sabe firmar Designar al Medico Legista de la Policía, a fin que examine al aprehendido. Requerir a través de cualquier medio idóneo la Plantilla Prontuarial actualizada del aprehendido. Llevar a cabo toda otra medida de carácter legal que se estime de interés.CERTIFICO.-&lt;/p&gt;",
      "Nombre": "ACTA DE INICIO LEGAJO UFI",
      "DiligenciaID": "15286e19-fd32-11f0-b73b-0242ac140003"
    }
  ],
  "textEditsCounter": {
    "Preform": 0,
    "Contravener": 0,
    "instructionDecree": 0
  },
  "acusados": {
    "list": [
      {
        "arrId": "02e83c4b-d7ac-4186-9eac-b91bcea6c35e",
        "doc": {
          "instruccion": {
            "id": "sabe_leer_sabe_firmar",
            "nombre": "Sabe leer y sabe firmar"
          },
          "nacionalidad": {
            "id": 1,
            "nombre": "ARGENTINA"
          },
          "exhibeDocumento": {
            "id": 0,
            "nombre": "No"
          },
          "tieneEstudios": {
            "id": 1,
            "nombre": "Sí"
          },
          "personaJuridica": false,
          "condicion": {
            "id": "Detenido",
            "nombre": "Detenido"
          },
          "tieneSeguro": false,
          "arrId": "02e83c4b-d7ac-4186-9eac-b91bcea6c35e"
        },
        "type": "doc",
        "conocido": true,
        "hasIdentikit": false,
        "sipeSearch": false,
        "emptyTitle": "Nuevo vinculado",
        "filiacionDesconocida": false
      },
      {
        "arrId": "9d0e2b82-75d3-4ffa-a4c7-b77177341a7c",
        "doc": {
          "instruccion": {
            "id": "sabe_leer_sabe_firmar",
            "nombre": "Sabe leer y sabe firmar"
          },
          "nacionalidad": {
            "id": 1,
            "nombre": "ARGENTINA"
          },
          "exhibeDocumento": {
            "id": 1,
            "nombre": "Sí"
          },
          "tieneEstudios": {
            "id": 1,
            "nombre": "Sí"
          }
        },
        "identikitQuestion": 1,
        "type": "empty",
        "conocido": true,
        "hasIdentikit": false,
        "emptyTitle": "Nuevo vinculado"
      }
    ],
    "emptyDoc": {
      "instruccion": {
        "id": "sabe_leer_sabe_firmar",
        "nombre": "Sabe leer y sabe firmar"
      },
      "nacionalidad": {
        "id": 1,
        "nombre": "ARGENTINA"
      },
      "exhibeDocumento": {
        "id": 1,
        "nombre": "Sí"
      },
      "tieneEstudios": {
        "id": 1,
        "nombre": "Sí"
      }
    }
  },
  "robados": {
    "list": [
      {
        "arrId": "881d954f-7e8c-4806-bbc3-2f94278de62c",
        "doc": {
          "newFormatEffect": true
        },
        "type": "empty"
      }
    ],
    "emptyDoc": {
      "newFormatEffect": true
    }
  },
  "denunciante": {
    "list": [
      {
        "arrId": "0ab1effb-1ac5-4881-8801-8b12ce2eb4ba",
        "doc": {
          "personaJuridica": false,
          "condicion": {
            "id": "Damnificado",
            "nombre": "Damnificado"
          },
          "documento": "40470460",
          "tipoDocumento": {
            "id": "DNI",
            "nombre": "DNI",
            "descripcion": "Documento Nacional de Identidad"
          },
          "sexo": {
            "id": "F",
            "nombre": "Femenino"
          },
          "exhibeDocumento": {
            "id": 0,
            "nombre": "No"
          },
          "instruccion": {
            "id": "universitaria",
            "nombre": "Universitaria"
          },
          "apellido": "perez",
          "nombre": "Santiago",
          "nacionalidad": {
            "id": 1,
            "nombre": "ARGENTINA"
          },
          "fechaNacimiento": "12/12/1212",
          "edad": "12",
          "estadoCivil": {
            "id": "5",
            "nombre": "Viudo/a"
          },
          "telefono": "02644427988",
          "profesion": "12312312",
          "domicilio": "123123123123123",
          "email": "santygarces@gmail.com",
          "tieneSeguro": false,
          "tieneEstudios": {
            "id": 1,
            "nombre": "Sí"
          },
          "cuil": "121231231",
          "arrId": "0ab1effb-1ac5-4881-8801-8b12ce2eb4ba"
        },
        "type": "doc",
        "sipeSearch": false,
        "emptyTitle": "Nuevo afectado"
      },
      {
        "arrId": "56675c10-1f19-44f5-916b-ad5963858afb",
        "doc": {
          "instruccion": {
            "id": "sabe_leer_sabe_firmar",
            "nombre": "Sabe leer y sabe firmar"
          },
          "nacionalidad": {
            "id": 1,
            "nombre": "ARGENTINA"
          },
          "tipoDocumento": {
            "id": "DNI",
            "nombre": "DNI"
          },
          "exhibeDocumento": {
            "id": 1,
            "nombre": "Sí"
          },
          "tieneEstudios": {
            "id": 1,
            "nombre": "Sí"
          }
        },
        "type": "empty",
        "ordenPublico": false,
        "emptyTitle": "Nuevo afectado"
      }
    ],
    "emptyDoc": {
      "instruccion": {
        "id": "sabe_leer_sabe_firmar",
        "nombre": "Sabe leer y sabe firmar"
      },
      "nacionalidad": {
        "id": 1,
        "nombre": "ARGENTINA"
      },
      "condicion": {
        "id": "Denunciante",
        "nombre": "Denunciante"
      },
      "tipoDocumento": {
        "id": "DNI",
        "nombre": "DNI"
      },
      "exhibeDocumento": {
        "id": 1,
        "nombre": "Sí"
      },
      "tieneEstudios": {
        "id": 1,
        "nombre": "Sí"
      }
    }
  },
  "afectacionPatrimonial": {
    "list": [
      {
        "arrId": "731fc14f-e0cc-4208-9702-be60bd9b19c5",
        "doc": {
          "newFormatEffect": true
        },
        "type": "empty"
      }
    ]
  },
  "actaInicio": "--- En la provincia de San Juan,  sede de , a los 29 días del mes de Enero del año Dos Mil Veintiseis, siendo las 13:44 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del   Sargento Primero jefeGorgori adscripto/s al numerario de Ptp Policial Tamberias Calingasta --- En la provincia de San Juan, sede de , a los 29 días del mes de Enero del año Dos Mil Veintiseis, siendo las 13:44 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del Sargento Primero jefeGorgori adscripto/s al numerario de Ptp Policial Tamberias Calingasta--- En la provincia de San Juan, sede de , a los 29 días del mes de Enero del año Dos Mil Veintiseis, siendo las 13:44 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del Sargento Primero jefeGorgori adscripto/s al numerario de Ptp Policial Tamberias Calingasta--- En la provincia de San Juan, sede de , a los 29 días del mes de Enero del año Dos Mil Veintiseis, siendo las 13:44 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del Sargento Primero jefeGorgori adscripto/s al numerario de Ptp Policial Tamberias Calingasta--- En la provincia de San Juan, sede de , a los 29 días del mes de Enero del año Dos Mil Veintiseis, siendo las 13:44 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del Sargento Primero jefeGorgori adscripto/s al numerario de Ptp Policial Tamberias Calingasta. ; en virtud de ello la instrucción DISPONE Iniciar el Legajo de investigación que corresponda. Designar como secretario de las mismas al funcionario de Policía al pie firmante. Dar inmediata intervención a la U.F.I. N° 4  mediante la remisión del Parte Preventivo. Recibir a  , de nacionalidad ARGENTINA, Sabe leer y sabe firmar Designar al Medico Legista de la Policía, a fin que examine al aprehendido. Requerir a través de cualquier medio idóneo la Plantilla Prontuarial actualizada del aprehendido. Llevar a cabo toda otra medida de carácter legal que se estime de interés.CERTIFICO.-",
  "sumarioEstado": "En Curso",
  "idDependencia": "0ae9138d-1d2c-11ef-83e2-0242ac120003",
  "idUser": "37ce39fe-f85c-11f0-a2f2-0242ac140004",
  "DependenciaID": "0ae9138d-1d2c-11ef-83e2-0242ac120003",
  "ActuacionUsuarioDependencia": [
    {
      "ActuacionUsuarioDependenciaID": "13029470-fd32-11f0-b73b-0242ac140003",
      "Fechadesde": "2026-01-29 13:46:35",
      "SumarioID": "12f6af01-fd32-11f0-b73b-0242ac140003",
      "UsuarioID": "37ce39fe-f85c-11f0-a2f2-0242ac140004",
      "DependenciaID": "0ae9138d-1d2c-11ef-83e2-0242ac120003",
      "EstadoRelacion": "ORIGINAL",
      "NombreUsuario": "santy8989",
      "Email": "santygarces@gmail.com",
      "Apellido": "Garces",
      "Nombre": "Santiago",
      "NumeroIdentificacion": "40490499"
    }
  ],
  "actuacionUsuarioDependenciaID": "13029470-fd32-11f0-b73b-0242ac140003",
  "dependenciaDomicilio": "algo",
  "dependenciaID": "0ae9138d-1d2c-11ef-83e2-0242ac120003",
  "denunciaID": "12f01cb3-fd32-11f0-b73b-0242ac140003",
  "tiposumarioID": "Unidades Fiscales de Investigacion Flagrancia",
  "sumarioEstadoID": "12fff92d-fd32-11f0-b73b-0242ac140003",
  "PersonalFiscal": [
    {
      "PersonalfiscalID": "159d607f-ff05-11ec-bb82-0eb8b69eb347",
      "Denominacion": "Dr. Adrian Riveros",
      "Jerarquia": "Fiscal"
    },
    {
      "PersonalfiscalID": "b38de3d0-ff06-11ec-bb82-0eb8b69eb347",
      "Denominacion": "Dr. Carlos Cáceres",
      "Jerarquia": "Ayudante"
    }
  ],
  "preMoment": {
    "date": new Date("2026-01-29T16:49:08.512Z"),
    "date2": new Date("2026-01-29T16:49:08.512Z")
  }
},

  //ACTUACIÓN "UFI CAVIG"
  "ufi-cavig": {
    denunciantesBD: [],
    ubicacion: "",
    preUbicacion: {
      calle: "FALSA",
      numero: "123",
      coordinates: { lat: -31.541697941234222, lng: -68.537934422493 },
    },
    moment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    preMoment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    estadoCivil: {},
    residencia: {},
    denuncia: [{ name: "InputNestor", value: "" }],
    fechaDenuncia: new Date(),
    fechaCertificadoDenuncia: null,
    denunciaText: "",
    causaNumero: "123456",
    modusOperandi: {
      TipomodusoperandiID: "4d6928f6-a3c5-11ec-816d-16c2a030bb97",
      Descripcion: null,
      Nombre: "EN BANDA",
    },
    causaCaratula: {
      TipocausacaratulaID: "fc2db6c2-85f7-11ed-8410-0242ac120003",
      Descripcion: null,
      Nombre: "nuevo delito",
      TipoCaratula: "Delito",
    },
    listaArticulos: [],
    causaJuzgado: null,
    ActuacionUfi: {
      TipoufiID: "ufi34fb5-c013-11ec-8878-16c2a030bb97",
      Fechainivig: "2022-07-06 13:22:00",
      Fechafinvig: null,
      Numero: "3",
    },
    Sitio: { TipoSitioID: "tipo-sitio-id-0001" },
    prosecutor: {
      PersonalfiscalID: "159d607f-ff05-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Adrian Riveros",
      Jerarquia: "Fiscal",
    },
    assistant: {
      PersonalfiscalID: "b8d73615-ff06-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Solera Alejandro",
      Jerarquia: "Ayudante",
    },
    id: null,
    saveStatus: "new",
    timer: false,
    isSaving: false,
    type: null,
    deposition:
      "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar ufi- CAVIG",
    formType: "ufi-cavig",
    dependencia: "SUB COMISARIA  E3",
    PersonalInterviniente: [
      {
        nombre: "jefe gorgory",
        jerarquia: { id: "4", nombre: "Sargento" },
        dependencia: "Ptp Policial Tamberias Calingasta",
      },
    ],
    textEditsCounter: {
      Preform: 0,
      Contravener: 0,
      Postform: "",
      LegalData: "",
      instructionDecree: 0,
    },
    textEstaticos: {
      Preform: "",
      Contravener: "",
      Postform: "",
      LegalData: "",
      instructionDecree: "",
    },
    spinnerOrderTablePrintFrom: false,
    acusados: {
      list: [
        {
          arrId: "6ee9d327-f610-43ba-95ee-f67714d7c342",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Aprehendido", nombre: "Aprehendido" },
            email: "loremipsum@yahoo.com",
            apellido: "mojo",
            arrId: "6ee9d327-f610-43ba-95ee-f67714d7c342",
            nombre: " jojo",
            estadoCivil: { id: "4", nombre: "Divorciado/a" },
            apodo: "mojo jojo",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          sipeSearch: false,
          emptyTitle: "Nuevo aprehendido",
        },
        {
          arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Acusado", nombre: "Acusado" },
            arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
            apellido: "Rodríguez",
            nombre: "Bender Bending",
            fechaNacimiento: "18/12/1994",
            estadoCivil: { id: "2", nombre: "Casado/a" },
            domicilio: "Planet Express",
            apodo: "bender",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo aprehendido",
        },
        {
          arrId: "0ab72ea4-71cb-4d9e-9744-5bd17e6226b7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Aprehendido", nombre: "Aprehendido" },
            email: "loremipsum@yahoo.com",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "empty",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo aprehendido",
        },
      ],
      emptyDoc: {
        instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
        email: "helloworld@gmail.com",
        nacionalidad: { id: 1, nombre: "ARGENTINA" },
        tipoDocumento: { id: "DNI", nombre: "DNI" },
        condicion: { id: "Aprehendido", nombre: "Aprehendido" },
        email: "loremipsum@yahoo.com",
      },
    },
    robados: {
      list: [
        {
          arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
          doc: {
            tipoEfecto: { id: "Recuperado", nombre: "Recuperado" },
            arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
            CategoriaID: "1",
            SubcategoriaID: "2d532f6b-b685-11ec-8878-16c2a030bb97",
            TipoID: "8fd03587-dfb4-11ed-9f23-0242ac120004",
            MarcaID: "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            ModeloID: "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            Anio: "2023",
            Chasis: "156",
            NumeroMotor: "1589798",
            Dominio: "asd123",
            NumeroSerie: "2235",
            Imei: "159489159",
            Abonado: "365",
            Color: "Gris",
          },
          type: "doc",
          conocido: true,
          hasIdentikit: false,
        },
        {
          arrId: "6c445767-6a60-4617-900f-dd776bfb1fee",
          doc: { newFormatEffect: true, tipoEfecto: { id: "Secuestrado", nombre: "Secuestrado" } },
          type: "empty",
          conocido: true,
          hasIdentikit: false,
        },
      ],
    },
    denunciante: {
      list: [
        {
          arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "victima", nombre: "Víctima" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
            documento: "123",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Johnny",
            apellido: "Bravo",
            fechaNacimiento: "18/07/1993",
            domicilio: "Neuquén, Argentina. 1887",
            telefono: "123",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nueva víctima",
        },
        {
          arrId: "a2270ac0-41fb-4d6c-a3be-466c0a2845bf",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            apellido: "Scooby",
            arrId: "a2270ac0-41fb-4d6c-a3be-466c0a2845bf",
            nombre: "Doo",
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            documento: "1234",
            sexo: { id: "M", nombre: "Masculino" },
            fechaNacimiento: "18/07/1993",
            telefono: "123",
            domicilio: "La maquina del misterio",
          },
          type: "doc",
          ordenPublico: false,
          emptyTitle: "Nueva víctima",
          sipeSearch: false,
        },
        {
          arrId: "0512fffc-f85a-4c65-bd8d-61a2f8b1f12e",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "victima", nombre: "Víctima" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nueva víctima",
        },
      ],
      emptyDoc: {
        instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
        email: "helloworld@gmail.com",
        nacionalidad: { id: 1, nombre: "ARGENTINA" },
        condicion: { id: "victima", nombre: "Víctima" },
        tipoDocumento: { id: "DNI", nombre: "DNI" },
      },
    },
    diligencia: [],
    DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    ActuacionUsuarioDependencia: [
      {
        ActuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
        Fechadesde: "2022-09-16 00:00:00",
        Fechahasta: null,
        ActuacionID: "cdaf7be3-35d0-11ed-9474-00ff2876ab1e",
        UsuarioID: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
        DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
        Numeroextracto: null,
        RecienEnviada: "0",
        NombreUsuario: "UserTesterE3",
        Email: "cangaleonardo@gmail.com",
        Apellido: "Test",
        Nombre: "User",
        Dni: "1111111",
      },
    ],
    actuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
    dependenciaPolicial: "SUB COMISARIA  E3",
    dependenciaDepartamento: "RAWSON",
    dependenciaDomicilio: "20 de Junio y Mistral (Fte. Plaza)",
    dependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    denunciaID: "cdac0e23-35d0-11ed-9474-00ff2876ab1e",
    tiposumarioID: "Unidades Fiscales de Investigacion cavig",
    sumarioEstado: "sin estado asignado",
    sumarioEstadoID: "sin estado asignado",
    idDependencia: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    idUser: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
  },

  //ACTUACIÓN "UFI ANIVI"
  "ufi-anivi": {
    denunciantesBD: [],
    ubicacion: "",
    preUbicacion: {
      calle: "FALSA",
      numero: "123",
      coordinates: { lat: -31.541697941234222, lng: -68.537934422493 },
    },
    moment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    preMoment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    estadoCivil: {},
    residencia: {},
    denuncia: [{ name: "InputNestor", value: "" }],
    fechaDenuncia: new Date(),
    fechaCertificadoDenuncia: null,
    denunciaText: "",
    causaNumero: "123456",
    modusOperandi: {
      TipomodusoperandiID: "4d6928f6-a3c5-11ec-816d-16c2a030bb97",
      Descripcion: null,
      Nombre: "EN BANDA",
    },
    causaCaratula: {
      TipocausacaratulaID: "fc2db6c2-85f7-11ed-8410-0242ac120003",
      Descripcion: null,
      Nombre: "nuevo delito",
      TipoCaratula: "Delito",
    },
    listaArticulos: [],
    causaJuzgado: null,
    ActuacionUfi: {
      TipoufiID: "ufi34fb5-c013-11ec-8878-16c2a030bb97",
      Fechainivig: "2022-07-06 13:22:00",
      Fechafinvig: null,
      Numero: "3",
    },
    Sitio: { TipoSitioID: "tipo-sitio-id-0001" },
    prosecutor: {
      PersonalfiscalID: "159d607f-ff05-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Adrian Riveros",
      Jerarquia: "Fiscal",
    },
    assistant: {
      PersonalfiscalID: "b8d73615-ff06-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Solera Alejandro",
      Jerarquia: "Ayudante",
    },
    id: null,
    saveStatus: "new",
    timer: false,
    isSaving: false,
    type: null,
    deposition:
      "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar ufi- anivi",
    formType: "ufi-anivi",
    dependencia: "SUB COMISARIA  E3",
    PersonalInterviniente: [
      {
        nombre: "jefe gorgory",
        jerarquia: { id: "4", nombre: "Sargento" },
        dependencia: "Ptp Policial Tamberias Calingasta",
      },
    ],
    textEditsCounter: {
      Preform: 0,
      Contravener: 0,
      Postform: "",
      LegalData: "",
      instructionDecree: 0,
    },
    textEstaticos: {
      Preform: "",
      Contravener: "",
      Postform: "",
      LegalData: "",
      instructionDecree: "",
    },
    spinnerOrderTablePrintFrom: false,
    acusados: {
      list: [
        {
          arrId: "6ee9d327-f610-43ba-95ee-f67714d7c342",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Aprehendido", nombre: "Aprehendido" },
            email: "loremipsum@yahoo.com",
            apellido: "mojo",
            arrId: "6ee9d327-f610-43ba-95ee-f67714d7c342",
            nombre: " jojo",
            estadoCivil: { id: "4", nombre: "Divorciado/a" },
            apodo: "mojo jojo",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          sipeSearch: false,
          emptyTitle: "Nuevo aprehendido",
        },
        {
          arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Acusado", nombre: "Acusado" },
            arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
            apellido: "Rodríguez",
            nombre: "Bender Bending",
            fechaNacimiento: "18/12/1994",
            estadoCivil: { id: "2", nombre: "Casado/a" },
            domicilio: "Planet Express",
            apodo: "bender",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo aprehendido",
        },
        {
          arrId: "0ab72ea4-71cb-4d9e-9744-5bd17e6226b7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Aprehendido", nombre: "Aprehendido" },
            email: "loremipsum@yahoo.com",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "empty",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo aprehendido",
        },
      ],
      emptyDoc: {
        instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
        email: "helloworld@gmail.com",
        nacionalidad: { id: 1, nombre: "ARGENTINA" },
        tipoDocumento: { id: "DNI", nombre: "DNI" },
        condicion: { id: "Aprehendido", nombre: "Aprehendido" },
        email: "loremipsum@yahoo.com",
      },
    },
    robados: {
      list: [
        {
          arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
          doc: {
            tipoEfecto: { id: "Recuperado", nombre: "Recuperado" },
            arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
            CategoriaID: "1",
            SubcategoriaID: "2d532f6b-b685-11ec-8878-16c2a030bb97",
            TipoID: "8fd03587-dfb4-11ed-9f23-0242ac120004",
            MarcaID: "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            ModeloID: "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            Anio: "2023",
            Chasis: "156",
            NumeroMotor: "1589798",
            Dominio: "asd123",
            NumeroSerie: "2235",
            Imei: "159489159",
            Abonado: "365",
            Color: "Gris",
          },
          type: "doc",
          conocido: true,
          hasIdentikit: false,
        },
        {
          arrId: "6c445767-6a60-4617-900f-dd776bfb1fee",
          doc: { newFormatEffect: true, tipoEfecto: { id: "Secuestrado", nombre: "Secuestrado" } },
          type: "empty",
          conocido: true,
          hasIdentikit: false,
        },
      ],
    },

    denunciante: {
      list: [
        {
          arrId: "0512fffc-f85a-4c65-bd8d-61a2f8b1f12e",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "victima", nombre: "Víctima" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            nombre: "H.J.S",
            arrId: "0512fffc-f85a-4c65-bd8d-61a2f8b1f12e",
          },
          type: "doc",
          ordenPublico: false,
          emptyTitle: "Nueva víctima",
        },
        {
          arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "victima", nombre: "Víctima" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
            documento: "123",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Johnny",
            apellido: "Bravo",
            fechaNacimiento: "18/07/1993",
            domicilio: "Neuquén, Argentina. 1887",
            telefono: "123",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nueva víctima",
        },
        {
          arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "victima", nombre: "Víctima" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nueva víctima",
        },
      ],
    },
    diligencia: [],
    DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    ActuacionUsuarioDependencia: [
      {
        ActuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
        Fechadesde: "2022-09-16 00:00:00",
        Fechahasta: null,
        ActuacionID: "cdaf7be3-35d0-11ed-9474-00ff2876ab1e",
        UsuarioID: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
        DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
        Numeroextracto: null,
        RecienEnviada: "0",
        NombreUsuario: "UserTesterE3",
        Email: "cangaleonardo@gmail.com",
        Apellido: "Test",
        Nombre: "User",
        Dni: "1111111",
      },
    ],
    actuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
    dependenciaPolicial: "SUB COMISARIA  E3",
    dependenciaDepartamento: "RAWSON",
    dependenciaDomicilio: "20 de Junio y Mistral (Fte. Plaza)",
    dependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    denunciaID: "cdac0e23-35d0-11ed-9474-00ff2876ab1e",
    tiposumarioID: "Unidades Fiscales de Investigacion anivi",
    sumarioEstado: "sin estado asignado",
    sumarioEstadoID: "sin estado asignado",
    idDependencia: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    idUser: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
  },

  //ACTUACIÓN "UFI ESTABLECER PARADERO"
  "ufi-establecer-paradero": {
    denunciantesBD: [],
    estadoCivil: {},
    residencia: {},
    denuncia: [{ name: "InputNestor", value: "" }],
    fechaDenuncia: new Date(),
    ubicacion: "",
    preUbicacion: {
      calle: "FALSA",
      numero: "123",
      coordinates: { lat: -31.541697941234222, lng: -68.537934422493 },
    },
    moment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    preMoment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    fechaCertificadoDenuncia: null,
    denunciaText: "",
    causaNumero: "123456",
    modusOperandi: {
      TipomodusoperandiID: "4d6928f6-a3c5-11ec-816d-16c2a030bb97",
      Descripcion: null,
      Nombre: "EN BANDA",
    },
    causaCaratula: {
      TipocausacaratulaID: "fc2db6c2-85f7-11ed-8410-0242ac120003",
      Descripcion: null,
      Nombre: "nuevo delito",
      TipoCaratula: "Delito",
    },
    listaArticulos: [],
    causaJuzgado: null,
    ActuacionUfi: {
      TipoufiID: "ufi34fb5-c013-11ec-8878-16c2a030bb97",
      Fechainivig: "2022-07-06 13:22:00",
      Fechafinvig: null,
      Numero: "3",
    },
    Sitio: { TipoSitioID: "tipo-sitio-id-0001" },
    prosecutor: {
      PersonalfiscalID: "159d607f-ff05-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Adrian Riveros",
      Jerarquia: "Fiscal",
    },
    assistant: {
      PersonalfiscalID: "b8d73615-ff06-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Solera Alejandro",
      Jerarquia: "Ayudante",
    },
    id: null,
    saveStatus: "new",
    timer: false,
    isSaving: false,
    type: null,
    deposition:
      "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar ufi-establecer-paradero",
    formType: "ufi-establecer-paradero",
    dependencia: "SUB COMISARIA  E3",
    textEditsCounter: {
      Preform: 0,
      Contravener: 0,
      Postform: "",
      LegalData: "",
      instructionDecree: 0,
    },
    textEstaticos: {
      Preform: "",
      Contravener: "",
      Postform: "",
      LegalData: "",
      instructionDecree: "",
    },
    spinnerOrderTablePrintFrom: false,
    acusados: {
      list: [
        {
          arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Extraviado", nombre: "Extraviado" },
            arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
            apellido: "Rodríguez",
            nombre: "Bender Bending",
            fechaNacimiento: "18/12/1994",
            estadoCivil: { id: "2", nombre: "Casado/a" },
            domicilio: "Planet Express",
            apodo: "bender",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo extraviado",
        },
        {
          arrId: "0ab72ea4-71cb-4d9e-9744-5bd17e6226b7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Extraviado", nombre: "Extraviado" },
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "empty",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo extraviado",
        },
      ],
      emptyDoc: {
        instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
        email: "helloworld@gmail.com",
        nacionalidad: { id: 1, nombre: "ARGENTINA" },
        tipoDocumento: { id: "DNI", nombre: "DNI" },
        condicion: { id: "Extraviado", nombre: "Extraviado" },
      },
    },
    robados: {
      list: [
        {
          arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
          doc: {
            tipoEfecto: { id: "Recuperado", nombre: "Recuperado" },
            arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
            CategoriaID: "1",
            SubcategoriaID: "2d532f6b-b685-11ec-8878-16c2a030bb97",
            TipoID: "8fd03587-dfb4-11ed-9f23-0242ac120004",
            MarcaID: "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            ModeloID: "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            Anio: "2023",
            Chasis: "156",
            NumeroMotor: "1589798",
            Dominio: "asd123",
            NumeroSerie: "2235",
            Imei: "159489159",
            Abonado: "365",
            Color: "Gris",
          },
          type: "doc",
          conocido: true,
          hasIdentikit: false,
        },
        {
          arrId: "6c445767-6a60-4617-900f-dd776bfb1fee",
          doc: { newFormatEffect: true, tipoEfecto: { id: "Secuestrado", nombre: "Secuestrado" } },
          type: "empty",
          conocido: true,
          hasIdentikit: false,
        },
      ],
    },
    denunciante: {
      list: [
        {
          arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Denunciante", nombre: "Denunciante" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
            documento: "123",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Johnny",
            apellido: "Bravo",
            fechaNacimiento: "18/07/1993",
            domicilio: "Neuquén, Argentina. 1887",
            telefono: "123",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nueva víctima",
        },
        {
          arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Denunciante", nombre: "Denunciante" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nueva víctima",
        },
      ],
    },
    diligencia: [],
    DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    ActuacionUsuarioDependencia: [
      {
        ActuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
        Fechadesde: "2022-09-16 00:00:00",
        Fechahasta: null,
        ActuacionID: "cdaf7be3-35d0-11ed-9474-00ff2876ab1e",
        UsuarioID: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
        DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
        Numeroextracto: null,
        RecienEnviada: "0",
        NombreUsuario: "UserTesterE3",
        Email: "cangaleonardo@gmail.com",
        Apellido: "Test",
        Nombre: "User",
        Dni: "1111111",
      },
    ],
    actuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
    dependenciaPolicial: "SUB COMISARIA  E3",
    dependenciaDepartamento: "RAWSON",
    dependenciaDomicilio: "20 de Junio y Mistral (Fte. Plaza)",
    dependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    denunciaID: "cdac0e23-35d0-11ed-9474-00ff2876ab1e",
    tiposumarioID: "Unidades Fiscales de Investigacion D.E Establecer Paradero",
    sumarioEstado: "sin estado asignado",
    sumarioEstadoID: "sin estado asignado",
    idDependencia: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    idUser: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
  },

  //ACTUACIÓN "UFI EMERGENCIAS MÉDICAS"
  "ufi-emergencias-medicas": {
    denunciantesBD: [],
    estadoCivil: {},
    residencia: {},
    denuncia: [{ name: "InputNestor", value: "" }],
    fechaDenuncia: new Date(),
    fechaCertificadoDenuncia: null,
    denunciaText: "",
    causaNumero: "123456",
    modusOperandi: {
      TipomodusoperandiID: "4d6928f6-a3c5-11ec-816d-16c2a030bb97",
      Descripcion: null,
      Nombre: "EN BANDA",
    },
    ubicacion: "",
    preUbicacion: {
      calle: "FALSA",
      numero: "123",
      coordinates: { lat: -31.541697941234222, lng: -68.537934422493 },
    },
    moment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    preMoment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    causaCaratula: {
      TipocausacaratulaID: "fc2db6c2-85f7-11ed-8410-0242ac120003",
      Descripcion: null,
      Nombre: "nuevo delito",
      TipoCaratula: "Delito",
    },
    listaArticulos: [],
    causaJuzgado: null,
    ActuacionUfi: {
      TipoufiID: "ufi34fb5-c013-11ec-8878-16c2a030bb97",
      Fechainivig: "2022-07-06 13:22:00",
      Fechafinvig: null,
      Numero: "3",
    },
    Sitio: { TipoSitioID: "tipo-sitio-id-0001" },
    prosecutor: {
      PersonalfiscalID: "159d607f-ff05-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Adrian Riveros",
      Jerarquia: "Fiscal",
    },
    assistant: {
      PersonalfiscalID: "b8d73615-ff06-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Solera Alejandro",
      Jerarquia: "Ayudante",
    },
    id: null,
    saveStatus: "new",
    timer: false,
    isSaving: false,
    type: null,
    deposition:
      "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar ufi-emergencias-medicas",
    formType: "ufi-emergencias-medicas",
    dependencia: "SUB COMISARIA  E3",
    PersonalInterviniente: [
      {
        nombre: "jefe gorgory",
        jerarquia: { id: "4", nombre: "Sargento" },
        dependencia: "Ptp Policial Tamberias Calingasta",
      },
    ],
    textEditsCounter: {
      Preform: 0,
      Contravener: 0,
      Postform: "",
      LegalData: "",
      instructionDecree: 0,
    },
    textEstaticos: {
      Preform: "",
      Contravener: "",
      Postform: "",
      LegalData: "",
      instructionDecree: "",
    },
    spinnerOrderTablePrintFrom: false,
    robados: {
      list: [
        {
          arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
          doc: {
            tipoEfecto: { id: "Recuperado", nombre: "Recuperado" },
            arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
            CategoriaID: "1",
            SubcategoriaID: "2d532f6b-b685-11ec-8878-16c2a030bb97",
            TipoID: "8fd03587-dfb4-11ed-9f23-0242ac120004",
            MarcaID: "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            ModeloID: "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            Anio: "2023",
            Chasis: "156",
            NumeroMotor: "1589798",
            Dominio: "asd123",
            NumeroSerie: "2235",
            Imei: "159489159",
            Abonado: "365",
            Color: "Gris",
          },
          type: "doc",
          conocido: true,
          hasIdentikit: false,
        },
        {
          arrId: "6c445767-6a60-4617-900f-dd776bfb1fee",
          doc: { newFormatEffect: true, tipoEfecto: { id: "Secuestrado", nombre: "Secuestrado" } },
          type: "empty",
          conocido: true,
          hasIdentikit: false,
        },
      ],
    },
    denunciante: {
      list: [
        {
          arrId: "13f5f49f-d15f-4cf4-b1bc-3e79a70e2252",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: "69", nombre: "FRANCIA" },
            condicion: { id: "Fallecido", nombre: "Fallecido" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "5", nombre: "Viudo/a" },
            arrId: "13f5f49f-d15f-4cf4-b1bc-3e79a70e2252",
            documento: "1234567",
            sexo: { id: "M", nombre: "Masculino" },
            apellido: "Selección de fútbol",
            nombre: "de Francia",
            fechaNacimiento: "1919/001",
            domicilio: "Federación Francesa de Fútbol (FFF)",
            telefono: "111111",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nuevo damnificado/a y/o fallecido",
        },
        {
          arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
            documento: "123",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Johnny",
            apellido: "Bravo",
            fechaNacimiento: "18/07/1993",
            domicilio: "Neuquén, Argentina. 1887",
            telefono: "123",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nueva víctima",
        },
        {
          arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Fallecido", nombre: "Fallecido" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nueva víctima",
        },
      ],
    },
    diligencia: [],
    DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    ActuacionUsuarioDependencia: [
      {
        ActuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
        Fechadesde: "2022-09-16 00:00:00",
        Fechahasta: null,
        ActuacionID: "cdaf7be3-35d0-11ed-9474-00ff2876ab1e",
        UsuarioID: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
        DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
        Numeroextracto: null,
        RecienEnviada: "0",
        NombreUsuario: "UserTesterE3",
        Email: "cangaleonardo@gmail.com",
        Apellido: "Test",
        Nombre: "User",
        Dni: "1111111",
      },
    ],
    actuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
    dependenciaPolicial: "SUB COMISARIA  E3",
    dependenciaDepartamento: "RAWSON",
    dependenciaDomicilio: "20 de Junio y Mistral (Fte. Plaza)",
    dependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    denunciaID: "cdac0e23-35d0-11ed-9474-00ff2876ab1e",
    tiposumarioID: "Unidades Fiscales de Investigacion D.E Emergencias Medicas",
    sumarioEstado: "sin estado asignado",
    sumarioEstadoID: "sin estado asignado",
    idDependencia: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    idUser: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
  },

  //ACTUACIÓN "UFI SINIESTRO VIAL"
  "ufi-siniestro-vial": {
    denunciantesBD: [],
    ubicacion: "",
    preUbicacion: {
      calle: "FALSA",
      numero: "123",
      coordinates: { lat: -31.541697941234222, lng: -68.537934422493 },
    },
    moment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    preMoment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    estadoCivil: {},
    residencia: {},
    denuncia: [{ name: "InputNestor", value: "" }],
    fechaDenuncia: new Date(),
    fechaCertificadoDenuncia: null,
    denunciaText: "",
    causaNumero: "123456",
    modusOperandi: {
      TipomodusoperandiID: "4d6928f6-a3c5-11ec-816d-16c2a030bb97",
      Descripcion: null,
      Nombre: "EN BANDA",
    },
    causaCaratula: {
      TipocausacaratulaID: "fc2db6c2-85f7-11ed-8410-0242ac120003",
      Descripcion: null,
      Nombre: "nuevo delito",
      TipoCaratula: "Delito",
    },
    listaArticulos: [],
    causaJuzgado: null,
    ActuacionUfi: {
      TipoufiID: "ufi34fb5-c013-11ec-8878-16c2a030bb97",
      Fechainivig: "2022-07-06 13:22:00",
      Fechafinvig: null,
      Numero: "3",
    },
    Sitio: { TipoSitioID: "tipo-sitio-id-0001" },
    prosecutor: {
      PersonalfiscalID: "159d607f-ff05-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Adrian Riveros",
      Jerarquia: "Fiscal",
    },
    assistant: {
      PersonalfiscalID: "b8d73615-ff06-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Solera Alejandro",
      Jerarquia: "Ayudante",
    },
    id: null,
    saveStatus: "new",
    timer: false,
    isSaving: false,
    type: null,
    deposition:
      "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar ufi-siniestro-vial",
    formType: "ufi-siniestro-vial",
    dependencia: "SUB COMISARIA  E3",
    PersonalInterviniente: [
      {
        nombre: "jefe gorgory",
        jerarquia: { id: "4", nombre: "Sargento" },
        dependencia: "Ptp Policial Tamberias Calingasta",
      },
    ],
    textEditsCounter: {
      Preform: 0,
      Contravener: 0,
      Postform: "",
      LegalData: "",
      instructionDecree: 0,
    },
    textEstaticos: {
      Preform: "",
      Contravener: "",
      Postform: "",
      LegalData: "",
      instructionDecree: "",
    },
    spinnerOrderTablePrintFrom: false,
    acusados: {
      list: [
        {
          arrId: "a9f804a4-30fc-4a0b-8e28-af2cb728e8b3",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Acusado", nombre: "Acusado" },
            arrId: "a9f804a4-30fc-4a0b-8e28-af2cb728e8b3",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "",
          filiacionDesconocida: true,
        },
        {
          arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Aprehendido", nombre: "Aprehendido" },
            email: "loremipsum@yahoo.com",
            arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
            apellido: "Rodríguez",
            nombre: "Bender Bending",
            fechaNacimiento: "18/12/1994",
            estadoCivil: { id: "2", nombre: "Casado/a" },
            domicilio: "Planet Express",
            apodo: "bender",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo Aprehendido",
        },
        {
          arrId: "0ab72ea4-71cb-4d9e-9744-5bd17e6226b7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Aprehendido", nombre: "Aprehendido" },
            email: "loremipsum@yahoo.com",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "empty",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo Aprehendido",
        },
      ],
      emptyDoc: {
        instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
        email: "helloworld@gmail.com",
        nacionalidad: { id: 1, nombre: "ARGENTINA" },
        tipoDocumento: { id: "DNI", nombre: "DNI" },
        condicion: { id: "Aprehendido", nombre: "Aprehendido" },
        email: "loremipsum@yahoo.com",
      },
    },
    robados: {
      list: [
        {
          arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
          doc: {
            tipoEfecto: { id: "Recuperado", nombre: "Recuperado" },
            arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
            CategoriaID: "1",
            SubcategoriaID: "2d532f6b-b685-11ec-8878-16c2a030bb97",
            TipoID: "8fd03587-dfb4-11ed-9f23-0242ac120004",
            MarcaID: "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            ModeloID: "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            Anio: "2023",
            Chasis: "156",
            NumeroMotor: "1589798",
            Dominio: "asd123",
            NumeroSerie: "2235",
            Imei: "159489159",
            Abonado: "365",
            Color: "Gris",
          },
          type: "doc",
          conocido: true,
          hasIdentikit: false,
        },
        {
          arrId: "6c445767-6a60-4617-900f-dd776bfb1fee",
          doc: { newFormatEffect: true, tipoEfecto: { id: "Secuestrado", nombre: "Secuestrado" } },
          type: "empty",
          conocido: true,
          hasIdentikit: false,
        },
      ],
    },
    denunciante: {
      list: [
        {
          arrId: "13f5f49f-d15f-4cf4-b1bc-3e79a70e2252",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: "69", nombre: "FRANCIA" },
            condicion: { id: "Fallecido", nombre: "Fallecido" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "5", nombre: "Viudo/a" },
            arrId: "13f5f49f-d15f-4cf4-b1bc-3e79a70e2252",
            documento: "1234567",
            sexo: { id: "M", nombre: "Masculino" },
            apellido: "Selección de fútbol",
            nombre: "de Francia",
            fechaNacimiento: "1919/001",
            domicilio: "Federación Francesa de Fútbol (FFF)",
            telefono: "111111",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nuevo damnificado/a y/o fallecido",
        },
        {
          arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
            documento: "123",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Johnny",
            apellido: "Bravo",
            fechaNacimiento: "18/07/1993",
            domicilio: "Neuquén, Argentina. 1887",
            telefono: "123",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nueva víctima",
        },
        {
          arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Fallecido", nombre: "Fallecido" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nueva víctima",
        },
      ],
    },
    diligencia: [],
    DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    ActuacionUsuarioDependencia: [
      {
        ActuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
        Fechadesde: "2022-09-16 00:00:00",
        Fechahasta: null,
        ActuacionID: "cdaf7be3-35d0-11ed-9474-00ff2876ab1e",
        UsuarioID: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
        DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
        Numeroextracto: null,
        RecienEnviada: "0",
        NombreUsuario: "UserTesterE3",
        Email: "cangaleonardo@gmail.com",
        Apellido: "Test",
        Nombre: "User",
        Dni: "1111111",
      },
    ],
    actuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
    dependenciaPolicial: "SUB COMISARIA  E3",
    dependenciaDepartamento: "RAWSON",
    dependenciaDomicilio: "20 de Junio y Mistral (Fte. Plaza)",
    dependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    denunciaID: "cdac0e23-35d0-11ed-9474-00ff2876ab1e",
    tiposumarioID: "Unidades Fiscales de Investigacion D.E Siniestro Vial",
    sumarioEstado: "sin estado asignado",
    sumarioEstadoID: "sin estado asignado",
    idDependencia: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    idUser: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
  },

  //ACTUACIÓN "UFI OTROS"
  "ufi-otros": {
    denunciantesBD: [],
    ubicacion: "",
    preUbicacion: {
      calle: "FALSA",
      numero: "123",
      coordinates: { lat: -31.541697941234222, lng: -68.537934422493 },
    },
    moment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    preMoment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    estadoCivil: {},
    residencia: {},
    denuncia: [{ name: "InputNestor", value: "" }],
    fechaDenuncia: new Date(),
    fechaCertificadoDenuncia: null,
    denunciaText: "",
    causaNumero: "123456",
    modusOperandi: {
      TipomodusoperandiID: "4d6928f6-a3c5-11ec-816d-16c2a030bb97",
      Descripcion: null,
      Nombre: "EN BANDA",
    },
    causaCaratula: {
      TipocausacaratulaID: "fc2db6c2-85f7-11ed-8410-0242ac120003",
      Descripcion: null,
      Nombre: "nuevo delito",
      TipoCaratula: "Delito",
    },
    listaArticulos: [],
    causaJuzgado: null,
    ActuacionUfi: {
      TipoufiID: "ufi34fb5-c013-11ec-8878-16c2a030bb97",
      Fechainivig: "2022-07-06 13:22:00",
      Fechafinvig: null,
      Numero: "3",
    },
    Sitio: { TipoSitioID: "tipo-sitio-id-0001" },
    prosecutor: {
      PersonalfiscalID: "159d607f-ff05-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Adrian Riveros",
      Jerarquia: "Fiscal",
    },
    assistant: {
      PersonalfiscalID: "b8d73615-ff06-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Solera Alejandro",
      Jerarquia: "Ayudante",
    },
    id: null,
    saveStatus: "new",
    timer: false,
    isSaving: false,
    type: null,
    deposition:
      "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar ufi-otros",
    formType: "ufi-otros",
    dependencia: "SUB COMISARIA  E3",
    PersonalInterviniente: [
      {
        nombre: "jefe gorgory",
        jerarquia: { id: "4", nombre: "Sargento" },
        dependencia: "Ptp Policial Tamberias Calingasta",
      },
    ],
    textEditsCounter: {
      Preform: 0,
      Contravener: 0,
      Postform: "",
      LegalData: "",
      instructionDecree: 0,
    },
    textEstaticos: {
      Preform: "",
      Contravener: "",
      Postform: "",
      LegalData: "",
      instructionDecree: "",
    },
    spinnerOrderTablePrintFrom: false,
    acusados: {
      list: [
        {
          arrId: "a9f804a4-30fc-4a0b-8e28-af2cb728e8b3",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Acusado", nombre: "Acusado" },
            arrId: "a9f804a4-30fc-4a0b-8e28-af2cb728e8b3",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "",
          filiacionDesconocida: true,
        },
        {
          arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Aprehendido", nombre: "Aprehendido" },
            email: "loremipsum@yahoo.com",
            arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
            apellido: "Rodríguez",
            nombre: "Bender Bending",
            fechaNacimiento: "18/12/1994",
            estadoCivil: { id: "2", nombre: "Casado/a" },
            domicilio: "Planet Express",
            apodo: "bender",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo Aprehendido",
        },
        {
          arrId: "0ab72ea4-71cb-4d9e-9744-5bd17e6226b7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Aprehendido", nombre: "Aprehendido" },
            email: "loremipsum@yahoo.com",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "empty",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo Aprehendido",
        },
      ],
      emptyDoc: {
        instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
        email: "helloworld@gmail.com",
        nacionalidad: { id: 1, nombre: "ARGENTINA" },
        tipoDocumento: { id: "DNI", nombre: "DNI" },
        condicion: { id: "Aprehendido", nombre: "Aprehendido" },
        email: "loremipsum@yahoo.com",
      },
    },
    robados: {
      list: [
        {
          arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
          doc: {
            tipoEfecto: { id: "Recuperado", nombre: "Recuperado" },
            arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
            CategoriaID: "1",
            SubcategoriaID: "2d532f6b-b685-11ec-8878-16c2a030bb97",
            TipoID: "8fd03587-dfb4-11ed-9f23-0242ac120004",
            MarcaID: "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            ModeloID: "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            Anio: "2023",
            Chasis: "156",
            NumeroMotor: "1589798",
            Dominio: "asd123",
            NumeroSerie: "2235",
            Imei: "159489159",
            Abonado: "365",
            Color: "Gris",
          },
          type: "doc",
          conocido: true,
          hasIdentikit: false,
        },
        {
          arrId: "6c445767-6a60-4617-900f-dd776bfb1fee",
          doc: { newFormatEffect: true, tipoEfecto: { id: "Secuestrado", nombre: "Secuestrado" } },
          type: "empty",
          conocido: true,
          hasIdentikit: false,
        },
      ],
    },
    denunciante: {
      list: [
        {
          arrId: "13f5f49f-d15f-4cf4-b1bc-3e79a70e2252",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: "69", nombre: "FRANCIA" },
            condicion: { id: "Fallecido", nombre: "Fallecido" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "5", nombre: "Viudo/a" },
            arrId: "13f5f49f-d15f-4cf4-b1bc-3e79a70e2252",
            documento: "1234567",
            sexo: { id: "M", nombre: "Masculino" },
            apellido: "Selección de fútbol",
            nombre: "de Francia",
            fechaNacimiento: "1919/001",
            domicilio: "Federación Francesa de Fútbol (FFF)",
            telefono: "111111",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nuevo damnificado/a y/o fallecido",
        },
        {
          arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
            documento: "123",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Johnny",
            apellido: "Bravo",
            fechaNacimiento: "18/07/1993",
            domicilio: "Neuquén, Argentina. 1887",
            telefono: "123",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nueva víctima",
        },
        {
          arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Fallecido", nombre: "Fallecido" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nueva víctima",
        },
      ],
    },
    diligencia: [],
    DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    ActuacionUsuarioDependencia: [
      {
        ActuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
        Fechadesde: "2022-09-16 00:00:00",
        Fechahasta: null,
        ActuacionID: "",
        UsuarioID: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
        DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
        Numeroextracto: null,
        RecienEnviada: "0",
        NombreUsuario: "UserTesterE3",
        Email: "cangaleonardo@gmail.com",
        Apellido: "Test",
        Nombre: "User",
        Dni: "1111111",
      },
    ],
    actuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
    dependenciaPolicial: "SUB COMISARIA  E3",
    dependenciaDepartamento: "RAWSON",
    dependenciaDomicilio: "20 de Junio y Mistral (Fte. Plaza)",
    dependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    denunciaID: "cdac0e23-35d0-11ed-9474-00ff2876ab1e",
    tiposumarioID: "Unidades Fiscales de Investigacion D.E Otros",
    sumarioEstado: "sin estado asignado",
    sumarioEstadoID: "sin estado asignado",
    idDependencia: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    idUser: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
  },

  //ACTUACIÓN "UFI AHORCAMIENTO O SUICIDIO"
  "ufi-ahorcamiento-suicidio": {
    denunciantesBD: [],
    ubicacion: "",
    preUbicacion: {
      calle: "FALSA",
      numero: "123",
      coordinates: { lat: -31.541697941234222, lng: -68.537934422493 },
    },
    moment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    preMoment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    estadoCivil: {},
    residencia: {},
    denuncia: [{ name: "InputNestor", value: "" }],
    fechaDenuncia: new Date(),
    fechaCertificadoDenuncia: null,
    denunciaText: "",
    causaNumero: "123456",
    modusOperandi: {
      TipomodusoperandiID: "4d6928f6-a3c5-11ec-816d-16c2a030bb97",
      Descripcion: null,
      Nombre: "EN BANDA",
    },
    causaCaratula: {
      TipocausacaratulaID: "fc2db6c2-85f7-11ed-8410-0242ac120003",
      Descripcion: null,
      Nombre: "nuevo delito",
      TipoCaratula: "Delito",
    },
    listaArticulos: [],
    causaJuzgado: null,
    ActuacionUfi: {
      TipoufiID: "ufi34fb5-c013-11ec-8878-16c2a030bb97",
      Fechainivig: "2022-07-06 13:22:00",
      Fechafinvig: null,
      Numero: "3",
    },
    Sitio: { TipoSitioID: "tipo-sitio-id-0001" },
    prosecutor: {
      PersonalfiscalID: "159d607f-ff05-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Adrian Riveros",
      Jerarquia: "Fiscal",
    },
    assistant: {
      PersonalfiscalID: "b8d73615-ff06-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Solera Alejandro",
      Jerarquia: "Ayudante",
    },
    id: null,
    saveStatus: "new",
    timer: false,
    isSaving: false,
    type: null,
    deposition:
      "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar ufi-ahorcamiento-suicidio",
    formType: "ufi-ahorcamiento-suicidio",
    dependencia: "SUB COMISARIA  E3",
    PersonalInterviniente: [
      {
        nombre: "jefe gorgory",
        jerarquia: { id: "4", nombre: "Sargento" },
        dependencia: "Ptp Policial Tamberias Calingasta",
      },
    ],
    textEditsCounter: {
      Preform: 0,
      Contravener: 0,
      Postform: "",
      LegalData: "",
      instructionDecree: 0,
    },
    textEstaticos: {
      Preform: "",
      Contravener: "",
      Postform: "",
      LegalData: "",
      instructionDecree: "",
    },
    spinnerOrderTablePrintFrom: false,
    robados: {
      list: [
        {
          arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
          doc: {
            tipoEfecto: { id: "Recuperado", nombre: "Recuperado" },
            arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
            CategoriaID: "1",
            SubcategoriaID: "2d532f6b-b685-11ec-8878-16c2a030bb97",
            TipoID: "8fd03587-dfb4-11ed-9f23-0242ac120004",
            MarcaID: "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            ModeloID: "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            Anio: "2023",
            Chasis: "156",
            NumeroMotor: "1589798",
            Dominio: "asd123",
            NumeroSerie: "2235",
            Imei: "159489159",
            Abonado: "365",
            Color: "Gris",
          },
          type: "doc",
          conocido: true,
          hasIdentikit: false,
        },
        {
          arrId: "6c445767-6a60-4617-900f-dd776bfb1fee",
          doc: { newFormatEffect: true, tipoEfecto: { id: "Secuestrado", nombre: "Secuestrado" } },
          type: "empty",
          conocido: true,
          hasIdentikit: false,
        },
      ],
    },
    denunciante: {
      list: [
        {
          arrId: "13f5f49f-d15f-4cf4-b1bc-3e79a70e2252",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: "69", nombre: "FRANCIA" },
            condicion: { id: "Fallecido", nombre: "Fallecido" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "5", nombre: "Viudo/a" },
            arrId: "13f5f49f-d15f-4cf4-b1bc-3e79a70e2252",
            documento: "1234567",
            sexo: { id: "M", nombre: "Masculino" },
            apellido: "Selección de fútbol",
            nombre: "de Francia",
            fechaNacimiento: "1919/001",
            domicilio: "Federación Francesa de Fútbol (FFF)",
            telefono: "111111",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nuevo damnificado/a y/o fallecido",
        },
        {
          arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
            documento: "123",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Johnny",
            apellido: "Bravo",
            fechaNacimiento: "18/07/1993",
            domicilio: "Neuquén, Argentina. 1887",
            telefono: "123",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nueva víctima",
        },
        {
          arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Fallecido", nombre: "Fallecido" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nueva víctima",
        },
      ],
    },
    diligencia: [],
    DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    ActuacionUsuarioDependencia: [
      {
        ActuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
        Fechadesde: "2022-09-16 00:00:00",
        Fechahasta: null,
        ActuacionID: "cdaf7be3-35d0-11ed-9474-00ff2876ab1e",
        UsuarioID: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
        DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
        Numeroextracto: null,
        RecienEnviada: "0",
        NombreUsuario: "UserTesterE3",
        Email: "cangaleonardo@gmail.com",
        Apellido: "Test",
        Nombre: "User",
        Dni: "1111111",
      },
    ],
    actuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
    dependenciaPolicial: "SUB COMISARIA  E3",
    dependenciaDepartamento: "RAWSON",
    dependenciaDomicilio: "20 de Junio y Mistral (Fte. Plaza)",
    dependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    denunciaID: "cdac0e23-35d0-11ed-9474-00ff2876ab1e",
    tiposumarioID: "Unidades Fiscales de Investigacion D.E Ahorcamiento o Suicidio",
    sumarioEstado: "sin estado asignado",
    sumarioEstadoID: "sin estado asignado",
    idDependencia: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    idUser: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
  },

  //ACTUACIÓN "UFI INTOXICACIÓN"
  "ufi-intoxicacion": {
    denunciantesBD: [],
    ubicacion: "",
    preUbicacion: {
      calle: "FALSA",
      numero: "123",
      coordinates: { lat: -31.541697941234222, lng: -68.537934422493 },
    },
    moment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    preMoment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    estadoCivil: {},
    residencia: {},
    denuncia: [{ name: "InputNestor", value: "" }],
    fechaDenuncia: new Date(),
    fechaCertificadoDenuncia: null,
    denunciaText: "",
    causaNumero: "123456",
    modusOperandi: {
      TipomodusoperandiID: "4d6928f6-a3c5-11ec-816d-16c2a030bb97",
      Descripcion: null,
      Nombre: "EN BANDA",
    },
    causaCaratula: {
      TipocausacaratulaID: "fc2db6c2-85f7-11ed-8410-0242ac120003",
      Descripcion: null,
      Nombre: "nuevo delito",
      TipoCaratula: "Delito",
    },
    listaArticulos: [],
    causaJuzgado: null,
    ActuacionUfi: {
      TipoufiID: "ufi34fb5-c013-11ec-8878-16c2a030bb97",
      Fechainivig: "2022-07-06 13:22:00",
      Fechafinvig: null,
      Numero: "3",
    },
    Sitio: { TipoSitioID: "tipo-sitio-id-0001" },
    prosecutor: {
      PersonalfiscalID: "159d607f-ff05-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Adrian Riveros",
      Jerarquia: "Fiscal",
    },
    assistant: {
      PersonalfiscalID: "b8d73615-ff06-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Solera Alejandro",
      Jerarquia: "Ayudante",
    },
    id: null,
    saveStatus: "new",
    timer: false,
    isSaving: false,
    type: null,
    deposition:
      "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar ufi-intoxicacion",
    formType: "ufi-intoxicacion",
    dependencia: "SUB COMISARIA  E3",
    PersonalInterviniente: [
      {
        nombre: "jefe gorgory",
        jerarquia: { id: "4", nombre: "Sargento" },
        dependencia: "Ptp Policial Tamberias Calingasta",
      },
    ],
    textEditsCounter: {
      Preform: 0,
      Contravener: 0,
      Postform: "",
      LegalData: "",
      instructionDecree: 0,
    },
    textEstaticos: {
      Preform: "",
      Contravener: "",
      Postform: "",
      LegalData: "",
      instructionDecree: "",
    },
    spinnerOrderTablePrintFrom: false,
    robados: {
      list: [
        {
          arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
          doc: {
            tipoEfecto: { id: "Recuperado", nombre: "Recuperado" },
            arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
            CategoriaID: "1",
            SubcategoriaID: "2d532f6b-b685-11ec-8878-16c2a030bb97",
            TipoID: "8fd03587-dfb4-11ed-9f23-0242ac120004",
            MarcaID: "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            ModeloID: "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            Anio: "2023",
            Chasis: "156",
            NumeroMotor: "1589798",
            Dominio: "asd123",
            NumeroSerie: "2235",
            Imei: "159489159",
            Abonado: "365",
            Color: "Gris",
          },
          type: "doc",
          conocido: true,
          hasIdentikit: false,
        },
        {
          arrId: "6c445767-6a60-4617-900f-dd776bfb1fee",
          doc: { newFormatEffect: true, tipoEfecto: { id: "Secuestrado", nombre: "Secuestrado" } },
          type: "empty",
          conocido: true,
          hasIdentikit: false,
        },
      ],
    },
    denunciante: {
      list: [
        {
          arrId: "13f5f49f-d15f-4cf4-b1bc-3e79a70e2252",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: "69", nombre: "FRANCIA" },
            condicion: { id: "Fallecido", nombre: "Fallecido" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "5", nombre: "Viudo/a" },
            arrId: "13f5f49f-d15f-4cf4-b1bc-3e79a70e2252",
            documento: "1234567",
            sexo: { id: "M", nombre: "Masculino" },
            apellido: "Selección de fútbol",
            nombre: "de Francia",
            fechaNacimiento: "1919/001",
            domicilio: "Federación Francesa de Fútbol (FFF)",
            telefono: "111111",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nuevo damnificado/a y/o fallecido",
        },
        {
          arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
            documento: "123",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Johnny",
            apellido: "Bravo",
            fechaNacimiento: "18/07/1993",
            domicilio: "Neuquén, Argentina. 1887",
            telefono: "123",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nueva víctima",
        },
        {
          arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Fallecido", nombre: "Fallecido" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nueva víctima",
        },
      ],
    },
    diligencia: [],
    DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    ActuacionUsuarioDependencia: [
      {
        ActuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
        Fechadesde: "2022-09-16 00:00:00",
        Fechahasta: null,
        ActuacionID: "cdaf7be3-35d0-11ed-9474-00ff2876ab1e",
        UsuarioID: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
        DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
        Numeroextracto: null,
        RecienEnviada: "0",
        NombreUsuario: "UserTesterE3",
        Email: "cangaleonardo@gmail.com",
        Apellido: "Test",
        Nombre: "User",
        Dni: "1111111",
      },
    ],
    actuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
    dependenciaPolicial: "SUB COMISARIA  E3",
    dependenciaDepartamento: "RAWSON",
    dependenciaDomicilio: "20 de Junio y Mistral (Fte. Plaza)",
    dependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    denunciaID: "cdac0e23-35d0-11ed-9474-00ff2876ab1e",
    tiposumarioID: "Unidades Fiscales de Investigacion D.E Intoxicacion",
    sumarioEstado: "sin estado asignado",
    sumarioEstadoID: "sin estado asignado",
    idDependencia: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    idUser: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
  },

  //ACTUACIÓN "UFI INCENDIO EN VIVIENDA"
  "ufi-incendio-vivienda": {
    denunciantesBD: [],
    ubicacion: "",
    preUbicacion: {
      calle: "FALSA",
      numero: "123",
      coordinates: { lat: -31.541697941234222, lng: -68.537934422493 },
    },
    moment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    preMoment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    estadoCivil: {},
    residencia: {},
    denuncia: [{ name: "InputNestor", value: "" }],
    fechaDenuncia: new Date(),
    fechaCertificadoDenuncia: null,
    denunciaText: "",
    causaNumero: "123456",
    modusOperandi: {
      TipomodusoperandiID: "4d6928f6-a3c5-11ec-816d-16c2a030bb97",
      Descripcion: null,
      Nombre: "EN BANDA",
    },
    causaCaratula: {
      TipocausacaratulaID: "fc2db6c2-85f7-11ed-8410-0242ac120003",
      Descripcion: null,
      Nombre: "nuevo delito",
      TipoCaratula: "Delito",
    },
    listaArticulos: [],
    causaJuzgado: null,
    ActuacionUfi: {
      TipoufiID: "ufi34fb5-c013-11ec-8878-16c2a030bb97",
      Fechainivig: "2022-07-06 13:22:00",
      Fechafinvig: null,
      Numero: "3",
    },
    Sitio: { TipoSitioID: "tipo-sitio-id-0001" },
    prosecutor: {
      PersonalfiscalID: "159d607f-ff05-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Adrian Riveros",
      Jerarquia: "Fiscal",
    },
    assistant: {
      PersonalfiscalID: "b8d73615-ff06-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Solera Alejandro",
      Jerarquia: "Ayudante",
    },
    id: null,
    saveStatus: "new",
    timer: false,
    isSaving: false,
    type: null,
    deposition:
      "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar ufi-incendio-vivienda",
    formType: "ufi-incendio-vivienda",
    dependencia: "SUB COMISARIA  E3",
    PersonalInterviniente: [
      {
        nombre: "jefe gorgory",
        jerarquia: { id: "4", nombre: "Sargento" },
        dependencia: "Ptp Policial Tamberias Calingasta",
      },
    ],
    textEditsCounter: {
      Preform: 0,
      Contravener: 0,
      Postform: "",
      LegalData: "",
      instructionDecree: 0,
    },
    textEstaticos: {
      Preform: "",
      Contravener: "",
      Postform: "",
      LegalData: "",
      instructionDecree: "",
    },
    spinnerOrderTablePrintFrom: false,
    robados: {
      list: [
        {
          arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
          doc: {
            tipoEfecto: { id: "Recuperado", nombre: "Recuperado" },
            arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
            CategoriaID: "1",
            SubcategoriaID: "2d532f6b-b685-11ec-8878-16c2a030bb97",
            TipoID: "8fd03587-dfb4-11ed-9f23-0242ac120004",
            MarcaID: "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            ModeloID: "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            Anio: "2023",
            Chasis: "156",
            NumeroMotor: "1589798",
            Dominio: "asd123",
            NumeroSerie: "2235",
            Imei: "159489159",
            Abonado: "365",
            Color: "Gris",
          },
          type: "doc",
          conocido: true,
          hasIdentikit: false,
        },
        {
          arrId: "6c445767-6a60-4617-900f-dd776bfb1fee",
          doc: { newFormatEffect: true, tipoEfecto: { id: "Secuestrado", nombre: "Secuestrado" } },
          type: "empty",
          conocido: true,
          hasIdentikit: false,
        },
      ],
    },
    denunciante: {
      list: [
        {
          arrId: "13f5f49f-d15f-4cf4-b1bc-3e79a70e2252",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: "69", nombre: "FRANCIA" },
            condicion: { id: "Fallecido", nombre: "Fallecido" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "5", nombre: "Viudo/a" },
            arrId: "13f5f49f-d15f-4cf4-b1bc-3e79a70e2252",
            documento: "1234567",
            sexo: { id: "M", nombre: "Masculino" },
            apellido: "Selección de fútbol",
            nombre: "de Francia",
            fechaNacimiento: "1919/001",
            domicilio: "Federación Francesa de Fútbol (FFF)",
            telefono: "111111",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nuevo damnificado/a y/o fallecido",
        },
        {
          arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
            documento: "123",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Johnny",
            apellido: "Bravo",
            fechaNacimiento: "18/07/1993",
            domicilio: "Neuquén, Argentina. 1887",
            telefono: "123",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nueva víctima",
        },
        {
          arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Fallecido", nombre: "Fallecido" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nueva víctima",
        },
      ],
    },
    diligencia: [],
    DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    ActuacionUsuarioDependencia: [
      {
        ActuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
        Fechadesde: "2022-09-16 00:00:00",
        Fechahasta: null,
        ActuacionID: "cdaf7be3-35d0-11ed-9474-00ff2876ab1e",
        UsuarioID: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
        DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
        Numeroextracto: null,
        RecienEnviada: "0",
        NombreUsuario: "UserTesterE3",
        Email: "cangaleonardo@gmail.com",
        Apellido: "Test",
        Nombre: "User",
        Dni: "1111111",
      },
    ],
    actuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
    dependenciaPolicial: "SUB COMISARIA  E3",
    dependenciaDepartamento: "RAWSON",
    dependenciaDomicilio: "20 de Junio y Mistral (Fte. Plaza)",
    dependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    denunciaID: "cdac0e23-35d0-11ed-9474-00ff2876ab1e",
    tiposumarioID: "Unidades Fiscales de Investigacion D.E Incendio en Vivienda",
    sumarioEstado: "sin estado asignado",
    sumarioEstadoID: "sin estado asignado",
    idDependencia: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    idUser: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
  },

  //ACTUACIÓN "PRELIMINARES INCENDIO EN VIVIENDA"
  "preliminar-incendio-vivienda": {
    denunciantesBD: [],
    ubicacion: "",
    preUbicacion: {
      calle: "FALSA",
      numero: "123",
      coordinates: { lat: -31.541697941234222, lng: -68.537934422493 },
    },
    moment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    preMoment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    estadoCivil: {},
    residencia: {},
    denuncia: [{ name: "InputNestor", value: "" }],
    fechaDenuncia: new Date(),
    fechaCertificadoDenuncia: null,
    denunciaText: "",
    causaNumero: "123456",
    modusOperandi: {
      TipomodusoperandiID: "4d6928f6-a3c5-11ec-816d-16c2a030bb97",
      Descripcion: null,
      Nombre: "EN BANDA",
    },
    causaCaratula: null,
    listaArticulos: [],
    causaJuzgado: {
      JuzgadoID: "3db1cda6-cca0-11e4-8df1-0090f58f4f32",
      Fechainivig: "2021-12-23 00:00:00",
      Fechafinvig: null,
      Nombre: "JUZGADO DE PAZ ZONDA",
      Telefono: null,
      Domicilio: null,
    },
    listaCaratulas: [
      {
        TipocausacaratulaID: "2771bc5b-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ABUSO DE ARMA",
        TipoCaratula: "Causa Caratula",
      },
      {
        TipocausacaratulaID: "2a5c76f3-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ACT.PARA ESTABLECER PARADERO",
        TipoCaratula: "Causa Caratula",
      },
      {
        TipocausacaratulaID: "2b6ff555-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ACT.POR FALLECIMIENTO",
        TipoCaratula: "Causa Caratula",
      },
    ],
    id: null,
    saveStatus: "new",
    timer: false,
    isSaving: false,
    type: null,
    deposition:
      "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar preliminar-incendio-vivienda",
    formType: "preliminar-incendio-vivienda",
    dependencia: "SUB COMISARIA  E3",
    Sitio: { TipoSitioID: "tipo-sitio-id-0001" },
    PersonalInterviniente: [
      {
        nombre: "jefe gorgory",
        jerarquia: { id: "4", nombre: "Sargento" },
        dependencia: "Ptp Policial Tamberias Calingasta",
      },
    ],
    textEditsCounter: {
      Preform: 0,
      Contravener: 0,
      Postform: "",
      LegalData: "",
      instructionDecree: 0,
    },
    textEstaticos: {
      Preform: "",
      Contravener: "",
      Postform: "",
      LegalData: "",
      instructionDecree: "",
    },
    spinnerOrderTablePrintFrom: false,
    acusados: {
      list: [
        {
          arrId: "a9f804a4-30fc-4a0b-8e28-af2cb728e8b3",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Acusado", nombre: "Acusado" },
            arrId: "a9f804a4-30fc-4a0b-8e28-af2cb728e8b3",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "",
          filiacionDesconocida: true,
        },
        {
          arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Detenido", nombre: "Detenido" },
            email: "helloworld@hotmail.com",
            arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
            apellido: "Rodríguez",
            nombre: "Bender Bending",
            fechaNacimiento: "18/12/1994",
            estadoCivil: { id: "2", nombre: "Casado/a" },
            domicilio: "Planet Express",
            apodo: "bender",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo Detenido",
        },
        {
          arrId: "0ab72ea4-71cb-4d9e-9744-5bd17e6226b7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Detenido", nombre: "Detenido" },
            email: "helloworld@hotmail.com",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "empty",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo Detenido",
        },
      ],
      emptyDoc: {
        instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
        email: "helloworld@gmail.com",
        nacionalidad: { id: 1, nombre: "ARGENTINA" },
        tipoDocumento: { id: "DNI", nombre: "DNI" },
        condicion: { id: "Detenido", nombre: "Detenido" },
        email: "helloworld@hotmail.com",
      },
    },
    robados: {
      list: [
        {
          arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
          doc: {
            tipoEfecto: { id: "Recuperado", nombre: "Recuperado" },
            arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
            CategoriaID: "1",
            SubcategoriaID: "2d532f6b-b685-11ec-8878-16c2a030bb97",
            TipoID: "8fd03587-dfb4-11ed-9f23-0242ac120004",
            MarcaID: "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            ModeloID: "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            Anio: "2023",
            Chasis: "156",
            NumeroMotor: "1589798",
            Dominio: "asd123",
            NumeroSerie: "2235",
            Imei: "159489159",
            Abonado: "365",
            Color: "Gris",
          },
          type: "doc",
          conocido: true,
          hasIdentikit: false,
        },
        {
          arrId: "6c445767-6a60-4617-900f-dd776bfb1fee",
          doc: { newFormatEffect: true, tipoEfecto: { id: "Secuestrado", nombre: "Secuestrado" } },
          type: "empty",
          conocido: true,
          hasIdentikit: false,
        },
      ],
    },
    denunciante: {
      list: [
        {
          arrId: "20e7c1cd-4fff-42ef-a3a6-40102bb5109c",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Denunciante y Damnificado", nombre: "Denunciante y Damnificado" },
            email: "dolor_sit_amet@hotmail.com",
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "3", nombre: "Separado/a" },
            arrId: "20e7c1cd-4fff-42ef-a3a6-40102bb5109c",
            documento: "1234",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Marcelo",
            apellido: "UAMPA",
            fechaNacimiento: "12-06-1985",
            domicilioSIPE: " ,  CP: - , , ",
            telefono: "33333",
          },
          type: "doc",
          sipeSearch: true,
          emptyTitle: "Nuevo denunciante y/o damnificado/a",
        },
        {
          arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
            documento: "123",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Johnny",
            apellido: "Bravo",
            fechaNacimiento: "18/07/1993",
            domicilio: "Neuquén, Argentina. 1887",
            telefono: "123",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nuevo denunciante y/o damnificado/a",
        },
        {
          arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nueva víctima",
        },
      ],
    },
    diligencia: [],
    DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    ActuacionUsuarioDependencia: [
      {
        ActuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
        Fechadesde: "2022-09-16 00:00:00",
        Fechahasta: null,
        ActuacionID: "cdaf7be3-35d0-11ed-9474-00ff2876ab1e",
        UsuarioID: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
        DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
        Numeroextracto: null,
        RecienEnviada: "0",
        NombreUsuario: "UserTesterE3",
        Email: "cangaleonardo@gmail.com",
        Apellido: "Test",
        Nombre: "User",
        Dni: "1111111",
      },
    ],
    actuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
    dependenciaPolicial: "SUB COMISARIA  E3",
    dependenciaDepartamento: "RAWSON",
    dependenciaDomicilio: "20 de Junio y Mistral (Fte. Plaza)",
    dependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    denunciaID: "cdac0e23-35d0-11ed-9474-00ff2876ab1e",
    tiposumarioID: "Actuacion Preliminar por Incendio en Vivienda",
    sumarioEstado: "sin estado asignado",
    sumarioEstadoID: "sin estado asignado",
    idDependencia: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    idUser: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
  },

  //ACTUACIÓN "PRELIMINARES ESTABLECER PROCEDENCIA"
  "preliminar-establecer-procedencias": {
    denunciantesBD: [],
    estadoCivil: {},
    residencia: {},
    denuncia: [{ name: "InputNestor", value: "" }],
    fechaDenuncia: new Date(),
    fechaCertificadoDenuncia: null,
    denunciaText: "",
    causaNumero: "123456",
    modusOperandi: {
      TipomodusoperandiID: "4d6928f6-a3c5-11ec-816d-16c2a030bb97",
      Descripcion: null,
      Nombre: "EN BANDA",
    },
    ubicacion: "",
    preUbicacion: {
      calle: "FALSA",
      numero: "123",
      coordinates: { lat: -31.541697941234222, lng: -68.537934422493 },
    },
    moment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    preMoment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    causaCaratula: null,
    listaArticulos: [],
    causaJuzgado: {
      JuzgadoID: "3db1cda6-cca0-11e4-8df1-0090f58f4f32",
      Fechainivig: "2021-12-23 00:00:00",
      Fechafinvig: null,
      Nombre: "JUZGADO DE PAZ ZONDA",
      Telefono: null,
      Domicilio: null,
    },
    listaCaratulas: [
      {
        TipocausacaratulaID: "2771bc5b-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ABUSO DE ARMA",
        TipoCaratula: "Causa Caratula",
      },
      {
        TipocausacaratulaID: "2a5c76f3-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ACT.PARA ESTABLECER PARADERO",
        TipoCaratula: "Causa Caratula",
      },
      {
        TipocausacaratulaID: "2b6ff555-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ACT.POR FALLECIMIENTO",
        TipoCaratula: "Causa Caratula",
      },
    ],
    id: null,
    saveStatus: "new",
    timer: false,
    isSaving: false,
    type: null,
    deposition:
      "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar preliminar-establecer-procedencias",
    formType: "preliminar-establecer-procedencias",
    dependencia: "SUB COMISARIA  E3",
    PersonalInterviniente: [
      {
        nombre: "jefe gorgory",
        jerarquia: { id: "4", nombre: "Sargento" },
        dependencia: "Ptp Policial Tamberias Calingasta",
      },
    ],
    textEditsCounter: {
      Preform: 0,
      Contravener: 0,
      Postform: "",
      LegalData: "",
      instructionDecree: 0,
    },
    textEstaticos: {
      Preform: "",
      Contravener: "",
      Postform: "",
      LegalData: "",
      instructionDecree: "",
    },
    spinnerOrderTablePrintFrom: false,
    Sitio: { TipoSitioID: "tipo-sitio-id-0001" },
    acusados: {
      list: [
        {
          arrId: "a9f804a4-30fc-4a0b-8e28-af2cb728e8b3",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Acusado", nombre: "Acusado" },
            arrId: "a9f804a4-30fc-4a0b-8e28-af2cb728e8b3",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "",
          filiacionDesconocida: true,
        },
        {
          arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Detenido", nombre: "Detenido" },
            email: "helloworld@hotmail.com",
            arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
            apellido: "Rodríguez",
            nombre: "Bender Bending",
            fechaNacimiento: "18/12/1994",
            estadoCivil: { id: "2", nombre: "Casado/a" },
            domicilio: "Planet Express",
            apodo: "bender",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo Detenido",
        },
        {
          arrId: "0ab72ea4-71cb-4d9e-9744-5bd17e6226b7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Detenido", nombre: "Detenido" },
            email: "helloworld@hotmail.com",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "empty",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo Detenido",
        },
      ],
      emptyDoc: {
        instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
        email: "helloworld@gmail.com",
        nacionalidad: { id: 1, nombre: "ARGENTINA" },
        tipoDocumento: { id: "DNI", nombre: "DNI" },
        condicion: { id: "Detenido", nombre: "Detenido" },
        email: "helloworld@hotmail.com",
      },
    },
    robados: {
      list: [
        {
          arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
          doc: {
            tipoEfecto: { id: "Recuperado", nombre: "Recuperado" },
            arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
            CategoriaID: "1",
            SubcategoriaID: "2d532f6b-b685-11ec-8878-16c2a030bb97",
            TipoID: "8fd03587-dfb4-11ed-9f23-0242ac120004",
            MarcaID: "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            ModeloID: "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            Anio: "2023",
            Chasis: "156",
            NumeroMotor: "1589798",
            Dominio: "asd123",
            NumeroSerie: "2235",
            Imei: "159489159",
            Abonado: "365",
            Color: "Gris",
          },
          type: "doc",
          conocido: true,
          hasIdentikit: false,
        },
        {
          arrId: "6c445767-6a60-4617-900f-dd776bfb1fee",
          doc: { newFormatEffect: true, tipoEfecto: { id: "Secuestrado", nombre: "Secuestrado" } },
          type: "empty",
          conocido: true,
          hasIdentikit: false,
        },
      ],
    },
    denunciante: {
      list: [
        {
          arrId: "20e7c1cd-4fff-42ef-a3a6-40102bb5109c",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Denunciante y Damnificado", nombre: "Denunciante y Damnificado" },
            email: "dolor_sit_amet@hotmail.com",
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "3", nombre: "Separado/a" },
            arrId: "20e7c1cd-4fff-42ef-a3a6-40102bb5109c",
            documento: "1234",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Marcelo",
            apellido: "UAMPA",
            fechaNacimiento: "12-06-1985",
            domicilioSIPE: " ,  CP: - , , ",
            telefono: "33333",
          },
          type: "doc",
          sipeSearch: true,
          emptyTitle: "Nuevo denunciante y/o damnificado/a",
        },
        {
          arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
            documento: "123",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Johnny",
            apellido: "Bravo",
            fechaNacimiento: "18/07/1993",
            domicilio: "Neuquén, Argentina. 1887",
            telefono: "123",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nuevo denunciante y/o damnificado/a",
        },
        {
          arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nueva víctima",
        },
      ],
    },
    diligencia: [],
    DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    ActuacionUsuarioDependencia: [
      {
        ActuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
        Fechadesde: "2022-09-16 00:00:00",
        Fechahasta: null,
        ActuacionID: "cdaf7be3-35d0-11ed-9474-00ff2876ab1e",
        UsuarioID: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
        DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
        Numeroextracto: null,
        RecienEnviada: "0",
        NombreUsuario: "UserTesterE3",
        Email: "cangaleonardo@gmail.com",
        Apellido: "Test",
        Nombre: "User",
        Dni: "1111111",
      },
    ],
    actuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
    dependenciaPolicial: "SUB COMISARIA  E3",
    dependenciaDepartamento: "RAWSON",
    dependenciaDomicilio: "20 de Junio y Mistral (Fte. Plaza)",
    dependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    denunciaID: "cdac0e23-35d0-11ed-9474-00ff2876ab1e",
    tiposumarioID: "Actuacion Preliminar para Establecer Procedencias",
    sumarioEstado: "sin estado asignado",
    sumarioEstadoID: "sin estado asignado",
    idDependencia: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    idUser: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
  },

  //ACTUACIÓN "PRELIMINARES FUGA DE MENOR"
  "preliminar-fuga-menor": {
    denunciantesBD: [],
    ubicacion: "",
    preUbicacion: {
      calle: "FALSA",
      numero: "123",
      coordinates: { lat: -31.541697941234222, lng: -68.537934422493 },
    },
    moment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    preMoment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    estadoCivil: {},
    residencia: {},
    denuncia: [{ name: "InputNestor", value: "" }],
    fechaDenuncia: new Date(),
    fechaCertificadoDenuncia: null,
    denunciaText: "",
    causaNumero: "123456",
    modusOperandi: {
      TipomodusoperandiID: "4d6928f6-a3c5-11ec-816d-16c2a030bb97",
      Descripcion: null,
      Nombre: "EN BANDA",
    },
    causaCaratula: null,
    listaArticulos: [],
    causaJuzgado: {
      JuzgadoID: "3db1cda6-cca0-11e4-8df1-0090f58f4f32",
      Fechainivig: "2021-12-23 00:00:00",
      Fechafinvig: null,
      Nombre: "JUZGADO DE PAZ ZONDA",
      Telefono: null,
      Domicilio: null,
    },
    Sitio: { TipoSitioID: "tipo-sitio-id-0001" },
    listaCaratulas: [
      {
        TipocausacaratulaID: "2771bc5b-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ABUSO DE ARMA",
        TipoCaratula: "Causa Caratula",
      },
      {
        TipocausacaratulaID: "2a5c76f3-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ACT.PARA ESTABLECER PARADERO",
        TipoCaratula: "Causa Caratula",
      },
      {
        TipocausacaratulaID: "2b6ff555-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ACT.POR FALLECIMIENTO",
        TipoCaratula: "Causa Caratula",
      },
    ],
    id: null,
    saveStatus: "new",
    timer: false,
    isSaving: false,
    type: null,
    deposition:
      "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar preliminar-fuga-menor",
    formType: "preliminar-fuga-menor",
    dependencia: "SUB COMISARIA  E3",
    PersonalInterviniente: [
      {
        nombre: "jefe gorgory",
        jerarquia: { id: "4", nombre: "Sargento" },
        dependencia: "Ptp Policial Tamberias Calingasta",
      },
    ],
    textEditsCounter: {
      Preform: 0,
      Contravener: 0,
      Postform: "",
      LegalData: "",
      instructionDecree: 0,
    },
    textEstaticos: {
      Preform: "",
      Contravener: "",
      Postform: "",
      LegalData: "",
      instructionDecree: "",
    },
    spinnerOrderTablePrintFrom: false,
    acusados: {
      list: [
        {
          arrId: "a9f804a4-30fc-4a0b-8e28-af2cb728e8b3",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Acusado", nombre: "Acusado" },
            arrId: "a9f804a4-30fc-4a0b-8e28-af2cb728e8b3",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "",
          filiacionDesconocida: true,
        },
        {
          arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Detenido", nombre: "Detenido" },
            email: "helloworld@hotmail.com",
            arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
            apellido: "Rodríguez",
            nombre: "Bender Bending",
            fechaNacimiento: "18/12/1994",
            estadoCivil: { id: "2", nombre: "Casado/a" },
            domicilio: "Planet Express",
            apodo: "bender",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo Detenido",
        },
        {
          arrId: "0ab72ea4-71cb-4d9e-9744-5bd17e6226b7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Detenido", nombre: "Detenido" },
            email: "helloworld@hotmail.com",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "empty",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo Detenido",
        },
      ],
      emptyDoc: {
        instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
        email: "helloworld@gmail.com",
        nacionalidad: { id: 1, nombre: "ARGENTINA" },
        tipoDocumento: { id: "DNI", nombre: "DNI" },
        condicion: { id: "Detenido", nombre: "Detenido" },
        email: "helloworld@hotmail.com",
      },
    },
    robados: {
      list: [
        {
          arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
          doc: {
            tipoEfecto: { id: "Recuperado", nombre: "Recuperado" },
            arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
            CategoriaID: "1",
            SubcategoriaID: "2d532f6b-b685-11ec-8878-16c2a030bb97",
            TipoID: "8fd03587-dfb4-11ed-9f23-0242ac120004",
            MarcaID: "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            ModeloID: "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            Anio: "2023",
            Chasis: "156",
            NumeroMotor: "1589798",
            Dominio: "asd123",
            NumeroSerie: "2235",
            Imei: "159489159",
            Abonado: "365",
            Color: "Gris",
          },
          type: "doc",
          conocido: true,
          hasIdentikit: false,
        },
        {
          arrId: "6c445767-6a60-4617-900f-dd776bfb1fee",
          doc: { newFormatEffect: true, tipoEfecto: { id: "Secuestrado", nombre: "Secuestrado" } },
          type: "empty",
          conocido: true,
          hasIdentikit: false,
        },
      ],
    },
    denunciante: {
      list: [
        {
          arrId: "20e7c1cd-4fff-42ef-a3a6-40102bb5109c",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Denunciante y Damnificado", nombre: "Denunciante y Damnificado" },
            email: "dolor_sit_amet@hotmail.com",
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "3", nombre: "Separado/a" },
            arrId: "20e7c1cd-4fff-42ef-a3a6-40102bb5109c",
            documento: "1234",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Marcelo",
            apellido: "UAMPA",
            fechaNacimiento: "12-06-1985",
            domicilioSIPE: " ,  CP: - , , ",
            telefono: "33333",
          },
          type: "doc",
          sipeSearch: true,
          emptyTitle: "Nuevo denunciante y/o damnificado/a",
        },
        {
          arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
            documento: "123",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Johnny",
            apellido: "Bravo",
            fechaNacimiento: "18/07/1993",
            domicilio: "Neuquén, Argentina. 1887",
            telefono: "123",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nuevo denunciante y/o damnificado/a",
        },
        {
          arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nueva víctima",
        },
      ],
    },
    diligencia: [],
    DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    ActuacionUsuarioDependencia: [
      {
        ActuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
        Fechadesde: "2022-09-16 00:00:00",
        Fechahasta: null,
        ActuacionID: "cdaf7be3-35d0-11ed-9474-00ff2876ab1e",
        UsuarioID: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
        DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
        Numeroextracto: null,
        RecienEnviada: "0",
        NombreUsuario: "UserTesterE3",
        Email: "cangaleonardo@gmail.com",
        Apellido: "Test",
        Nombre: "User",
        Dni: "1111111",
      },
    ],
    actuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
    dependenciaPolicial: "SUB COMISARIA  E3",
    dependenciaDepartamento: "RAWSON",
    dependenciaDomicilio: "20 de Junio y Mistral (Fte. Plaza)",
    dependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    denunciaID: "cdac0e23-35d0-11ed-9474-00ff2876ab1e",
    tiposumarioID: "Actuacion Preliminar por fuga de menor",
    sumarioEstado: "sin estado asignado",
    sumarioEstadoID: "sin estado asignado",
    idDependencia: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    idUser: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
  },

  //ACTUACIÓN "PRELIMINARES INCENDIO DE AUTOMOTOR"
  "preliminar-incendio-automotor": {
    denunciantesBD: [],
    ubicacion: "",
    preUbicacion: {
      calle: "FALSA",
      numero: "123",
      coordinates: { lat: -31.541697941234222, lng: -68.537934422493 },
    },
    moment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    preMoment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    estadoCivil: {},
    residencia: {},
    denuncia: [{ name: "InputNestor", value: "" }],
    fechaDenuncia: new Date(),
    fechaCertificadoDenuncia: null,
    denunciaText: "",
    causaNumero: "123456",
    modusOperandi: {
      TipomodusoperandiID: "4d6928f6-a3c5-11ec-816d-16c2a030bb97",
      Descripcion: null,
      Nombre: "EN BANDA",
    },
    causaCaratula: null,
    listaArticulos: [],
    causaJuzgado: {
      JuzgadoID: "3db1cda6-cca0-11e4-8df1-0090f58f4f32",
      Fechainivig: "2021-12-23 00:00:00",
      Fechafinvig: null,
      Nombre: "JUZGADO DE PAZ ZONDA",
      Telefono: null,
      Domicilio: null,
    },
    listaCaratulas: [
      {
        TipocausacaratulaID: "2771bc5b-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ABUSO DE ARMA",
        TipoCaratula: "Causa Caratula",
      },
      {
        TipocausacaratulaID: "2a5c76f3-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ACT.PARA ESTABLECER PARADERO",
        TipoCaratula: "Causa Caratula",
      },
      {
        TipocausacaratulaID: "2b6ff555-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ACT.POR FALLECIMIENTO",
        TipoCaratula: "Causa Caratula",
      },
    ],
    Sitio: { TipoSitioID: "tipo-sitio-id-0001" },
    id: null,
    saveStatus: "new",
    timer: false,
    isSaving: false,
    type: null,
    deposition:
      "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar preliminar-incendio-automotor",
    formType: "preliminar-incendio-automotor",
    dependencia: "SUB COMISARIA  E3",
    PersonalInterviniente: [
      {
        nombre: "jefe gorgory",
        jerarquia: { id: "4", nombre: "Sargento" },
        dependencia: "Ptp Policial Tamberias Calingasta",
      },
    ],
    textEditsCounter: {
      Preform: 0,
      Contravener: 0,
      Postform: "",
      LegalData: "",
      instructionDecree: 0,
    },
    textEstaticos: {
      Preform: "",
      Contravener: "",
      Postform: "",
      LegalData: "",
      instructionDecree: "",
    },
    spinnerOrderTablePrintFrom: false,
    robados: {
      list: [
        {
          arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
          doc: {
            tipoEfecto: { id: "Recuperado", nombre: "Recuperado" },
            arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
            CategoriaID: "1",
            SubcategoriaID: "2d532f6b-b685-11ec-8878-16c2a030bb97",
            TipoID: "8fd03587-dfb4-11ed-9f23-0242ac120004",
            MarcaID: "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            ModeloID: "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            Anio: "2023",
            Chasis: "156",
            NumeroMotor: "1589798",
            Dominio: "asd123",
            NumeroSerie: "2235",
            Imei: "159489159",
            Abonado: "365",
            Color: "Gris",
          },
          type: "doc",
          conocido: true,
          hasIdentikit: false,
        },
        {
          arrId: "6c445767-6a60-4617-900f-dd776bfb1fee",
          doc: { newFormatEffect: true, tipoEfecto: { id: "Secuestrado", nombre: "Secuestrado" } },
          type: "empty",
          conocido: true,
          hasIdentikit: false,
        },
      ],
    },
    denunciante: {
      list: [
        {
          arrId: "20e7c1cd-4fff-42ef-a3a6-40102bb5109c",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Protagonista", nombre: "Protagonista" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "3", nombre: "Separado/a" },
            arrId: "20e7c1cd-4fff-42ef-a3a6-40102bb5109c",
            documento: "1234",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Marcelo",
            apellido: "UAMPA",
            fechaNacimiento: "12-06-1985",
            domicilioSIPE: " ,  CP: - , , ",
            telefono: "33333",
          },
          type: "doc",
          sipeSearch: true,
          emptyTitle: "Nuevo Protagonistas",
        },
        {
          arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Acompañante", nombre: "Acompañante" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
            documento: "123",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Johnny",
            apellido: "Bravo",
            fechaNacimiento: "18/07/1993",
            domicilio: "Neuquén, Argentina. 1887",
            telefono: "123",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nuevo Acompañante",
        },
        {
          arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nueva víctima",
        },
      ],
    },
    diligencia: [],
    DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    ActuacionUsuarioDependencia: [
      {
        ActuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
        Fechadesde: "2022-09-16 00:00:00",
        Fechahasta: null,
        ActuacionID: "cdaf7be3-35d0-11ed-9474-00ff2876ab1e",
        UsuarioID: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
        DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
        Numeroextracto: null,
        RecienEnviada: "0",
        NombreUsuario: "UserTesterE3",
        Email: "cangaleonardo@gmail.com",
        Apellido: "Test",
        Nombre: "User",
        Dni: "1111111",
      },
    ],
    actuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
    dependenciaPolicial: "SUB COMISARIA  E3",
    dependenciaDepartamento: "RAWSON",
    dependenciaDomicilio: "20 de Junio y Mistral (Fte. Plaza)",
    dependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    denunciaID: "cdac0e23-35d0-11ed-9474-00ff2876ab1e",
    tiposumarioID: "Actuacion Preliminar incendio de Automotor",
    sumarioEstado: "sin estado asignado",
    sumarioEstadoID: "sin estado asignado",
    idDependencia: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    idUser: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
  },

  //ACTUACIÓN "PRELIMINARES CAÍDA CASUAL"
  "preliminar-caida-casual": {
    denunciantesBD: [],
    ubicacion: "",
    preUbicacion: {
      calle: "FALSA",
      numero: "123",
      coordinates: { lat: -31.541697941234222, lng: -68.537934422493 },
    },
    moment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    preMoment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    estadoCivil: {},
    residencia: {},
    denuncia: [{ name: "InputNestor", value: "" }],
    fechaDenuncia: new Date(),
    fechaCertificadoDenuncia: null,
    denunciaText: "",
    causaNumero: "123456",
    modusOperandi: {
      TipomodusoperandiID: "4d6928f6-a3c5-11ec-816d-16c2a030bb97",
      Descripcion: null,
      Nombre: "EN BANDA",
    },
    causaCaratula: null,
    listaArticulos: [],
    causaJuzgado: {},
    Sitio: { TipoSitioID: "tipo-sitio-id-0001" },
    listaCaratulas: [
      {
        TipocausacaratulaID: "2771bc5b-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ABUSO DE ARMA",
        TipoCaratula: "Causa Caratula",
      },
      {
        TipocausacaratulaID: "2a5c76f3-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ACT.PARA ESTABLECER PARADERO",
        TipoCaratula: "Causa Caratula",
      },
      {
        TipocausacaratulaID: "2b6ff555-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ACT.POR FALLECIMIENTO",
        TipoCaratula: "Causa Caratula",
      },
    ],
    id: null,
    saveStatus: "new",
    timer: false,
    isSaving: false,
    type: null,
    deposition:
      "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar preliminar-caida-casual",
    formType: "preliminar-caida-casual",
    dependencia: "SUB COMISARIA  E3",
    PersonalInterviniente: [
      {
        nombre: "jefe gorgory",
        jerarquia: { id: "4", nombre: "Sargento" },
        dependencia: "Ptp Policial Tamberias Calingasta",
      },
    ],
    textEditsCounter: {
      Preform: 0,
      Contravener: 0,
      Postform: "",
      LegalData: "",
      instructionDecree: 0,
    },
    textEstaticos: {
      Preform: "",
      Contravener: "",
      Postform: "",
      LegalData: "",
      instructionDecree: "",
    },
    spinnerOrderTablePrintFrom: false,
    denunciante: {
      list: [
        {
          arrId: "20e7c1cd-4fff-42ef-a3a6-40102bb5109c",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Protagonista", nombre: "Protagonista" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "3", nombre: "Separado/a" },
            arrId: "20e7c1cd-4fff-42ef-a3a6-40102bb5109c",
            documento: "1234",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Marcelo",
            apellido: "UAMPA",
            fechaNacimiento: "12-06-1985",
            domicilioSIPE: " ,  CP: - , , ",
            telefono: "33333",
          },
          type: "doc",
          sipeSearch: true,
          emptyTitle: "Nuevo Protagonistas",
        },
        {
          arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Acompañante", nombre: "Acompañante" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
            documento: "123",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Johnny",
            apellido: "Bravo",
            fechaNacimiento: "18/07/1993",
            domicilio: "Neuquén, Argentina. 1887",
            telefono: "123",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nuevo Acompañante",
        },
        {
          arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: "63", nombre: "ESTADOS UNIDOS" },
            condicion: { id: "Peatón", nombre: "Peatón" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
            estadoCivil: { id: "2", nombre: "Casado/a" },
            documento: "13131313",
            apellido: "Simpsons",
            nombre: "Homero J",
            fechaNacimiento: "18/05/1956",
            domicilio: "av siempreviva 742 springfield",
            telefono: "264448963",
            profesion: "Tecnico Nuclear",
            sexo: { id: "M", nombre: "Masculino" },
          },
          type: "doc",
          ordenPublico: false,
          emptyTitle: "Nuevo protagonista, acompañante y/o peatón",
          sipeSearch: false,
        },
        {
          arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nueva víctima",
        },
      ],
    },
    diligencia: [],
    DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    ActuacionUsuarioDependencia: [
      {
        ActuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
        Fechadesde: "2022-09-16 00:00:00",
        Fechahasta: null,
        ActuacionID: "cdaf7be3-35d0-11ed-9474-00ff2876ab1e",
        UsuarioID: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
        DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
        Numeroextracto: null,
        RecienEnviada: "0",
        NombreUsuario: "UserTesterE3",
        Email: "cangaleonardo@gmail.com",
        Apellido: "Test",
        Nombre: "User",
        Dni: "1111111",
      },
    ],
    actuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
    dependenciaPolicial: "SUB COMISARIA  E3",
    dependenciaDepartamento: "RAWSON",
    dependenciaDomicilio: "20 de Junio y Mistral (Fte. Plaza)",
    dependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    denunciaID: "cdac0e23-35d0-11ed-9474-00ff2876ab1e",
    tiposumarioID: "Actuacion Preliminar por Caida Casual",
    sumarioEstado: "sin estado asignado",
    sumarioEstadoID: "sin estado asignado",
    idDependencia: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    idUser: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
  },

  //ACTUACIÓN "PRELIMINARES SINIESTRO VIAL"
  "preliminar-siniestro-vial": {
    denunciantesBD: [],
    ubicacion: "",
    preUbicacion: {
      calle: "FALSA",
      numero: "123",
      coordinates: { lat: -31.541697941234222, lng: -68.537934422493 },
    },
    moment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    preMoment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    estadoCivil: {},
    residencia: {},
    denuncia: [{ name: "InputNestor", value: "" }],
    fechaDenuncia: new Date(),
    fechaCertificadoDenuncia: null,
    denunciaText: "",
    causaNumero: "123456",
    modusOperandi: {
      TipomodusoperandiID: "4d6928f6-a3c5-11ec-816d-16c2a030bb97",
      Descripcion: null,
      Nombre: "EN BANDA",
    },
    causaCaratula: null,
    listaArticulos: [],
    causaJuzgado: {
      JuzgadoID: "3db1cda6-cca0-11e4-8df1-0090f58f4f32",
      Fechainivig: "2021-12-23 00:00:00",
      Fechafinvig: null,
      Nombre: "JUZGADO DE PAZ ZONDA",
      Telefono: null,
      Domicilio: null,
    },
    Sitio: { TipoSitioID: "tipo-sitio-id-0001" },
    listaCaratulas: [
      {
        TipocausacaratulaID: "2771bc5b-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ABUSO DE ARMA",
        TipoCaratula: "Causa Caratula",
      },
      {
        TipocausacaratulaID: "2a5c76f3-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ACT.PARA ESTABLECER PARADERO",
        TipoCaratula: "Causa Caratula",
      },
      {
        TipocausacaratulaID: "2b6ff555-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ACT.POR FALLECIMIENTO",
        TipoCaratula: "Causa Caratula",
      },
    ],
    id: null,
    saveStatus: "new",
    timer: false,
    isSaving: false,
    type: null,
    deposition:
      "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar preliminar-siniestro-vial",
    formType: "preliminar-siniestro-vial",
    dependencia: "SUB COMISARIA  E3",
    PersonalInterviniente: [
      {
        nombre: "jefe gorgory",
        jerarquia: { id: "4", nombre: "Sargento" },
        dependencia: "Ptp Policial Tamberias Calingasta",
      },
    ],
    textEditsCounter: {
      Preform: 0,
      Contravener: 0,
      Postform: "",
      LegalData: "",
      instructionDecree: 0,
    },
    textEstaticos: {
      Preform: "",
      Contravener: "",
      Postform: "",
      LegalData: "",
      instructionDecree: "",
    },
    spinnerOrderTablePrintFrom: false,
    robados: {
      list: [
        {
          arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
          doc: {
            tipoEfecto: { id: "Recuperado", nombre: "Recuperado" },
            arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
            CategoriaID: "1",
            SubcategoriaID: "2d532f6b-b685-11ec-8878-16c2a030bb97",
            TipoID: "8fd03587-dfb4-11ed-9f23-0242ac120004",
            MarcaID: "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            ModeloID: "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            Anio: "2023",
            Chasis: "156",
            NumeroMotor: "1589798",
            Dominio: "asd123",
            NumeroSerie: "2235",
            Imei: "159489159",
            Abonado: "365",
            Color: "Gris",
          },
          type: "doc",
          conocido: true,
          hasIdentikit: false,
        },
        {
          arrId: "6c445767-6a60-4617-900f-dd776bfb1fee",
          doc: { newFormatEffect: true, tipoEfecto: { id: "Secuestrado", nombre: "Secuestrado" } },
          type: "empty",
          conocido: true,
          hasIdentikit: false,
        },
      ],
    },
    denunciante: {
      list: [
        {
          arrId: "20e7c1cd-4fff-42ef-a3a6-40102bb5109c",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Protagonista", nombre: "Protagonista" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "3", nombre: "Separado/a" },
            arrId: "20e7c1cd-4fff-42ef-a3a6-40102bb5109c",
            documento: "1234",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Marcelo",
            apellido: "UAMPA",
            fechaNacimiento: "12-06-1985",
            domicilioSIPE: " ,  CP: - , , ",
            telefono: "33333",
          },
          type: "doc",
          sipeSearch: true,
          emptyTitle: "Nuevo Protagonistas",
        },
        {
          arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Acompañante", nombre: "Acompañante" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
            documento: "123",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Johnny",
            apellido: "Bravo",
            fechaNacimiento: "18/07/1993",
            domicilio: "Neuquén, Argentina. 1887",
            telefono: "123",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nuevo Acompañante",
        },
        {
          arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: "63", nombre: "ESTADOS UNIDOS" },
            condicion: { id: "Peatón", nombre: "Peatón" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
            estadoCivil: { id: "2", nombre: "Casado/a" },
            documento: "13131313",
            apellido: "Simpsons",
            nombre: "Homero J",
            fechaNacimiento: "18/05/1956",
            domicilio: "av siempreviva 742 springfield",
            telefono: "264448963",
            profesion: "Tecnico Nuclear",
            sexo: { id: "M", nombre: "Masculino" },
          },
          type: "doc",
          ordenPublico: false,
          emptyTitle: "Nuevo protagonista, acompañante y/o peatón",
          sipeSearch: false,
        },
        {
          arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nueva víctima",
        },
      ],
    },
    diligencia: [],
    DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    ActuacionUsuarioDependencia: [
      {
        ActuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
        Fechadesde: "2022-09-16 00:00:00",
        Fechahasta: null,
        ActuacionID: "cdaf7be3-35d0-11ed-9474-00ff2876ab1e",
        UsuarioID: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
        DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
        Numeroextracto: null,
        RecienEnviada: "0",
        NombreUsuario: "UserTesterE3",
        Email: "cangaleonardo@gmail.com",
        Apellido: "Test",
        Nombre: "User",
        Dni: "1111111",
      },
    ],
    actuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
    dependenciaPolicial: "SUB COMISARIA  E3",
    dependenciaDepartamento: "RAWSON",
    dependenciaDomicilio: "20 de Junio y Mistral (Fte. Plaza)",
    dependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    denunciaID: "cdac0e23-35d0-11ed-9474-00ff2876ab1e",
    tiposumarioID: "Actuacion Preliminar por Siniestro Vial",
    sumarioEstado: "sin estado asignado",
    sumarioEstadoID: "sin estado asignado",
    idDependencia: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    idUser: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
  },

  //ACTUACIÓN "PRELIMINARES TENTATIVA DE SUICIDIO"
  "preliminar-tentativa-suicidio": {
    denunciantesBD: [],
    ubicacion: "",
    preUbicacion: {
      calle: "FALSA",
      numero: "123",
      coordinates: { lat: -31.541697941234222, lng: -68.537934422493 },
    },
    moment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    preMoment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    estadoCivil: {},
    residencia: {},
    denuncia: [{ name: "InputNestor", value: "" }],
    fechaDenuncia: new Date(),
    fechaCertificadoDenuncia: null,
    denunciaText: "",
    causaNumero: "123456",
    modusOperandi: {
      TipomodusoperandiID: "4d6928f6-a3c5-11ec-816d-16c2a030bb97",
      Descripcion: null,
      Nombre: "EN BANDA",
    },
    causaCaratula: null,
    listaArticulos: [],
    causaJuzgado: {
      JuzgadoID: "3db1cda6-cca0-11e4-8df1-0090f58f4f32",
      Fechainivig: "2021-12-23 00:00:00",
      Fechafinvig: null,
      Nombre: "JUZGADO DE PAZ ZONDA",
      Telefono: null,
      Domicilio: null,
    },
    Sitio: { TipoSitioID: "tipo-sitio-id-0001" },
    listaCaratulas: [
      {
        TipocausacaratulaID: "2771bc5b-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ABUSO DE ARMA",
        TipoCaratula: "Causa Caratula",
      },
      {
        TipocausacaratulaID: "2a5c76f3-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ACT.PARA ESTABLECER PARADERO",
        TipoCaratula: "Causa Caratula",
      },
      {
        TipocausacaratulaID: "2b6ff555-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ACT.POR FALLECIMIENTO",
        TipoCaratula: "Causa Caratula",
      },
    ],
    id: null,
    saveStatus: "new",
    timer: false,
    isSaving: false,
    type: null,
    deposition:
      "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar preliminar-tentativa-suicidio",
    formType: "preliminar-tentativa-suicidio",
    dependencia: "SUB COMISARIA  E3",
    PersonalInterviniente: [
      {
        nombre: "jefe gorgory",
        jerarquia: { id: "4", nombre: "Sargento" },
        dependencia: "Ptp Policial Tamberias Calingasta",
      },
    ],
    textEditsCounter: {
      Preform: 0,
      Contravener: 0,
      Postform: "",
      LegalData: "",
      instructionDecree: 0,
    },
    textEstaticos: {
      Preform: "",
      Contravener: "",
      Postform: "",
      LegalData: "",
      instructionDecree: "",
    },
    spinnerOrderTablePrintFrom: false,
    robados: {
      list: [
        {
          arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
          doc: {
            tipoEfecto: { id: "Recuperado", nombre: "Recuperado" },
            arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
            CategoriaID: "1",
            SubcategoriaID: "2d532f6b-b685-11ec-8878-16c2a030bb97",
            TipoID: "8fd03587-dfb4-11ed-9f23-0242ac120004",
            MarcaID: "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            ModeloID: "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            Anio: "2023",
            Chasis: "156",
            NumeroMotor: "1589798",
            Dominio: "asd123",
            NumeroSerie: "2235",
            Imei: "159489159",
            Abonado: "365",
            Color: "Gris",
          },
          type: "doc",
          conocido: true,
          hasIdentikit: false,
        },
        {
          arrId: "6c445767-6a60-4617-900f-dd776bfb1fee",
          doc: { newFormatEffect: true, tipoEfecto: { id: "Secuestrado", nombre: "Secuestrado" } },
          type: "empty",
          conocido: true,
          hasIdentikit: false,
        },
      ],
    },
    acusados: {
      list: [
        {
          arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Autolesionado", nombre: "Autolesionado" },
            arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
            apellido: "Rodríguez",
            nombre: "Bender Bending",
            fechaNacimiento: "18/12/1994",
            estadoCivil: { id: "2", nombre: "Casado/a" },
            domicilio: "Planet Express",
            apodo: "bender",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo Autolesionado",
        },
        {
          arrId: "0ab72ea4-71cb-4d9e-9744-5bd17e6226b7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Autolesionado", nombre: "Autolesionado" },
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "empty",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo Autolesionado",
        },
      ],
      emptyDoc: {
        instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
        email: "helloworld@gmail.com",
        nacionalidad: { id: 1, nombre: "ARGENTINA" },
        tipoDocumento: { id: "DNI", nombre: "DNI" },
        condicion: { id: "Autolesionado", nombre: "Autolesionado" },
      },
    },
    denunciante: {
      list: [
        {
          arrId: "20e7c1cd-4fff-42ef-a3a6-40102bb5109c",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            email: "dolor_sit_amet@hotmail.com",
            estadoCivil: { id: "3", nombre: "Separado/a" },
            arrId: "20e7c1cd-4fff-42ef-a3a6-40102bb5109c",
            documento: "1234",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Marcelo",
            apellido: "UAMPA",
            fechaNacimiento: "12-06-1985",
            domicilioSIPE: " ,  CP: - , , ",
            telefono: "33333",
          },
          type: "doc",
          sipeSearch: true,
          emptyTitle: "Nuevo Damnificado",
        },
        {
          arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Denunciante", nombre: "Denunciante" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            email: "dolor_sit_amet@hotmail.com",
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
            documento: "123",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Johnny",
            apellido: "Bravo",
            fechaNacimiento: "18/07/1993",
            domicilio: "Neuquén, Argentina. 1887",
            telefono: "123",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nuevo Denunciante",
        },
        {
          arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: "63", nombre: "ESTADOS UNIDOS" },
            condicion: { id: "Denunciante y Damnificado", nombre: "Denunciante y Damnificado" },
            email: "dolor_sit_amet@hotmail.com",
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
            estadoCivil: { id: "2", nombre: "Casado/a" },
            documento: "13131313",
            apellido: "Simpsons",
            nombre: "Homero J",
            fechaNacimiento: "18/05/1956",
            domicilio: "av siempreviva 742 springfield",
            telefono: "264448963",
            profesion: "Tecnico Nuclear",
            sexo: { id: "M", nombre: "Masculino" },
          },
          type: "doc",
          ordenPublico: false,
          emptyTitle: "nUEVO Denunciante y Damnificado",
          sipeSearch: false,
        },
        {
          arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nueva víctima",
        },
      ],
    },
    diligencia: [],
    DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    ActuacionUsuarioDependencia: [
      {
        ActuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
        Fechadesde: "2022-09-16 00:00:00",
        Fechahasta: null,
        ActuacionID: "cdaf7be3-35d0-11ed-9474-00ff2876ab1e",
        UsuarioID: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
        DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
        Numeroextracto: null,
        RecienEnviada: "0",
        NombreUsuario: "UserTesterE3",
        Email: "cangaleonardo@gmail.com",
        Apellido: "Test",
        Nombre: "User",
        Dni: "1111111",
      },
    ],
    actuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
    dependenciaPolicial: "SUB COMISARIA  E3",
    dependenciaDepartamento: "RAWSON",
    dependenciaDomicilio: "20 de Junio y Mistral (Fte. Plaza)",
    dependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    denunciaID: "cdac0e23-35d0-11ed-9474-00ff2876ab1e",
    tiposumarioID: "Actuacion Preliminar por Tentativa de Suicidio",
    sumarioEstado: "sin estado asignado",
    sumarioEstadoID: "sin estado asignado",
    idDependencia: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    idUser: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
  },

  //ACTUACIÓN "PRELIMINARES OTROS"
  "preliminar-otros": {
    denunciantesBD: [],
    ubicacion: "",
    preUbicacion: {
      calle: "FALSA",
      numero: "123",
      coordinates: { lat: -31.541697941234222, lng: -68.537934422493 },
    },
    moment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    preMoment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 preveGMT-0300"),
    },
    estadoCivil: {},
    residencia: {},
    denuncia: [{ name: "InputNestor", value: "" }],
    Sitio: { TipoSitioID: "tipo-sitio-id-0001" },
    fechaDenuncia: new Date(),
    fechaCertificadoDenuncia: null,
    denunciaText: "",
    causaNumero: "123456",
    modusOperandi: {
      TipomodusoperandiID: "4d6928f6-a3c5-11ec-816d-16c2a030bb97",
      Descripcion: null,
      Nombre: "EN BANDA",
    },
    causaCaratula: null,
    listaArticulos: [],
    causaJuzgado: {
      JuzgadoID: "3db1cda6-cca0-11e4-8df1-0090f58f4f32",
      Fechainivig: "2021-12-23 00:00:00",
      Fechafinvig: null,
      Nombre: "JUZGADO DE PAZ ZONDA",
      Telefono: null,
      Domicilio: null,
    },
    listaCaratulas: [
      {
        TipocausacaratulaID: "2771bc5b-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ABUSO DE ARMA",
        TipoCaratula: "Causa Caratula",
      },
      {
        TipocausacaratulaID: "2a5c76f3-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ACT.PARA ESTABLECER PARADERO",
        TipoCaratula: "Causa Caratula",
      },
      {
        TipocausacaratulaID: "2b6ff555-a3ca-11ec-816d-16c2a030bb97",
        Descripcion: null,
        Nombre: "ACT.POR FALLECIMIENTO",
        TipoCaratula: "Causa Caratula",
      },
    ],
    id: null,
    saveStatus: "new",
    timer: false,
    isSaving: false,
    type: null,
    deposition:
      "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar preliminar-otros",
    formType: "preliminar-otros",
    dependencia: "SUB COMISARIA  E3",
    PersonalInterviniente: [
      {
        nombre: "jefe gorgory",
        jerarquia: { id: "4", nombre: "Sargento" },
        dependencia: "Ptp Policial Tamberias Calingasta",
      },
    ],
    textEditsCounter: {
      Preform: 0,
      Contravener: 0,
      Postform: "",
      LegalData: "",
      instructionDecree: 0,
    },
    textEstaticos: {
      Preform: "",
      Contravener: "",
      Postform: "",
      LegalData: "",
      instructionDecree: "",
    },
    spinnerOrderTablePrintFrom: false,
    acusados: {
      list: [
        {
          arrId: "a9f804a4-30fc-4a0b-8e28-af2cb728e8b3",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Acusado", nombre: "Acusado" },
            arrId: "a9f804a4-30fc-4a0b-8e28-af2cb728e8b3",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "",
          filiacionDesconocida: true,
        },
        {
          arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Acusado y/o Detenido", nombre: "Acusado y/o Detenido" },
            arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
            apellido: "Rodríguez",
            nombre: "Bender Bending",
            fechaNacimiento: "18/12/1994",
            estadoCivil: { id: "2", nombre: "Casado/a" },
            domicilio: "Planet Express",
            apodo: "bender",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo Detenido",
        },
        {
          arrId: "0ab72ea4-71cb-4d9e-9744-5bd17e6226b7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Acusado y/o Detenido", nombre: "Acusado y/o Detenido" },
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "empty",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo Detenido",
        },
      ],
      emptyDoc: {
        instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
        email: "helloworld@gmail.com",
        nacionalidad: { id: 1, nombre: "ARGENTINA" },
        tipoDocumento: { id: "DNI", nombre: "DNI" },
        condicion: { id: "Detenido", nombre: "Detenido" },
        email: "helloworld@hotmail.com",
      },
    },
    robados: {
      list: [
        {
          arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
          doc: {
            tipoEfecto: { id: "Recuperado", nombre: "Recuperado" },
            arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
            CategoriaID: "1",
            SubcategoriaID: "2d532f6b-b685-11ec-8878-16c2a030bb97",
            TipoID: "8fd03587-dfb4-11ed-9f23-0242ac120004",
            MarcaID: "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            ModeloID: "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            Anio: "2023",
            Chasis: "156",
            NumeroMotor: "1589798",
            Dominio: "asd123",
            NumeroSerie: "2235",
            Imei: "159489159",
            Abonado: "365",
            Color: "Gris",
          },
          type: "doc",
          conocido: true,
          hasIdentikit: false,
        },
        {
          arrId: "6c445767-6a60-4617-900f-dd776bfb1fee",
          doc: { newFormatEffect: true, tipoEfecto: { id: "Secuestrado", nombre: "Secuestrado" } },
          type: "empty",
          conocido: true,
          hasIdentikit: false,
        },
      ],
    },
    denunciante: {
      list: [
        {
          arrId: "20e7c1cd-4fff-42ef-a3a6-40102bb5109c",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Denunciante y Damnificado", nombre: "Denunciante y Damnificado" },
            email: "dolor_sit_amet@hotmail.com",
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "3", nombre: "Separado/a" },
            arrId: "20e7c1cd-4fff-42ef-a3a6-40102bb5109c",
            documento: "1234",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Marcelo",
            apellido: "UAMPA",
            fechaNacimiento: "12-06-1985",
            domicilioSIPE: " ,  CP: - , , ",
            telefono: "33333",
          },
          type: "doc",
          sipeSearch: true,
          emptyTitle: "Nuevo denunciante y/o damnificado/a",
        },
        {
          arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
            documento: "123",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Johnny",
            apellido: "Bravo",
            fechaNacimiento: "18/07/1993",
            domicilio: "Neuquén, Argentina. 1887",
            telefono: "123",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nuevo denunciante y/o damnificado/a",
        },
        {
          arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "Damnificado", nombre: "Damnificado" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nueva víctima",
        },
      ],
    },
    diligencia: [],
    DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    ActuacionUsuarioDependencia: [
      {
        ActuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
        Fechadesde: "2022-09-16 00:00:00",
        Fechahasta: null,
        ActuacionID: "cdaf7be3-35d0-11ed-9474-00ff2876ab1e",
        UsuarioID: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
        DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
        Numeroextracto: null,
        RecienEnviada: "0",
        Nombreusuario: "UserTesterE3",
        Email: "cangaleonardo@gmail.com",
        Apellido: "Test",
        Nombre: "User",
        Dni: "1111111",
      },
    ],
    actuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
    dependenciaPolicial: "SUB COMISARIA  E3",
    dependenciaDepartamento: "RAWSON",
    dependenciaDomicilio: "20 de Junio y Mistral (Fte. Plaza)",
    dependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    denunciaID: "cdac0e23-35d0-11ed-9474-00ff2876ab1e",
    tiposumarioID: "Actuacion Preliminar - Otros",
    sumarioEstado: "sin estado asignado",
    sumarioEstadoID: "sin estado asignado",
    idDependencia: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    idUser: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
  },

  //ACTUACIÓN "UFI DELITOS CONTRA LA PROPIEDAD POR DENUNCIA"
  "ufi-delitos-contra-la-propiedad": {
    denunciantesBD: [],
    ubicacion: "",
    preUbicacion: {
      calle: "FALSA",
      numero: "123",
      coordinates: { lat: -31.541697941234222, lng: -68.537934422493 },
    },
    moment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    preMoment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    estadoCivil: {},
    residencia: {},
    denuncia: [{ name: "InputNestor", value: "" }],
    fechaDenuncia: new Date(),
    fechaCertificadoDenuncia: null,
    denunciaText: "",
    causaNumero: "123456",
    modusOperandi: {
      TipomodusoperandiID: "4d6928f6-a3c5-11ec-816d-16c2a030bb97",
      Descripcion: null,
      Nombre: "EN BANDA",
    },
    causaCaratula: {
      TipocausacaratulaID: "fc2db6c2-85f7-11ed-8410-0242ac120003",
      Descripcion: null,
      Nombre: "nuevo delito",
      TipoCaratula: "Delito",
    },
    listaArticulos: [],
    causaJuzgado: null,
    ActuacionUfi: {
      TipoufiID: "ufi34fb5-c013-11ec-8878-16c2a030bb97",
      Fechainivig: "2022-07-06 13:22:00",
      Fechafinvig: null,
      Numero: "3",
    },
    Sitio: { TipoSitioID: "tipo-sitio-id-0001" },
    prosecutor: {
      PersonalfiscalID: "159d607f-ff05-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Adrian Riveros",
      Jerarquia: "Fiscal",
    },
    assistant: {
      PersonalfiscalID: "b8d73615-ff06-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Solera Alejandro",
      Jerarquia: "Ayudante",
    },
    id: null,
    saveStatus: "new",
    timer: false,
    isSaving: false,
    type: null,
    deposition:
      "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar ufi- anivi",
    formType: "ufi-delitos-contra-la-propiedad",
    dependencia: "SUB COMISARIA  E3",
    PersonalInterviniente: [
      {
        nombre: "jefe gorgory",
        jerarquia: { id: "4", nombre: "Sargento" },
        dependencia: "Ptp Policial Tamberias Calingasta",
      },
    ],
    textEditsCounter: {
      Preform: 0,
      Contravener: 0,
      Postform: "",
      LegalData: "",
      instructionDecree: 0,
    },
    textEstaticos: {
      Preform: "",
      Contravener: "",
      Postform: "",
      LegalData: "",
      instructionDecree: "",
    },
    spinnerOrderTablePrintFrom: false,
    acusados: {
      list: [
        {
          arrId: "6ee9d327-f610-43ba-95ee-f67714d7c342",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Aprehendido", nombre: "Aprehendido" },
            email: "loremipsum@yahoo.com",
            apellido: "mojo",
            arrId: "6ee9d327-f610-43ba-95ee-f67714d7c342",
            nombre: " jojo",
            estadoCivil: { id: "4", nombre: "Divorciado/a" },
            apodo: "mojo jojo",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          sipeSearch: false,
          emptyTitle: "Nuevo aprehendido",
        },
        {
          arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Acusado", nombre: "Acusado" },
            arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
            apellido: "Rodríguez",
            nombre: "Bender Bending",
            fechaNacimiento: "18/12/1994",
            estadoCivil: { id: "2", nombre: "Casado/a" },
            domicilio: "Planet Express",
            apodo: "bender",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo aprehendido",
        },
        {
          arrId: "0ab72ea4-71cb-4d9e-9744-5bd17e6226b7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Aprehendido", nombre: "Aprehendido" },
            email: "loremipsum@yahoo.com",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "empty",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo aprehendido",
        },
      ],
      emptyDoc: {
        instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
        email: "helloworld@gmail.com",
        nacionalidad: { id: 1, nombre: "ARGENTINA" },
        tipoDocumento: { id: "DNI", nombre: "DNI" },
        condicion: { id: "Aprehendido", nombre: "Aprehendido" },
        email: "loremipsum@yahoo.com",
      },
    },
    robados: {
      list: [
        {
          arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
          doc: {
            tipoEfecto: { id: "Recuperado", nombre: "Recuperado" },
            arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
            CategoriaID: "1",
            SubcategoriaID: "2d532f6b-b685-11ec-8878-16c2a030bb97",
            TipoID: "8fd03587-dfb4-11ed-9f23-0242ac120004",
            MarcaID: "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            ModeloID: "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            Anio: "2023",
            Chasis: "156",
            NumeroMotor: "1589798",
            Dominio: "asd123",
            NumeroSerie: "2235",
            Imei: "159489159",
            Abonado: "365",
            Color: "Gris",
          },
          type: "doc",
          conocido: true,
          hasIdentikit: false,
        },
        {
          arrId: "6c445767-6a60-4617-900f-dd776bfb1fee",
          doc: { newFormatEffect: true, tipoEfecto: { id: "Secuestrado", nombre: "Secuestrado" } },
          type: "empty",
          conocido: true,
          hasIdentikit: false,
        },
      ],
    },
    denunciante: {
      list: [
        {
          arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "victima", nombre: "Víctima" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
            documento: "123",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Johnny",
            apellido: "Bravo",
            fechaNacimiento: "18/07/1993",
            domicilio: "Neuquén, Argentina. 1887",
            telefono: "123",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nueva víctima",
        },
        {
          arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "victima", nombre: "Víctima" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nueva víctima",
        },
      ],
    },
    diligencia: [],
    DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    ActuacionUsuarioDependencia: [
      {
        ActuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
        Fechadesde: "2022-09-16 00:00:00",
        Fechahasta: null,
        ActuacionID: "cdaf7be3-35d0-11ed-9474-00ff2876ab1e",
        UsuarioID: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
        DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
        Numeroextracto: null,
        RecienEnviada: "0",
        NombreUsuario: "UserTesterE3",
        Email: "cangaleonardo@gmail.com",
        Apellido: "Test",
        Nombre: "User",
        Dni: "1111111",
      },
    ],
    actuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
    dependenciaPolicial: "SUB COMISARIA  E3",
    dependenciaDepartamento: "RAWSON",
    dependenciaDomicilio: "20 de Junio y Mistral (Fte. Plaza)",
    dependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    denunciaID: "cdac0e23-35d0-11ed-9474-00ff2876ab1e",
    tiposumarioID: "Unidades Fiscales de Investigacion anivi",
    sumarioEstado: "sin estado asignado",
    sumarioEstadoID: "sin estado asignado",
    idDependencia: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    idUser: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
  },

  //ACTUACIÓN "UFI DELITOS CONTRA LA PROPIEDAD POR OFICIO"
  "ufi-delitos-contra-la-propiedad-oficio": {
    denunciantesBD: [],
    ubicacion: "",
    preUbicacion: {
      calle: "FALSA",
      numero: "123",
      coordinates: { lat: -31.541697941234222, lng: -68.537934422493 },
    },
    moment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    preMoment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    estadoCivil: {},
    residencia: {},
    denuncia: [{ name: "InputNestor", value: "" }],
    fechaDenuncia: new Date(),
    fechaCertificadoDenuncia: null,
    denunciaText: "",
    causaNumero: "123456",
    modusOperandi: {
      TipomodusoperandiID: "4d6928f6-a3c5-11ec-816d-16c2a030bb97",
      Descripcion: null,
      Nombre: "EN BANDA",
    },
    causaCaratula: {
      TipocausacaratulaID: "fc2db6c2-85f7-11ed-8410-0242ac120003",
      Descripcion: null,
      Nombre: "nuevo delito",
      TipoCaratula: "Delito",
    },
    listaArticulos: [],
    causaJuzgado: null,
    ActuacionUfi: {
      TipoufiID: "ufi34fb5-c013-11ec-8878-16c2a030bb97",
      Fechainivig: "2022-07-06 13:22:00",
      Fechafinvig: null,
      Numero: "3",
    },
    Sitio: { TipoSitioID: "tipo-sitio-id-0001" },
    prosecutor: {
      PersonalfiscalID: "159d607f-ff05-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Adrian Riveros",
      Jerarquia: "Fiscal",
    },
    assistant: {
      PersonalfiscalID: "b8d73615-ff06-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Solera Alejandro",
      Jerarquia: "Ayudante",
    },
    id: null,
    saveStatus: "new",
    timer: false,
    isSaving: false,
    type: null,
    deposition:
      "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar ufi- anivi",
    formType: "ufi-delitos-contra-la-propiedad-oficio",
    dependencia: "SUB COMISARIA  E3",
    PersonalInterviniente: [
      {
        nombre: "jefe gorgory",
        jerarquia: { id: "4", nombre: "Sargento" },
        dependencia: "Ptp Policial Tamberias Calingasta",
      },
    ],
    textEditsCounter: {
      Preform: 0,
      Contravener: 0,
      Postform: "",
      LegalData: "",
      instructionDecree: 0,
    },
    textEstaticos: {
      Preform: "",
      Contravener: "",
      Postform: "",
      LegalData: "",
      instructionDecree: "",
    },
    spinnerOrderTablePrintFrom: false,
    acusados: {
      list: [
        {
          arrId: "6ee9d327-f610-43ba-95ee-f67714d7c342",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Aprehendido", nombre: "Aprehendido" },
            email: "loremipsum@yahoo.com",
            apellido: "mojo",
            arrId: "6ee9d327-f610-43ba-95ee-f67714d7c342",
            nombre: " jojo",
            estadoCivil: { id: "4", nombre: "Divorciado/a" },
            apodo: "mojo jojo",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          sipeSearch: false,
          emptyTitle: "Nuevo aprehendido",
        },
        {
          arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Acusado", nombre: "Acusado" },
            arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
            apellido: "Rodríguez",
            nombre: "Bender Bending",
            fechaNacimiento: "18/12/1994",
            estadoCivil: { id: "2", nombre: "Casado/a" },
            domicilio: "Planet Express",
            apodo: "bender",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo aprehendido",
        },
        {
          arrId: "0ab72ea4-71cb-4d9e-9744-5bd17e6226b7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Aprehendido", nombre: "Aprehendido" },
            email: "loremipsum@yahoo.com",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "empty",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo aprehendido",
        },
      ],
      emptyDoc: {
        instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
        email: "helloworld@gmail.com",
        nacionalidad: { id: 1, nombre: "ARGENTINA" },
        tipoDocumento: { id: "DNI", nombre: "DNI" },
        condicion: { id: "Aprehendido", nombre: "Aprehendido" },
        email: "loremipsum@yahoo.com",
      },
    },
    robados: {
      list: [
        {
          arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
          doc: {
            tipoEfecto: { id: "Recuperado", nombre: "Recuperado" },
            arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
            CategoriaID: "1",
            SubcategoriaID: "2d532f6b-b685-11ec-8878-16c2a030bb97",
            TipoID: "8fd03587-dfb4-11ed-9f23-0242ac120004",
            MarcaID: "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            ModeloID: "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            Anio: "2023",
            Chasis: "156",
            NumeroMotor: "1589798",
            Dominio: "asd123",
            NumeroSerie: "2235",
            Imei: "159489159",
            Abonado: "365",
            Color: "Gris",
          },
          type: "doc",
          conocido: true,
          hasIdentikit: false,
        },
        {
          arrId: "6c445767-6a60-4617-900f-dd776bfb1fee",
          doc: { newFormatEffect: true, tipoEfecto: { id: "Secuestrado", nombre: "Secuestrado" } },
          type: "empty",
          conocido: true,
          hasIdentikit: false,
        },
      ],
    },
    denunciante: {
      list: [
        {
          arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "victima", nombre: "Víctima" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
            documento: "123",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Johnny",
            apellido: "Bravo",
            fechaNacimiento: "18/07/1993",
            domicilio: "Neuquén, Argentina. 1887",
            telefono: "123",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nueva víctima",
        },
        {
          arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "victima", nombre: "Víctima" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nueva víctima",
        },
      ],
    },
    diligencia: [],
    DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    ActuacionUsuarioDependencia: [
      {
        ActuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
        Fechadesde: "2022-09-16 00:00:00",
        Fechahasta: null,
        ActuacionID: "cdaf7be3-35d0-11ed-9474-00ff2876ab1e",
        UsuarioID: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
        DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
        Numeroextracto: null,
        RecienEnviada: "0",
        NombreUsuario: "UserTesterE3",
        Email: "cangaleonardo@gmail.com",
        Apellido: "Test",
        Nombre: "User",
        Dni: "1111111",
      },
    ],
    actuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
    dependenciaPolicial: "SUB COMISARIA  E3",
    dependenciaDepartamento: "RAWSON",
    dependenciaDomicilio: "20 de Junio y Mistral (Fte. Plaza)",
    dependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    denunciaID: "cdac0e23-35d0-11ed-9474-00ff2876ab1e",
    tiposumarioID: "Unidades Fiscales de Investigacion anivi",
    sumarioEstado: "sin estado asignado",
    sumarioEstadoID: "sin estado asignado",
    idDependencia: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    idUser: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
  },

  //ACTUACIÓN "UFI DELITOS INFORMÁTICOS Y ESTAFAS POR DENUNCIA"
  "ufi-estafas-y-delitos-informaticos": {
    "preUbicacion": {
      "calle": "FALSA",
      "coordinates": {
        "lat": -31.541697941234222,
        "lng": -68.537934422493
      },
      "departamento": {
        "id": "7164a28a-ce2d-11e4-a042-0090f58f4f32",
        "nombre": "9 DE JULIO"
      },
      "numero": "123"
    },
    "denuncia": [
      {
        "name": "InputNestor"
      }
    ],
    "causaNumero": "123456",
    "modusOperandi": {
      "TipomodusoperandiID": "4d6928f6-a3c5-11ec-816d-16c2a030bb97",
      "Nombre": "EN BANDA"
    },
    "causaCaratula": {
      "TipocausacaratulaID": "fc2db6c2-85f7-11ed-8410-0242ac120003",
      "Nombre": "nuevo delito",
      "TipoCaratula": "Delito"
    },
    "ActuacionUfi": {
      "TipoufiID": "ufi34fb5-c013-11ec-8878-16c2a030bb97",
      "Fechainivig": "2022-07-06 13:22:00",
      "Numero": "3"
    },
    "prosecutor": {
      "PersonalfiscalID": "159d607f-ff05-11ec-bb82-0eb8b69eb347",
      "Denominacion": "Dr. Adrian Riveros",
      "Jerarquia": "Fiscal"
    },
    "assistant": {
      "PersonalfiscalID": "b8d73615-ff06-11ec-bb82-0eb8b69eb347",
      "Denominacion": "Dr. Solera Alejandro",
      "Jerarquia": "Ayudante"
    },
    "id": "778e21fd-d521-11f0-b42e-0242ac140006",
    "deposition": "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar ufi- anivi",
    "formType": "ufi-estafas-y-delitos-informaticos",
    "dependencia": "SUB COMISARIA  E3",
    "Sitio": {
      "TipoSitioID": "tipo-sitio-id-0001"
    },
    "effectsType": "empty",
    "PersonalInterviniente": [
      {
        "nombre": "jefe gorgory",
        "jerarquia": {
          "id": "4",
          "nombre": "Sargento"
        },
        "dependencia": "Ptp Policial Tamberias Calingasta"
      }
    ],
    "textEditsCounter": {
      "Preform": 0,
      "Contravener": 0,
      "instructionDecree": 0
    },
    "acusados": {
      "list": [
        {
          "arrId": "6ee9d327-f610-43ba-95ee-f67714d7c342",
          "doc": {
            "instruccion": {
              "id": "sabe_leer_sabe_firmar",
              "nombre": "Sabe leer y sabe firmar"
            },
            "email": "loremipsum@yahoo.com",
            "nacionalidad": {
              "id": 1,
              "nombre": "ARGENTINA"
            },
            "tipoDocumento": {
              "id": "DNI",
              "nombre": "DNI"
            },
            "condicion": {
              "id": "Aprehendido",
              "nombre": "Aprehendido"
            },
            "apellido": "jhon ",
            "arrId": "6ee9d327-f610-43ba-95ee-f67714d7c342",
            "nombre": "doe",
            "estadoCivil": {
              "id": "4",
              "nombre": "Divorciado/a"
            },
            "apodo": "mojo jojo",
            "personaJuridica": false,
            "exhibeDocumento": {
              "id": 1,
              "nombre": "Sí"
            },
            "fechaNacimiento": "11/11/1233",
            "edad": "24",
            "tieneSeguro": false,
            "tieneEstudios": {
              "id": 0,
              "nombre": "No"
            },
            "documento": "1212312",
            "sexo": {
              "id": "M",
              "nombre": "Masculino"
            },
            "profesion": "123123",
            "cuil": "123123123"
          },
          "identikit": [
            {
              "answer": "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              "question": "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              "questionNumber": 1
            },
            {
              "answer": "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              "question": "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              "questionNumber": 2
            },
            {
              "answer": "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              "question": "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              "questionNumber": 3
            },
            {
              "answer": "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              "question": "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              "questionNumber": 4
            },
            {
              "answer": "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              "question": "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              "questionNumber": 5
            },
            {
              "answer": "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              "question": "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              "questionNumber": 6
            }
          ],
          "type": "doc",
          "conocido": true,
          "hasIdentikit": false,
          "sipeSearch": false,
          "emptyTitle": "Nuevo aprehendido",
          "filiacionDesconocida": false
        },
        {
          "arrId": "0ab72ea4-71cb-4d9e-9744-5bd17e6226b7",
          "doc": {
            "instruccion": {
              "id": "sabe_leer_sabe_firmar",
              "nombre": "Sabe leer y sabe firmar"
            },
            "email": "loremipsum@yahoo.com",
            "nacionalidad": {
              "id": 1,
              "nombre": "ARGENTINA"
            },
            "tipoDocumento": {
              "id": "DNI",
              "nombre": "DNI"
            },
            "condicion": {
              "id": "Aprehendido",
              "nombre": "Aprehendido"
            }
          },
          "identikit": [
            {
              "answer": "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              "question": "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              "questionNumber": 1
            },
            {
              "answer": "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              "question": "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              "questionNumber": 2
            },
            {
              "answer": "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              "question": "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              "questionNumber": 3
            },
            {
              "answer": "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              "question": "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              "questionNumber": 4
            },
            {
              "answer": "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              "question": "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              "questionNumber": 5
            },
            {
              "answer": "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              "question": "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              "questionNumber": 6
            }
          ],
          "identikitQuestion": 1,
          "type": "empty",
          "conocido": true,
          "hasIdentikit": false,
          "emptyTitle": "Nuevo vinculado"
        }
      ],
      "emptyDoc": {
        "instruccion": {
          "id": "sabe_leer_sabe_firmar",
          "nombre": "Sabe leer y sabe firmar"
        },
        "email": "loremipsum@yahoo.com",
        "nacionalidad": {
          "id": 1,
          "nombre": "ARGENTINA"
        },
        "tipoDocumento": {
          "id": "DNI",
          "nombre": "DNI"
        },
        "condicion": {
          "id": "Aprehendido",
          "nombre": "Aprehendido"
        }
      }
    },
    "robados": {
      "list": [
        {
          "arrId": "7192952f-8a6b-4f89-a824-dc18b6713b43",
          "doc": {
            "tipoEfecto": {
              "id": "Recuperado",
              "nombre": "Recuperado"
            },
            "arrId": "7192952f-8a6b-4f89-a824-dc18b6713b43",
            "CategoriaID": "1",
            "SubcategoriaID": "2d532f6b-b685-11ec-8878-16c2a030bb97",
            "TipoID": "8fd03587-dfb4-11ed-9f23-0242ac120004",
            "MarcaID": "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            "ModeloID": "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            "Anio": "2023",
            "Chasis": "156",
            "NumeroMotor": "1589798",
            "Dominio": "asd123",
            "NumeroSerie": "2235",
            "Imei": "159489159",
            "Abonado": "365",
            "Color": "Gris"
          },
          "type": "doc",
          "conocido": true,
          "hasIdentikit": false
        },
        {
          "arrId": "6c445767-6a60-4617-900f-dd776bfb1fee",
          "doc": {
            "newFormatEffect": true,
            "tipoEfecto": {
              "id": "Secuestrado",
              "nombre": "Secuestrado"
            }
          },
          "type": "empty",
          "conocido": true,
          "hasIdentikit": false
        }
      ]
    },
    "denunciante": {
      "list": [
        {
          "arrId": "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
          "doc": {
            "personaJuridica": false,
            "condicion": {
              "id": "Denunciante",
              "nombre": "Denunciante"
            },
            "documento": "32133222",
            "tipoDocumento": {
              "id": "DNI",
              "nombre": "DNI"
            },
            "sexo": {
              "id": "M",
              "nombre": "Masculino"
            },
            "exhibeDocumento": {
              "id": 1,
              "nombre": "Sí"
            },
            "instruccion": {
              "id": "primaria",
              "nombre": "Primaria"
            },
            "apellido": "Pepe",
            "nombre": "Honguito",
            "nacionalidad": {
              "id": 1,
              "nombre": "ARGENTINA"
            },
            "fechaNacimiento": "18/07/1993",
            "edad": "13",
            "estadoCivil": {
              "id": "1",
              "nombre": "Soltero/a"
            },
            "telefono": "123",
            "profesion": "explorador",
            "domicilio": "Neuquén, Argentina. 1887",
            "email": "helloworld@gmail.com",
            "tieneSeguro": false,
            "tieneEstudios": {
              "id": 1,
              "nombre": "Sí"
            },
            "cuil": "123213321",
            "arrId": "9f9be280-0ce1-4cc4-ab8d-49bab143ed05"
          },
          "type": "doc",
          "sipeSearch": false,
          "emptyTitle": "Nueva víctima"
        },
        {
          "arrId": "439c3cf6-8429-4cc3-8184-80911162ffa7",
          "doc": {
            "instruccion": {
              "id": "sabe_leer_sabe_firmar",
              "nombre": "Sabe leer y sabe firmar"
            },
            "email": "helloworld@gmail.com",
            "nacionalidad": {
              "id": 1,
              "nombre": "ARGENTINA"
            },
            "condicion": {
              "id": "victima",
              "nombre": "Víctima"
            },
            "tipoDocumento": {
              "id": "DNI",
              "nombre": "DNI"
            }
          },
          "type": "empty",
          "ordenPublico": false,
          "emptyTitle": "Nuevo afectado"
        }
      ],
      "emptyDoc": {
        "instruccion": {
          "id": "sabe_leer_sabe_firmar",
          "nombre": "Sabe leer y sabe firmar"
        },
        "nacionalidad": {
          "id": 1,
          "nombre": "ARGENTINA"
        },
        "condicion": {
          "id": "Denunciante",
          "nombre": "Denunciante"
        },
        "tipoDocumento": {
          "id": "DNI",
          "nombre": "DNI"
        },
        "exhibeDocumento": {
          "id": 1,
          "nombre": "Sí"
        },
        "tieneEstudios": {
          "id": 1,
          "nombre": "Sí"
        }
      }
    },
    "afectacionPatrimonial": {
      "list": [
        {
          "arrId": "6ee9d327-f610-43ba-95ee-f69914d7c842",
          "doc": {
            "tipo": "credito",
            "fecha": "12/12/1231",
            "monto": "123123",
            "tipoMoneda": {
              "value": "2de2e161-ad03-11ef-9bf3-0242ac168989",
              "nombre": "Peso Argentino"
            },
            "NroTarjeta": "12341234123",
            "entidadBancaria": "123",
            "observaciones": "123123",
            "arrId": "6ee9d327-f610-43ba-95ee-f69914d7c842"
          },
          "type": "doc"
        },
        {
          "arrId": "6ee9d327-f610-43ba-95ee-f69914d7c579",
          "doc": {
            "name": "Nueva afectación",
            "newFormatEffect": true
          },
          "type": "empty"
        }
      ]
    },
    "idDependencia": "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    "idUser": "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
    "DependenciaID": "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    "ActuacionUsuarioDependencia": [
      {
        "ActuacionUsuarioDependenciaID": "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
        "Fechadesde": "2022-09-16 00:00:00",
        "ActuacionID": "cdaf7be3-35d0-11ed-9474-00ff2876ab1e",
        "UsuarioID": "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
        "DependenciaID": "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
        "RecienEnviada": "0",
        "NombreUsuario": "UserTesterE3",
        "Email": "cangaleonardo@gmail.com",
        "Apellido": "Test",
        "Nombre": "User",
        "Dni": "1111111"
      }
    ],
    "actuacionUsuarioDependenciaID": "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
    "dependenciaPolicial": "SUB COMISARIA  E3",
    "dependenciaDepartamento": "RAWSON",
    "dependenciaDomicilio": "20 de Junio y Mistral (Fte. Plaza)",
    "dependenciaID": "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    "denunciaID": "cdac0e23-35d0-11ed-9474-00ff2876ab1e",
    "tiposumarioID": "Unidades Fiscales de Investigacion anivi",
    "sumarioEstado": "En Curso",
    "sumarioEstadoID": "sin estado asignado",
    "actaInicio": "--- En la provincia de San Juan, SUB COMISARIA  E3 a los 09 días del mes de Diciembre del año Dos Mil Veinticinco, siendo las 14:04 horas, el Funcionario de Policía que suscribe, Jefe de esta sede legal y Secretario de Actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora precitada, comparece ante esta Instrucción la persona mencionada precedentemente a fin de poner en conocimiento la supuesta Comisión de un hecho de carácter delictivo, que da lugar a la intervención de esta Autoridad Policial, acto seguido y luego de ser impuesto del contenido del Art. 245° del Código Penal (falsa denuncia), a continuación, se le pregunta por sus nombres apellidos y demás circunstancias personales manifestó llamarse:   Pepe, Honguito, DNI N° 32133222, de nacionalidad ARGENTINA, estado civil Soltero/a, de 32 años de edad, Primaria, de profesion explorador, con domicilio en Neuquén, Argentina. 1887 \n . Con relación al hecho que viene a denunciar DECLARA: Que se presenta ante esta autoridad policial a fin de manifestar que Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar ufi- anivi. Lo que solicita es que se tomen las medidas legales de rigor. No siendo para más la presente acta la que leída y ratificada en todo su contenido se firma al pie por ante mí que lo CERTIFICA. --------",
    "PersonalFiscal": [
      {
        "PersonalfiscalID": "159d607f-ff05-11ec-bb82-0eb8b69eb347",
        "Denominacion": "Dr. Adrian Riveros",
        "Jerarquia": "Fiscal"
      },
      {
        "PersonalfiscalID": "b8d73615-ff06-11ec-bb82-0eb8b69eb347",
        "Denominacion": "Dr. Solera Alejandro",
        "Jerarquia": "Ayudante"
      }
    ],
    "preMoment": {
      "date": new Date("2025-12-09T17:06:57.013Z"),
      "date2": new Date("2025-12-09T17:06:57.013Z")
    }
  },

  //ACTUACIÓN "UFI DELITOS INFORMÁTICOS Y ESTAFAS POR OFICIO"
  "ufi-estafas-y-delitos-informaticos-oficio": {
  "preUbicacion": {
    "calle": "FALSA",
    "coordinates": {
      "lat": -31.541697941234222,
      "lng": -68.537934422493
    },
    "departamento": {
      "id": "7115dec8-ce2d-11e4-a042-0090f58f4f32",
      "nombre": "ALBARDON"
    },
    "numero": "123"
  },
  "denuncia": [
    {
      "name": "InputNestor"
    }
  ],
  "causaNumero": "123456",
  "modusOperandi": {
    "TipomodusoperandiID": "4d6928f6-a3c5-11ec-816d-16c2a030bb97",
    "Nombre": "EN BANDA"
  },
  "causaCaratula": {
    "TipocausacaratulaID": "fc2db6c2-85f7-11ed-8410-0242ac120003",
    "Nombre": "nuevo delito",
    "TipoCaratula": "Delito"
  },
  "ActuacionUfi": {
    "TipoufiID": "ufi34fb5-c013-11ec-8878-16c2a030bb97",
    "Fechainivig": "2022-07-06 13:22:00",
    "Numero": "3"
  },
  "prosecutor": {
    "PersonalfiscalID": "159d607f-ff05-11ec-bb82-0eb8b69eb347",
    "Denominacion": "Dr. Adrian Riveros",
    "Jerarquia": "Fiscal"
  },
  "assistant": {
    "PersonalfiscalID": "b8d73615-ff06-11ec-bb82-0eb8b69eb347",
    "Denominacion": "Dr. Solera Alejandro",
    "Jerarquia": "Ayudante"
  },
  "id": "ffdeb9d0-d518-11f0-b42e-0242ac140006",
  "deposition": "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar ufi- anivi",
  "formType": "ufi-estafas-y-delitos-informaticos-oficio",
  "dependencia": "SUB COMISARIA  E3",
  "Sitio": {
    "TipoSitioID": "tipo-sitio-id-0001"
  },
  "effectsType": "empty",
  "PersonalInterviniente": [
    {
      "nombre": "jefe gorgory",
      "jerarquia": {
        "id": "4",
        "nombre": "Sargento"
      },
      "dependencia": "Ptp Policial Tamberias Calingasta"
    }
  ],
  "textEditsCounter": {
    "Preform": 0,
    "Contravener": 0,
    "instructionDecree": 0
  },
  "acusados": {
    "list": [
      {
        "arrId": "0a53793a-9e75-45c7-9bd2-379c501822c7",
        "doc": {
          "instruccion": {
            "id": "no_sabe_leer_no_sabe_firmar",
            "nombre": "No sabe leer, no sabe firmar"
          },
          "email": "helloworld@gmail.com",
          "nacionalidad": {
            "id": 1,
            "nombre": "ARGENTINA"
          },
          "tipoDocumento": {
            "id": "DNI",
            "nombre": "DNI"
          },
          "condicion": {
            "id": "Acusado",
            "nombre": "Acusado"
          },
          "arrId": "0a53793a-9e75-45c7-9bd2-379c501822c7",
          "apellido": "Rodríguez",
          "nombre": "Bender Bending",
          "fechaNacimiento": "18/12/1994",
          "estadoCivil": {
            "id": "2",
            "nombre": "Casado/a"
          },
          "domicilio": "Planet Express",
          "apodo": "bender",
          "personaJuridica": false,
          "documento": "12312312",
          "sexo": {
            "id": "F",
            "nombre": "Femenino"
          },
          "exhibeDocumento": {
            "id": 1,
            "nombre": "Sí"
          },
          "edad": "12",
          "profesion": "123123",
          "tieneSeguro": false,
          "tieneEstudios": {
            "id": 1,
            "nombre": "Sí"
          },
          "observaciones": "123123",
          "cuil": "123123123"
        },
        "identikit": [
          {
            "answer": "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
            "question": "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
            "questionNumber": 1
          },
          {
            "answer": "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
            "question": "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
            "questionNumber": 2
          },
          {
            "answer": "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
            "question": "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
            "questionNumber": 3
          },
          {
            "answer": "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
            "question": "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
            "questionNumber": 4
          },
          {
            "answer": "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
            "question": "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
            "questionNumber": 5
          },
          {
            "answer": "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
            "question": "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
            "questionNumber": 6
          }
        ],
        "type": "doc",
        "conocido": true,
        "hasIdentikit": false,
        "emptyTitle": "Nuevo aprehendido",
        "filiacionDesconocida": false
      },
      {
        "arrId": "0ab72ea4-71cb-4d9e-9744-5bd17e6226b7",
        "doc": {
          "instruccion": {
            "id": "sabe_leer_sabe_firmar",
            "nombre": "Sabe leer y sabe firmar"
          },
          "email": "loremipsum@yahoo.com",
          "nacionalidad": {
            "id": 1,
            "nombre": "ARGENTINA"
          },
          "tipoDocumento": {
            "id": "DNI",
            "nombre": "DNI"
          },
          "condicion": {
            "id": "Aprehendido",
            "nombre": "Aprehendido"
          }
        },
        "identikit": [
          {
            "answer": "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
            "question": "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
            "questionNumber": 1
          },
          {
            "answer": "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
            "question": "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
            "questionNumber": 2
          },
          {
            "answer": "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
            "question": "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
            "questionNumber": 3
          },
          {
            "answer": "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
            "question": "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
            "questionNumber": 4
          },
          {
            "answer": "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
            "question": "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
            "questionNumber": 5
          },
          {
            "answer": "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
            "question": "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
            "questionNumber": 6
          }
        ],
        "identikitQuestion": 1,
        "type": "empty",
        "conocido": true,
        "hasIdentikit": false,
        "emptyTitle": "Nuevo vinculado"
      }
    ],
    "emptyDoc": {
      "instruccion": {
        "id": "sabe_leer_sabe_firmar",
        "nombre": "Sabe leer y sabe firmar"
      },
      "email": "loremipsum@yahoo.com",
      "nacionalidad": {
        "id": 1,
        "nombre": "ARGENTINA"
      },
      "tipoDocumento": {
        "id": "DNI",
        "nombre": "DNI"
      },
      "condicion": {
        "id": "Aprehendido",
        "nombre": "Aprehendido"
      }
    }
  },
  "robados": {
    "list": [
      {
        "arrId": "7192952f-8a6b-4f89-a824-dc18b6713b43",
        "doc": {
          "tipoEfecto": {
            "id": "Recuperado",
            "nombre": "Recuperado"
          },
          "arrId": "7192952f-8a6b-4f89-a824-dc18b6713b43",
          "CategoriaID": "1",
          "SubcategoriaID": "2d532f6b-b685-11ec-8878-16c2a030bb97",
          "TipoID": "8fd03587-dfb4-11ed-9f23-0242ac120004",
          "MarcaID": "06344cd6-cc77-11ec-acbc-16c2a030bb97",
          "ModeloID": "150cbaa4-c24f-11ec-8878-16c2a030bb97",
          "Anio": "2023",
          "Chasis": "156",
          "NumeroMotor": "1589798",
          "Dominio": "asd123",
          "NumeroSerie": "2235",
          "Imei": "159489159",
          "Abonado": "365",
          "Color": "Gris"
        },
        "type": "doc",
        "conocido": true,
        "hasIdentikit": false
      },
      {
        "arrId": "6c445767-6a60-4617-900f-dd776bfb1fee",
        "doc": {
          "newFormatEffect": true,
          "tipoEfecto": {
            "id": "Secuestrado",
            "nombre": "Secuestrado"
          }
        },
        "type": "empty",
        "conocido": true,
        "hasIdentikit": false
      }
    ]
  },
  "denunciante": {
    "list": [
      {
        "arrId": "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
        "doc": {
          "personaJuridica": false,
          "condicion": {
            "id": "Damnificado",
            "nombre": "Damnificado"
          },
          "documento": "1231231",
          "tipoDocumento": {
            "id": "DNI",
            "nombre": "DNI"
          },
          "sexo": {
            "id": "M",
            "nombre": "Masculino"
          },
          "exhibeDocumento": {
            "id": 1,
            "nombre": "Sí"
          },
          "instruccion": {
            "id": "sabe_leer_sabe_firmar",
            "nombre": "Sabe leer y sabe firmar"
          },
          "apellido": "Bravo",
          "nombre": "Johnny",
          "nacionalidad": {
            "id": 1,
            "nombre": "ARGENTINA"
          },
          "fechaNacimiento": "18/07/1993",
          "edad": "12",
          "estadoCivil": {
            "id": "1",
            "nombre": "Soltero/a"
          },
          "telefono": "123",
          "profesion": "123123",
          "domicilio": "Neuquén, Argentina. 1887",
          "email": "helloworld@gmail.com",
          "tieneSeguro": false,
          "tieneEstudios": {
            "id": 1,
            "nombre": "Sí"
          },
          "observaciones": "123123",
          "cuil": "123123123",
          "arrId": "9f9be280-0ce1-4cc4-ab8d-49bab143ed05"
        },
        "type": "doc",
        "sipeSearch": false,
        "emptyTitle": "Nueva víctima"
      },
      {
        "arrId": "439c3cf6-8429-4cc3-8184-80911162ffa7",
        "doc": {
          "instruccion": {
            "id": "sabe_leer_sabe_firmar",
            "nombre": "Sabe leer y sabe firmar"
          },
          "email": "helloworld@gmail.com",
          "nacionalidad": {
            "id": 1,
            "nombre": "ARGENTINA"
          },
          "condicion": {
            "id": "victima",
            "nombre": "Víctima"
          },
          "tipoDocumento": {
            "id": "DNI",
            "nombre": "DNI"
          }
        },
        "type": "empty",
        "ordenPublico": false,
        "emptyTitle": "Nuevo afectado"
      }
    ],
    "emptyDoc": {
      "instruccion": {
        "id": "sabe_leer_sabe_firmar",
        "nombre": "Sabe leer y sabe firmar"
      },
      "nacionalidad": {
        "id": 1,
        "nombre": "ARGENTINA"
      },
      "condicion": {
        "id": "Denunciante",
        "nombre": "Denunciante"
      },
      "tipoDocumento": {
        "id": "DNI",
        "nombre": "DNI"
      },
      "exhibeDocumento": {
        "id": 1,
        "nombre": "Sí"
      },
      "tieneEstudios": {
        "id": 1,
        "nombre": "Sí"
      }
    }
  },
  "afectacionPatrimonial": {
    "list": [
      {
        "arrId": "6ee9d327-f610-43ba-95ee-f69914d7c842",
        "doc": {
          "tipo": "credito",
          "fecha": "12/12/1212",
          "monto": "123",
          "tipoMoneda": {
            "value": "2de2e161-ad03-11ef-9bf3-0242ac168989",
            "nombre": "Peso Argentino"
          },
          "NroTarjeta": "123123123",
          "entidadBancaria": "123",
          "observaciones": "123123",
          "arrId": "6ee9d327-f610-43ba-95ee-f69914d7c842"
        },
        "type": "doc"
      },
      {
        "arrId": "6ee9d327-f610-43ba-95ee-f69914d7c579",
        "doc": {
          "name": "Nueva afectación",
          "newFormatEffect": true
        },
        "type": "empty"
      }
    ]
  },
  "idDependencia": "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
  "idUser": "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
  "DependenciaID": "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
  "ActuacionUsuarioDependencia": [
    {
      "ActuacionUsuarioDependenciaID": "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
      "Fechadesde": "2022-09-16 00:00:00",
      "ActuacionID": "cdaf7be3-35d0-11ed-9474-00ff2876ab1e",
      "UsuarioID": "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
      "DependenciaID": "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
      "RecienEnviada": "0",
      "NombreUsuario": "UserTesterE3",
      "Email": "cangaleonardo@gmail.com",
      "Apellido": "Test",
      "Nombre": "User",
      "Dni": "1111111"
    }
  ],
  "actuacionUsuarioDependenciaID": "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
  "dependenciaPolicial": "SUB COMISARIA  E3",
  "dependenciaDepartamento": "RAWSON",
  "dependenciaDomicilio": "20 de Junio y Mistral (Fte. Plaza)",
  "dependenciaID": "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
  "denunciaID": "cdac0e23-35d0-11ed-9474-00ff2876ab1e",
  "tiposumarioID": "Unidades Fiscales de Investigacion anivi",
  "sumarioEstado": "En Curso",
  "sumarioEstadoID": "sin estado asignado",
  "actaInicio": "--- En la provincia de San Juan, Departamento RAWSON, sede de SUB COMISARIA  E3, a los 09 días del mes de Diciembre del año Dos Mil Veinticinco, siendo las 12:30 horas; el funcionario de Policía que suscribe y Secretario de actuaciones que refrenda, a los fines legales HACE CONSTAR: Que en la fecha y hora indicada precedentemente se toma conocimiento por parte del   Sargento jefe gorgory adscripto/s al numerario de Ptp Policial Tamberias Calingasta Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar ufi- anivi. ; en virtud de ello la instrucción DISPONE Iniciar el Legajo de investigación que corresponda. Designar como secretario de las mismas al funcionario de Policía al pie firmante. Dar inmediata intervención a la U.F.I. N° 3  mediante la remisión del Parte Preventivo. Recibir a  Rodríguez, Bender Bending, DNI N° 12312312, Apodado como: bender, de nacionalidad ARGENTINA, estado civil Casado/a, de 30 años de edad, No sabe leer, no sabe firmar, de profesion 123123, con domicilio en Planet Expressy el secuestro de un/una o varios/as cuatri. Designar al Medico Legista de la Policía, a fin que examine al aprehendido. Requerir a través de cualquier medio idóneo la Plantilla Prontuarial actualizada del aprehendido. Llevar a cabo toda otra medida de carácter legal que se estime de interés.CERTIFICO.-",
  "PersonalFiscal": [
    {
      "PersonalfiscalID": "159d607f-ff05-11ec-bb82-0eb8b69eb347",
      "Denominacion": "Dr. Adrian Riveros",
      "Jerarquia": "Fiscal"
    },
    {
      "PersonalfiscalID": "b8d73615-ff06-11ec-bb82-0eb8b69eb347",
      "Denominacion": "Dr. Solera Alejandro",
      "Jerarquia": "Ayudante"
    }
  ],
  "preMoment": {
    "date": new Date("2025-12-09T16:06:20.607Z"),
    "date2": new Date("2025-12-09T16:06:20.607Z")
  }
},

  //ACTUACIÓN "UFI GENÉRICOS POR DENUNCIA"
  "ufi-generica": {
    denunciantesBD: [],
    ubicacion: "",
    preUbicacion: {
      calle: "FALSA",
      numero: "123",
      coordinates: { lat: -38.541697941234222, lng: -68.537934422493 },
    },
    moment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    preMoment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    estadoCivil: {},
    residencia: {},
    denuncia: [{ name: "InputNestor", value: "" }],
    fechaDenuncia: new Date(),
    fechaCertificadoDenuncia: null,
    denunciaText: "",
    causaNumero: "123456",
    modusOperandi: {
      TipomodusoperandiID: "4d6928f6-a3c5-11ec-816d-16c2a030bb97",
      Descripcion: null,
      Nombre: "EN BANDA",
    },
    causaCaratula: {
      TipocausacaratulaID: "fc2db6c2-85f7-11ed-8410-0242ac120003",
      Descripcion: null,
      Nombre: "nuevo delito",
      TipoCaratula: "Delito",
    },
    listaArticulos: [],
    causaJuzgado: null,
    ActuacionUfi: {
      TipoufiID: "ufi34fb5-c013-11ec-8878-16c2a030bb97",
      Fechainivig: "2022-07-06 13:22:00",
      Fechafinvig: null,
      Numero: "3",
    },
    Sitio: { TipoSitioID: "tipo-sitio-id-0001" },
    prosecutor: {
      PersonalfiscalID: "159d607f-ff05-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Adrian Riveros",
      Jerarquia: "Fiscal",
    },
    assistant: {
      PersonalfiscalID: "b8d73615-ff06-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Solera Alejandro",
      Jerarquia: "Ayudante",
    },
    id: null,
    saveStatus: "new",
    timer: false,
    isSaving: false,
    type: null,
    deposition:
      "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar ufi- anivi",
    formType: "ufi-generica",
    dependencia: "SUB COMISARIA  E3",
    PersonalInterviniente: [
      {
        nombre: "jefe gorgory",
        jerarquia: { id: "4", nombre: "Sargento" },
        dependencia: "Ptp Policial Tamberias Calingasta",
      },
    ],
    textEditsCounter: {
      Preform: 0,
      Contravener: 0,
      Postform: "",
      LegalData: "",
      instructionDecree: 0,
    },
    textEstaticos: {
      Preform: "",
      Contravener: "",
      Postform: "",
      LegalData: "",
      instructionDecree: "",
    },
    spinnerOrderTablePrintFrom: false,
    acusados: {
      list: [
        {
          arrId: "6ee9d327-f610-43ba-95ee-f67714d7c342",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Aprehendido", nombre: "Aprehendido" },
            email: "loremipsum@yahoo.com",
            apellido: "mojo",
            arrId: "6ee9d327-f610-43ba-95ee-f67714d7c342",
            nombre: " jojo",
            estadoCivil: { id: "4", nombre: "Divorciado/a" },
            apodo: "mojo jojo",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          sipeSearch: false,
          emptyTitle: "Nuevo aprehendido",
        },
        {
          arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Acusado", nombre: "Acusado" },
            arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
            apellido: "Rodríguez",
            nombre: "Bender Bending",
            fechaNacimiento: "18/12/1994",
            estadoCivil: { id: "2", nombre: "Casado/a" },
            domicilio: "Planet Express",
            apodo: "bender",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo aprehendido",
        },
        {
          arrId: "0ab72ea4-71cb-4d9e-9744-5bd17e6226b7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Aprehendido", nombre: "Aprehendido" },
            email: "loremipsum@yahoo.com",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "empty",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo aprehendido",
        },
      ],
      emptyDoc: {
        instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
        email: "helloworld@gmail.com",
        nacionalidad: { id: 1, nombre: "ARGENTINA" },
        tipoDocumento: { id: "DNI", nombre: "DNI" },
        condicion: { id: "Aprehendido", nombre: "Aprehendido" },
        email: "loremipsum@yahoo.com",
      },
    },
    robados: {
      list: [
        {
          arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
          doc: {
            tipoEfecto: { id: "Recuperado", nombre: "Recuperado" },
            arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
            CategoriaID: "1",
            SubcategoriaID: "2d532f6b-b685-11ec-8878-16c2a030bb97",
            TipoID: "8fd03587-dfb4-11ed-9f23-0242ac120004",
            MarcaID: "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            ModeloID: "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            Anio: "2023",
            Chasis: "156",
            NumeroMotor: "1589798",
            Dominio: "asd123",
            NumeroSerie: "2235",
            Imei: "159489159",
            Abonado: "365",
            Color: "Gris",
          },
          type: "doc",
          conocido: true,
          hasIdentikit: false,
        },
        {
          arrId: "6c445767-6a60-4617-900f-dd776bfb1fee",
          doc: { newFormatEffect: true, tipoEfecto: { id: "Secuestrado", nombre: "Secuestrado" } },
          type: "empty",
          conocido: true,
          hasIdentikit: false,
        },
      ],
    },
    denunciante: {
      list: [
        {
          arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "victima", nombre: "Víctima" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
            documento: "123",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Johnny",
            apellido: "Bravo",
            fechaNacimiento: "18/07/1993",
            domicilio: "Neuquén, Argentina. 1887",
            telefono: "123",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nueva víctima",
        },
        {
          arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "victima", nombre: "Víctima" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nueva víctima",
        },
      ],
    },
    diligencia: [],
    DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    ActuacionUsuarioDependencia: [
      {
        ActuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
        Fechadesde: "2022-09-16 00:00:00",
        Fechahasta: null,
        ActuacionID: "cdaf7be3-35d0-11ed-9474-00ff2876ab1e",
        UsuarioID: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
        DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
        Numeroextracto: null,
        RecienEnviada: "0",
        NombreUsuario: "UserTesterE3",
        Email: "cangaleonardo@gmail.com",
        Apellido: "Test",
        Nombre: "User",
        Dni: "1111111",
      },
    ],
    actuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
    dependenciaPolicial: "SUB COMISARIA  E3",
    dependenciaDepartamento: "RAWSON",
    dependenciaDomicilio: "20 de Junio y Mistral (Fte. Plaza)",
    dependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    denunciaID: "cdac0e23-35d0-11ed-9474-00ff2876ab1e",
    tiposumarioID: "Unidades Fiscales de Investigacion anivi",
    sumarioEstado: "sin estado asignado",
    sumarioEstadoID: "sin estado asignado",
    idDependencia: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    idUser: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
  },

  //ACTUACIÓN "UFI GENÉRICOS POR OFICIO"
  "ufi-generica-oficio": {
    denunciantesBD: [],
    ubicacion: "",
    preUbicacion: {
      calle: "FALSA",
      numero: "123",
      coordinates: { lat: -39.541697941234222, lng: -68.537934422493 },
    },
    moment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    preMoment: {
      date: new Date("Thu Aug 04 2022 13:55:07 GMT-0300"),
      date2: new Date("Sun Aug 07 2022 17:14:12 GMT-0300"),
    },
    estadoCivil: {},
    residencia: {},
    denuncia: [{ name: "InputNestor", value: "" }],
    fechaDenuncia: new Date(),
    fechaCertificadoDenuncia: null,
    denunciaText: "",
    causaNumero: "123456",
    modusOperandi: {
      TipomodusoperandiID: "4d6928f6-a3c5-11ec-816d-16c2a030bb97",
      Descripcion: null,
      Nombre: "EN BANDA",
    },
    causaCaratula: {
      TipocausacaratulaID: "fc2db6c2-85f7-11ed-8410-0242ac120003",
      Descripcion: null,
      Nombre: "nuevo delito",
      TipoCaratula: "Delito",
    },
    listaArticulos: [],
    causaJuzgado: null,
    ActuacionUfi: {
      TipoufiID: "ufi34fb5-c013-11ec-8878-16c2a030bb97",
      Fechainivig: "2022-07-06 13:22:00",
      Fechafinvig: null,
      Numero: "3",
    },
    Sitio: { TipoSitioID: "tipo-sitio-id-0001" },
    prosecutor: {
      PersonalfiscalID: "159d607f-ff05-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Adrian Riveros",
      Jerarquia: "Fiscal",
    },
    assistant: {
      PersonalfiscalID: "b8d73615-ff06-11ec-bb82-0eb8b69eb347",
      Denominacion: "Dr. Solera Alejandro",
      Jerarquia: "Ayudante",
    },
    id: null,
    saveStatus: "new",
    timer: false,
    isSaving: false,
    type: null,
    deposition:
      "Lorem ipsum odor amet, consectetuer adipiscing elit. Eleifend nunc nisl tristique congue a. Ultricies molestie dapibus himenaeos litora aenean laoreet placerat senectus. Dapibus fames in augue pellentesque himenaeos aliquet efficitur pharetra elit. Facilisi sociosqu facilisis phasellus quis gravida fringilla semper morbi. Ornare gravida molestie magnis montes duis conubia penatibus. Nisi donec et hac finibus auctor non ipsum suscipit. Efficitur facilisi euismod proin, varius aliquam blandit. Convallis dignissim id dictumst odio dis adipiscing. Amet nisl mi sociosqu porta et ipsum dictumst. FINEsto es para probar ufi- anivi",
    formType: "ufi-generica-oficio",
    dependencia: "SUB COMISARIA  E3",
    PersonalInterviniente: [
      {
        nombre: "jefe gorgory",
        jerarquia: { id: "4", nombre: "Sargento" },
        dependencia: "Ptp Policial Tamberias Calingasta",
      },
    ],
    textEditsCounter: {
      Preform: 0,
      Contravener: 0,
      Postform: "",
      LegalData: "",
      instructionDecree: 0,
    },
    textEstaticos: {
      Preform: "",
      Contravener: "",
      Postform: "",
      LegalData: "",
      instructionDecree: "",
    },
    spinnerOrderTablePrintFrom: false,
    acusados: {
      list: [
        {
          arrId: "6ee9d327-f610-43ba-95ee-f67714d7c342",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Aprehendido", nombre: "Aprehendido" },
            email: "loremipsum@yahoo.com",
            apellido: "mojo",
            arrId: "6ee9d327-f610-43ba-95ee-f67714d7c342",
            nombre: " jojo",
            estadoCivil: { id: "4", nombre: "Divorciado/a" },
            apodo: "mojo jojo",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          sipeSearch: false,
          emptyTitle: "Nuevo aprehendido",
        },
        {
          arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Acusado", nombre: "Acusado" },
            arrId: "0a53793a-9e75-45c7-9bd2-379c501822c7",
            apellido: "Rodríguez",
            nombre: "Bender Bending",
            fechaNacimiento: "18/12/1994",
            estadoCivil: { id: "2", nombre: "Casado/a" },
            domicilio: "Planet Express",
            apodo: "bender",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "doc",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo aprehendido",
        },
        {
          arrId: "0ab72ea4-71cb-4d9e-9744-5bd17e6226b7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            condicion: { id: "Aprehendido", nombre: "Aprehendido" },
            email: "loremipsum@yahoo.com",
          },
          identikit: [
            {
              answer: "Respuesta P.1: Vestía un casco ciclista formal de color amarillo, ",
              question: "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
              questionNumber: 1,
            },
            {
              answer: "Respuesta P.2: Tenía cabello rapado rizado de color negro ",
              question: "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
              questionNumber: 2,
            },
            {
              answer:
                "Respuesta P.3: Una persona de sexo femenino de estatura mediana,  promedio, estatura aproximada de 1600 cm ",
              question: "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
              questionNumber: 3,
            },
            {
              answer: "Respuesta P.4: Era un adulto de 21 años aproximadamente ",
              question: "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
              questionNumber: 4,
            },
            {
              answer: "Respuesta P.5: Tatuado  un texto  en el cuello en la zona frontal, ",
              question: "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
              questionNumber: 5,
            },
            {
              answer:
                "Respuesta P.6: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
              question: "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
              questionNumber: 6,
            },
          ],
          descriptionOffender: [],
          identikitQuestion: 1,
          type: "empty",
          conocido: true,
          hasIdentikit: false,
          emptyTitle: "Nuevo aprehendido",
        },
      ],
      emptyDoc: {
        instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
        email: "helloworld@gmail.com",
        nacionalidad: { id: 1, nombre: "ARGENTINA" },
        tipoDocumento: { id: "DNI", nombre: "DNI" },
        condicion: { id: "Aprehendido", nombre: "Aprehendido" },
        email: "loremipsum@yahoo.com",
      },
    },
    robados: {
      list: [
        {
          arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
          doc: {
            tipoEfecto: { id: "Recuperado", nombre: "Recuperado" },
            arrId: "7192952f-8a6b-4f89-a824-dc18b6713b43",
            CategoriaID: "1",
            SubcategoriaID: "2d532f6b-b685-11ec-8878-16c2a030bb97",
            TipoID: "8fd03587-dfb4-11ed-9f23-0242ac120004",
            MarcaID: "06344cd6-cc77-11ec-acbc-16c2a030bb97",
            ModeloID: "150cbaa4-c24f-11ec-8878-16c2a030bb97",
            Anio: "2023",
            Chasis: "156",
            NumeroMotor: "1589798",
            Dominio: "asd123",
            NumeroSerie: "2235",
            Imei: "159489159",
            Abonado: "365",
            Color: "Gris",
          },
          type: "doc",
          conocido: true,
          hasIdentikit: false,
        },
        {
          arrId: "6c445767-6a60-4617-900f-dd776bfb1fee",
          doc: { newFormatEffect: true, tipoEfecto: { id: "Secuestrado", nombre: "Secuestrado" } },
          type: "empty",
          conocido: true,
          hasIdentikit: false,
        },
      ],
    },
    denunciante: {
      list: [
        {
          arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "victima", nombre: "Víctima" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
            estadoCivil: { id: "1", nombre: "Soltero/a" },
            arrId: "9f9be280-0ce1-4cc4-ab8d-49bab143ed05",
            documento: "123",
            sexo: { id: "M", nombre: "Masculino" },
            nombre: "Johnny",
            apellido: "Bravo",
            fechaNacimiento: "18/07/1993",
            domicilio: "Neuquén, Argentina. 1887",
            telefono: "123",
          },
          type: "doc",
          sipeSearch: false,
          emptyTitle: "Nueva víctima",
        },
        {
          arrId: "439c3cf6-8429-4cc3-8184-80911162ffa7",
          doc: {
            instruccion: { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
            email: "helloworld@gmail.com",
            nacionalidad: { id: 1, nombre: "ARGENTINA" },
            condicion: { id: "victima", nombre: "Víctima" },
            tipoDocumento: { id: "DNI", nombre: "DNI" },
          },
          type: "empty",
          ordenPublico: false,
          emptyTitle: "Nueva víctima",
        },
      ],
    },
    diligencia: [],
    DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    ActuacionUsuarioDependencia: [
      {
        ActuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
        Fechadesde: "2022-09-16 00:00:00",
        Fechahasta: null,
        ActuacionID: "cdaf7be3-35d0-11ed-9474-00ff2876ab1e",
        UsuarioID: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
        DependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
        Numeroextracto: null,
        RecienEnviada: "0",
        NombreUsuario: "UserTesterE3",
        Email: "cangaleonardo@gmail.com",
        Apellido: "Test",
        Nombre: "User",
        Dni: "1111111",
      },
    ],
    actuacionUsuarioDependenciaID: "cdb5914c-35d0-11ed-9474-00ff2876ab1e",
    dependenciaPolicial: "SUB COMISARIA  E3",
    dependenciaDepartamento: "RAWSON",
    dependenciaDomicilio: "20 de Junio y Mistral (Fte. Plaza)",
    dependenciaID: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    denunciaID: "cdac0e23-35d0-11ed-9474-00ff2876ab1e",
    tiposumarioID: "Unidades Fiscales de Investigacion anivi",
    sumarioEstado: "sin estado asignado",
    sumarioEstadoID: "sin estado asignado",
    idDependencia: "96ba4bf0-2c54-11ec-b414-16c2a030bb97",
    idUser: "07ffa5ba-9ee4-11ec-816d-16c2a030bb97",
  },
};
